import "core-js/modules/es6.promise";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.math.log2";
import "core-js/modules/es6.math.log10";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.typed.data-view";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.date.to-json";
import "core-js/modules/es7.string.trim-left";
import "core-js/modules/es7.string.trim-right";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.array.reduce-right";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es7.string.pad-end";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es7.array.flat-map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.last-index-of";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var t,
    e,
    n,
    r,
    i,
    _o2 = function o(t, e) {
  return (_o2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, e) {
    t.__proto__ = e;
  } || function (t, e) {
    for (var n in e) {
      e.hasOwnProperty(n) && (t[n] = e[n]);
    }
  })(t, e);
};

function a(t, e) {
  function n() {
    this.constructor = t;
  }

  _o2(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
}

!function (t) {
  t.GRAPHICS_DOCUMENT = "graphics-document", t.GRAPHICS_OBJECT = "graphics-object", t.GRAPHICS_SYMBOL = "graphics-symbol", t.GROUP = "group";
}(t || (t = {})), function (t) {
  t.SLICE_MOUSEOVER = "pie-slice-mouseover", t.SLICE_MOUSEMOVE = "pie-slice-mousemove", t.SLICE_CLICK = "pie-slice-click", t.SLICE_MOUSEOUT = "pie-slice-mouseout";
}(e || (e = {})), function (t) {
  t.BAR_MOUSEOVER = "bar-mouseover", t.BAR_MOUSEMOVE = "bar-mousemove", t.BAR_CLICK = "bar-click", t.BAR_MOUSEOUT = "bar-mouseout";
}(n || (n = {})), function (t) {
  t.SCATTER_MOUSEOVER = "scatter-mouseover", t.SCATTER_MOUSEMOVE = "scatter-mousemove", t.SCATTER_CLICK = "scatter-click", t.SCATTER_MOUSEOUT = "scatter-mouseout";
}(r || (r = {})), function (t) {
  t.POINT_MOUSEOVER = "scatter-mouseover", t.POINT_MOUSEMOVE = "scatter-mousemove", t.POINT_CLICK = "scatter-click", t.POINT_MOUSEOUT = "scatter-mouseout";
}(i || (i = {}));

var s,
    u,
    c,
    l,
    f,
    h,
    p,
    d,
    v,
    g,
    y,
    _,
    m = Object.freeze({
  __proto__: null,

  get Pie() {
    return e;
  },

  get Bar() {
    return n;
  },

  get Scatter() {
    return r;
  },

  get Line() {
    return i;
  }

});

!function (t) {
  t.DEFAULT = "default", t.G100 = "g100", t.G90 = "g90", t.G10 = "g10";
}(s || (s = {})), function (t) {
  t.LEFT = "left", t.RIGHT = "right", t.TOP = "top", t.BOTTOM = "bottom";
}(u || (u = {})), function (t) {
  t.VERTICAL = "vertical", t.HORIZONTAL = "horizontal";
}(c || (c = {})), function (t) {
  t.PRIMARY = "primary", t.SECONDARY = "secondary";
}(l || (l = {})), function (t) {
  t.TIME = "time", t.LINEAR = "linear", t.LOG = "log", t.LABELS = "labels";
}(f || (f = {})), function (t) {
  t.MOUSE = "mouse", t.TOP = "top", t.BOTTOM = "bottom";
}(h || (h = {})), function (t) {
  t.DATAPOINT = "datapoint", t.GRIDLINE = "gridline", t.TITLE = "title";
}(p || (p = {})), function (t) {
  t.RIGHT = "right", t.LEFT = "left", t.TOP = "top", t.BOTTOM = "bottom";
}(d || (d = {})), function (t) {
  t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical";
}(v || (v = {})), function (t) {
  t.ROW = "row", t.COLUMN = "column", t.ROW_REVERSE = "row-reverse", t.COLUMN_REVERSE = "column-reverse";
}(g || (g = {})), function (t) {
  t.FIXED = "fixed", t.PREFERRED = "preferred", t.STRETCH = "stretch";
}(y || (y = {})), function (t) {
  t.LEFT = "left", t.RIGHT = "right";
}(_ || (_ = {}));
var b = Object.freeze({
  __proto__: null,

  get Roles() {
    return t;
  },

  Events: m,

  get ChartTheme() {
    return s;
  },

  get AxisPositions() {
    return u;
  },

  get CartesianOrientations() {
    return c;
  },

  get AxisTypes() {
    return l;
  },

  get ScaleTypes() {
    return f;
  },

  get TooltipPosition() {
    return h;
  },

  get TooltipTypes() {
    return p;
  },

  get LegendPositions() {
    return d;
  },

  get LegendOrientations() {
    return v;
  },

  get LayoutDirection() {
    return g;
  },

  get LayoutGrowth() {
    return y;
  },

  get CalloutDirections() {
    return _;
  }

}),
    x = "object" == typeof global && global && global.Object === Object && global,
    w = "object" == typeof self && self && self.Object === Object && self,
    O = x || w || Function("return this")(),
    E = O.Symbol,
    T = Object.prototype,
    S = T.hasOwnProperty,
    M = T.toString,
    A = E ? E.toStringTag : void 0;
var k = Object.prototype.toString;
var L = E ? E.toStringTag : void 0;

function C(t) {
  return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : L && L in Object(t) ? function (t) {
    var e = S.call(t, A),
        n = t[A];

    try {
      t[A] = void 0;
      var r = !0;
    } catch (t) {}

    var i = M.call(t);
    return r && (e ? t[A] = n : delete t[A]), i;
  }(t) : function (t) {
    return k.call(t);
  }(t);
}

function R(t) {
  return null != t && "object" == typeof t;
}

function j(t) {
  return "symbol" == typeof t || R(t) && "[object Symbol]" == C(t);
}

function P(t) {
  return "number" == typeof t ? t : j(t) ? NaN : +t;
}

function D(t, e) {
  for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r;) {
    i[n] = e(t[n], n, t);
  }

  return i;
}

var I = Array.isArray,
    N = E ? E.prototype : void 0,
    B = N ? N.toString : void 0;

function F(t) {
  if ("string" == typeof t) return t;
  if (I(t)) return D(t, F) + "";
  if (j(t)) return B ? B.call(t) : "";
  var e = t + "";
  return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
}

function z(t, e) {
  return function (n, r) {
    var i;
    if (void 0 === n && void 0 === r) return e;

    if (void 0 !== n && (i = n), void 0 !== r) {
      if (void 0 === i) return r;
      "string" == typeof n || "string" == typeof r ? (n = F(n), r = F(r)) : (n = P(n), r = P(r)), i = t(n, r);
    }

    return i;
  };
}

var V = z(function (t, e) {
  return t + e;
}, 0);

function G(t) {
  var e = typeof t;
  return null != t && ("object" == e || "function" == e);
}

var U = /^\s+|\s+$/g,
    H = /^[-+]0x[0-9a-f]+$/i,
    W = /^0b[01]+$/i,
    q = /^0o[0-7]+$/i,
    Y = parseInt;

function X(t) {
  if ("number" == typeof t) return t;
  if (j(t)) return NaN;

  if (G(t)) {
    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
    t = G(e) ? e + "" : e;
  }

  if ("string" != typeof t) return 0 === t ? t : +t;
  t = t.replace(U, "");
  var n = W.test(t);
  return n || q.test(t) ? Y(t.slice(2), n ? 2 : 8) : H.test(t) ? NaN : +t;
}

function $(t) {
  return t ? (t = X(t)) === 1 / 0 || t === -1 / 0 ? 17976931348623157e292 * (t < 0 ? -1 : 1) : t == t ? t : 0 : 0 === t ? t : 0;
}

function Z(t) {
  var e = $(t),
      n = e % 1;
  return e == e ? n ? e - n : e : 0;
}

function K(t) {
  return t;
}

function J(t) {
  if (!G(t)) return !1;
  var e = C(t);
  return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
}

var Q,
    tt = O["__core-js_shared__"],
    et = (Q = /[^.]+$/.exec(tt && tt.keys && tt.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Q : "";
var nt = Function.prototype.toString;

function rt(t) {
  if (null != t) {
    try {
      return nt.call(t);
    } catch (t) {}

    try {
      return t + "";
    } catch (t) {}
  }

  return "";
}

var it = /^\[object .+?Constructor\]$/,
    ot = Function.prototype,
    at = Object.prototype,
    st = ot.toString,
    ut = at.hasOwnProperty,
    ct = RegExp("^" + st.call(ut).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

function lt(t) {
  return !(!G(t) || function (t) {
    return !!et && et in t;
  }(t)) && (J(t) ? ct : it).test(rt(t));
}

function ft(t, e) {
  var n = function (t, e) {
    return null == t ? void 0 : t[e];
  }(t, e);

  return lt(n) ? n : void 0;
}

var ht = ft(O, "WeakMap"),
    pt = ht && new ht(),
    dt = pt ? function (t, e) {
  return pt.set(t, e), t;
} : K,
    vt = Object.create,
    gt = function () {
  function t() {}

  return function (e) {
    if (!G(e)) return {};
    if (vt) return vt(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();

function yt(t) {
  return function () {
    var e = arguments;

    switch (e.length) {
      case 0:
        return new t();

      case 1:
        return new t(e[0]);

      case 2:
        return new t(e[0], e[1]);

      case 3:
        return new t(e[0], e[1], e[2]);

      case 4:
        return new t(e[0], e[1], e[2], e[3]);

      case 5:
        return new t(e[0], e[1], e[2], e[3], e[4]);

      case 6:
        return new t(e[0], e[1], e[2], e[3], e[4], e[5]);

      case 7:
        return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
    }

    var n = gt(t.prototype),
        r = t.apply(n, e);
    return G(r) ? r : n;
  };
}

function _t(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);

    case 1:
      return t.call(e, n[0]);

    case 2:
      return t.call(e, n[0], n[1]);

    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }

  return t.apply(e, n);
}

var mt = Math.max;

function bt(t, e, n, r) {
  for (var i = -1, o = t.length, a = n.length, s = -1, u = e.length, c = mt(o - a, 0), l = Array(u + c), f = !r; ++s < u;) {
    l[s] = e[s];
  }

  for (; ++i < a;) {
    (f || i < o) && (l[n[i]] = t[i]);
  }

  for (; c--;) {
    l[s++] = t[i++];
  }

  return l;
}

var xt = Math.max;

function wt(t, e, n, r) {
  for (var i = -1, o = t.length, a = -1, s = n.length, u = -1, c = e.length, l = xt(o - s, 0), f = Array(l + c), h = !r; ++i < l;) {
    f[i] = t[i];
  }

  for (var p = i; ++u < c;) {
    f[p + u] = e[u];
  }

  for (; ++a < s;) {
    (h || i < o) && (f[p + n[a]] = t[i++]);
  }

  return f;
}

function Ot(t, e) {
  for (var n = t.length, r = 0; n--;) {
    t[n] === e && ++r;
  }

  return r;
}

function Et() {}

function Tt(t) {
  this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
}

function St() {}

Tt.prototype = gt(Et.prototype), Tt.prototype.constructor = Tt;
var Mt = pt ? function (t) {
  return pt.get(t);
} : St,
    At = {},
    kt = Object.prototype.hasOwnProperty;

function Lt(t) {
  for (var e = t.name + "", n = At[e], r = kt.call(At, e) ? n.length : 0; r--;) {
    var i = n[r],
        o = i.func;
    if (null == o || o == t) return i.name;
  }

  return e;
}

function Ct(t, e) {
  this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = void 0;
}

function Rt(t, e) {
  var n = -1,
      r = t.length;

  for (e || (e = Array(r)); ++n < r;) {
    e[n] = t[n];
  }

  return e;
}

function jt(t) {
  if (t instanceof Tt) return t.clone();
  var e = new Ct(t.__wrapped__, t.__chain__);
  return e.__actions__ = Rt(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
}

Ct.prototype = gt(Et.prototype), Ct.prototype.constructor = Ct;
var Pt = Object.prototype.hasOwnProperty;

function Dt(t) {
  if (R(t) && !I(t) && !(t instanceof Tt)) {
    if (t instanceof Ct) return t;
    if (Pt.call(t, "__wrapped__")) return jt(t);
  }

  return new Ct(t);
}

function It(t) {
  var e = Lt(t),
      n = Dt[e];
  if ("function" != typeof n || !(e in Tt.prototype)) return !1;
  if (t === n) return !0;
  var r = Mt(n);
  return !!r && t === r[0];
}

Dt.prototype = Et.prototype, Dt.prototype.constructor = Dt;
var Nt = Date.now;

function Bt(t) {
  var e = 0,
      n = 0;
  return function () {
    var r = Nt(),
        i = 16 - (r - n);

    if (n = r, i > 0) {
      if (++e >= 800) return arguments[0];
    } else e = 0;

    return t.apply(void 0, arguments);
  };
}

var Ft = Bt(dt),
    zt = /\{\n\/\* \[wrapped with (.+)\] \*/,
    Vt = /,? & /;
var Gt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

function Ut(t) {
  return function () {
    return t;
  };
}

var Ht = function () {
  try {
    var t = ft(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch (t) {}
}(),
    Wt = Bt(Ht ? function (t, e) {
  return Ht(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ut(e),
    writable: !0
  });
} : K);

function qt(t, e) {
  for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t);) {
    ;
  }

  return t;
}

function Yt(t, e, n, r) {
  for (var i = t.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) {
    if (e(t[o], o, t)) return o;
  }

  return -1;
}

function Xt(t) {
  return t != t;
}

function $t(t, e, n) {
  return e == e ? function (t, e, n) {
    for (var r = n - 1, i = t.length; ++r < i;) {
      if (t[r] === e) return r;
    }

    return -1;
  }(t, e, n) : Yt(t, Xt, n);
}

function Zt(t, e) {
  return !!(null == t ? 0 : t.length) && $t(t, e, 0) > -1;
}

var Kt = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];

function Jt(t, e, n) {
  var r = e + "";
  return Wt(t, function (t, e) {
    var n = e.length;
    if (!n) return t;
    var r = n - 1;
    return e[r] = (n > 1 ? "& " : "") + e[r], e = e.join(n > 2 ? ", " : " "), t.replace(Gt, "{\n/* [wrapped with " + e + "] */\n");
  }(r, function (t, e) {
    return qt(Kt, function (n) {
      var r = "_." + n[0];
      e & n[1] && !Zt(t, r) && t.push(r);
    }), t.sort();
  }(function (t) {
    var e = t.match(zt);
    return e ? e[1].split(Vt) : [];
  }(r), n)));
}

function Qt(t, e, n, r, i, o, a, s, u, c) {
  var l = 8 & e;
  e |= l ? 32 : 64, 4 & (e &= ~(l ? 64 : 32)) || (e &= -4);
  var f = [t, e, i, l ? o : void 0, l ? a : void 0, l ? void 0 : o, l ? void 0 : a, s, u, c],
      h = n.apply(void 0, f);
  return It(t) && Ft(h, f), h.placeholder = r, Jt(h, t, e);
}

function te(t) {
  return t.placeholder;
}

var ee = /^(?:0|[1-9]\d*)$/;

function ne(t, e) {
  var n = typeof t;
  return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && ee.test(t)) && t > -1 && t % 1 == 0 && t < e;
}

var re = Math.min;

function ie(t, e) {
  for (var n = t.length, r = re(e.length, n), i = Rt(t); r--;) {
    var o = e[r];
    t[r] = ne(o, n) ? i[o] : void 0;
  }

  return t;
}

function oe(t, e) {
  for (var n = -1, r = t.length, i = 0, o = []; ++n < r;) {
    var a = t[n];
    a !== e && "__lodash_placeholder__" !== a || (t[n] = "__lodash_placeholder__", o[i++] = n);
  }

  return o;
}

function ae(t, e, n, r, i, o, a, s, u, c) {
  var l = 128 & e,
      f = 1 & e,
      h = 2 & e,
      p = 24 & e,
      d = 512 & e,
      v = h ? void 0 : yt(t);
  return function g() {
    for (var y = arguments.length, _ = Array(y), m = y; m--;) {
      _[m] = arguments[m];
    }

    if (p) var b = te(g),
        x = Ot(_, b);

    if (r && (_ = bt(_, r, i, p)), o && (_ = wt(_, o, a, p)), y -= x, p && y < c) {
      var w = oe(_, b);
      return Qt(t, e, ae, g.placeholder, n, _, w, s, u, c - y);
    }

    var E = f ? n : this,
        T = h ? E[t] : t;
    return y = _.length, s ? _ = ie(_, s) : d && y > 1 && _.reverse(), l && u < y && (_.length = u), this && this !== O && this instanceof g && (T = v || yt(T)), T.apply(E, _);
  };
}

var se = Math.min;
var ue = Math.max;

function ce(t, e, n, r, i, o, a, s) {
  var u = 2 & e;
  if (!u && "function" != typeof t) throw new TypeError("Expected a function");
  var c = r ? r.length : 0;

  if (c || (e &= -97, r = i = void 0), a = void 0 === a ? a : ue(Z(a), 0), s = void 0 === s ? s : Z(s), c -= i ? i.length : 0, 64 & e) {
    var l = r,
        f = i;
    r = i = void 0;
  }

  var h = u ? void 0 : Mt(t),
      p = [t, e, n, r, i, l, f, o, a, s];
  if (h && function (t, e) {
    var n = t[1],
        r = e[1],
        i = n | r,
        o = i < 131,
        a = 128 == r && 8 == n || 128 == r && 256 == n && t[7].length <= e[8] || 384 == r && e[7].length <= e[8] && 8 == n;
    if (!o && !a) return t;
    1 & r && (t[2] = e[2], i |= 1 & n ? 0 : 4);
    var s = e[3];

    if (s) {
      var u = t[3];
      t[3] = u ? bt(u, s, e[4]) : s, t[4] = u ? oe(t[3], "__lodash_placeholder__") : e[4];
    }

    (s = e[5]) && (u = t[5], t[5] = u ? wt(u, s, e[6]) : s, t[6] = u ? oe(t[5], "__lodash_placeholder__") : e[6]), (s = e[7]) && (t[7] = s), 128 & r && (t[8] = null == t[8] ? e[8] : se(t[8], e[8])), null == t[9] && (t[9] = e[9]), t[0] = e[0], t[1] = i;
  }(p, h), t = p[0], e = p[1], n = p[2], r = p[3], i = p[4], !(s = p[9] = void 0 === p[9] ? u ? 0 : t.length : ue(p[9] - c, 0)) && 24 & e && (e &= -25), e && 1 != e) d = 8 == e || 16 == e ? function (t, e, n) {
    var r = yt(t);
    return function i() {
      for (var o = arguments.length, a = Array(o), s = o, u = te(i); s--;) {
        a[s] = arguments[s];
      }

      var c = o < 3 && a[0] !== u && a[o - 1] !== u ? [] : oe(a, u);
      if ((o -= c.length) < n) return Qt(t, e, ae, i.placeholder, void 0, a, c, void 0, void 0, n - o);
      var l = this && this !== O && this instanceof i ? r : t;
      return _t(l, this, a);
    };
  }(t, e, s) : 32 != e && 33 != e || i.length ? ae.apply(void 0, p) : function (t, e, n, r) {
    var i = 1 & e,
        o = yt(t);
    return function e() {
      for (var a = -1, s = arguments.length, u = -1, c = r.length, l = Array(c + s), f = this && this !== O && this instanceof e ? o : t; ++u < c;) {
        l[u] = r[u];
      }

      for (; s--;) {
        l[u++] = arguments[++a];
      }

      return _t(f, i ? n : this, l);
    };
  }(t, e, n, r);else var d = function (t, e, n) {
    var r = 1 & e,
        i = yt(t);
    return function e() {
      var o = this && this !== O && this instanceof e ? i : t;
      return o.apply(r ? n : this, arguments);
    };
  }(t, e, n);
  return Jt((h ? dt : Ft)(d, p), t, e);
}

function le(t, e, n) {
  return e = n ? void 0 : e, ce(t, 128, void 0, void 0, void 0, void 0, e = t && null == e ? t.length : e);
}

function fe(t, e, n) {
  "__proto__" == e && Ht ? Ht(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}

function he(t, e) {
  return t === e || t != t && e != e;
}

var pe = Object.prototype.hasOwnProperty;

function de(t, e, n) {
  var r = t[e];
  pe.call(t, e) && he(r, n) && (void 0 !== n || e in t) || fe(t, e, n);
}

function ve(t, e, n, r) {
  var i = !n;
  n || (n = {});

  for (var o = -1, a = e.length; ++o < a;) {
    var s = e[o],
        u = r ? r(n[s], t[s], s, n, t) : void 0;
    void 0 === u && (u = t[s]), i ? fe(n, s, u) : de(n, s, u);
  }

  return n;
}

var ge = Math.max;

function ye(t, e, n) {
  return e = ge(void 0 === e ? t.length - 1 : e, 0), function () {
    for (var r = arguments, i = -1, o = ge(r.length - e, 0), a = Array(o); ++i < o;) {
      a[i] = r[e + i];
    }

    i = -1;

    for (var s = Array(e + 1); ++i < e;) {
      s[i] = r[i];
    }

    return s[e] = n(a), _t(t, this, s);
  };
}

function _e(t, e) {
  return Wt(ye(t, e, K), t + "");
}

function me(t) {
  return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
}

function be(t) {
  return null != t && me(t.length) && !J(t);
}

function xe(t, e, n) {
  if (!G(n)) return !1;
  var r = typeof e;
  return !!("number" == r ? be(n) && ne(e, n.length) : "string" == r && e in n) && he(n[e], t);
}

function we(t) {
  return _e(function (e, n) {
    var r = -1,
        i = n.length,
        o = i > 1 ? n[i - 1] : void 0,
        a = i > 2 ? n[2] : void 0;

    for (o = t.length > 3 && "function" == typeof o ? (i--, o) : void 0, a && xe(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), e = Object(e); ++r < i;) {
      var s = n[r];
      s && t(e, s, r, o);
    }

    return e;
  });
}

var Oe = Object.prototype;

function Ee(t) {
  var e = t && t.constructor;
  return t === ("function" == typeof e && e.prototype || Oe);
}

function Te(t, e) {
  for (var n = -1, r = Array(t); ++n < t;) {
    r[n] = e(n);
  }

  return r;
}

function Se(t) {
  return R(t) && "[object Arguments]" == C(t);
}

var Me = Object.prototype,
    Ae = Me.hasOwnProperty,
    ke = Me.propertyIsEnumerable,
    Le = Se(function () {
  return arguments;
}()) ? Se : function (t) {
  return R(t) && Ae.call(t, "callee") && !ke.call(t, "callee");
};

function Ce() {
  return !1;
}

var Re = "object" == typeof exports && exports && !exports.nodeType && exports,
    je = Re && "object" == typeof module && module && !module.nodeType && module,
    Pe = je && je.exports === Re ? O.Buffer : void 0,
    De = (Pe ? Pe.isBuffer : void 0) || Ce,
    Ie = {};

function Ne(t) {
  return function (e) {
    return t(e);
  };
}

Ie["[object Float32Array]"] = Ie["[object Float64Array]"] = Ie["[object Int8Array]"] = Ie["[object Int16Array]"] = Ie["[object Int32Array]"] = Ie["[object Uint8Array]"] = Ie["[object Uint8ClampedArray]"] = Ie["[object Uint16Array]"] = Ie["[object Uint32Array]"] = !0, Ie["[object Arguments]"] = Ie["[object Array]"] = Ie["[object ArrayBuffer]"] = Ie["[object Boolean]"] = Ie["[object DataView]"] = Ie["[object Date]"] = Ie["[object Error]"] = Ie["[object Function]"] = Ie["[object Map]"] = Ie["[object Number]"] = Ie["[object Object]"] = Ie["[object RegExp]"] = Ie["[object Set]"] = Ie["[object String]"] = Ie["[object WeakMap]"] = !1;

var Be = "object" == typeof exports && exports && !exports.nodeType && exports,
    Fe = Be && "object" == typeof module && module && !module.nodeType && module,
    ze = Fe && Fe.exports === Be && x.process,
    Ve = function () {
  try {
    var t = Fe && Fe.require && Fe.require("util").types;

    return t || ze && ze.binding && ze.binding("util");
  } catch (t) {}
}(),
    Ge = Ve && Ve.isTypedArray,
    Ue = Ge ? Ne(Ge) : function (t) {
  return R(t) && me(t.length) && !!Ie[C(t)];
},
    He = Object.prototype.hasOwnProperty;

function We(t, e) {
  var n = I(t),
      r = !n && Le(t),
      i = !n && !r && De(t),
      o = !n && !r && !i && Ue(t),
      a = n || r || i || o,
      s = a ? Te(t.length, String) : [],
      u = s.length;

  for (var c in t) {
    !e && !He.call(t, c) || a && ("length" == c || i && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || ne(c, u)) || s.push(c);
  }

  return s;
}

function qe(t, e) {
  return function (n) {
    return t(e(n));
  };
}

var Ye = qe(Object.keys, Object),
    Xe = Object.prototype.hasOwnProperty;

function $e(t) {
  if (!Ee(t)) return Ye(t);
  var e = [];

  for (var n in Object(t)) {
    Xe.call(t, n) && "constructor" != n && e.push(n);
  }

  return e;
}

function Ze(t) {
  return be(t) ? We(t) : $e(t);
}

var Ke = Object.prototype.hasOwnProperty,
    Je = we(function (t, e) {
  if (Ee(e) || be(e)) ve(e, Ze(e), t);else for (var n in e) {
    Ke.call(e, n) && de(t, n, e[n]);
  }
});
var Qe = Object.prototype.hasOwnProperty;

function tn(t) {
  if (!G(t)) return function (t) {
    var e = [];
    if (null != t) for (var n in Object(t)) {
      e.push(n);
    }
    return e;
  }(t);
  var e = Ee(t),
      n = [];

  for (var r in t) {
    ("constructor" != r || !e && Qe.call(t, r)) && n.push(r);
  }

  return n;
}

function en(t) {
  return be(t) ? We(t, !0) : tn(t);
}

var nn = we(function (t, e) {
  ve(e, en(e), t);
}),
    rn = we(function (t, e, n, r) {
  ve(e, en(e), t, r);
}),
    on = we(function (t, e, n, r) {
  ve(e, Ze(e), t, r);
}),
    an = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    sn = /^\w*$/;

function un(t, e) {
  if (I(t)) return !1;
  var n = typeof t;
  return !("number" != n && "symbol" != n && "boolean" != n && null != t && !j(t)) || sn.test(t) || !an.test(t) || null != e && t in Object(e);
}

var cn = ft(Object, "create");
var ln = Object.prototype.hasOwnProperty;
var fn = Object.prototype.hasOwnProperty;

function hn(t) {
  var e = -1,
      n = null == t ? 0 : t.length;

  for (this.clear(); ++e < n;) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}

function pn(t, e) {
  for (var n = t.length; n--;) {
    if (he(t[n][0], e)) return n;
  }

  return -1;
}

hn.prototype.clear = function () {
  this.__data__ = cn ? cn(null) : {}, this.size = 0;
}, hn.prototype["delete"] = function (t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}, hn.prototype.get = function (t) {
  var e = this.__data__;

  if (cn) {
    var n = e[t];
    return "__lodash_hash_undefined__" === n ? void 0 : n;
  }

  return ln.call(e, t) ? e[t] : void 0;
}, hn.prototype.has = function (t) {
  var e = this.__data__;
  return cn ? void 0 !== e[t] : fn.call(e, t);
}, hn.prototype.set = function (t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = cn && void 0 === e ? "__lodash_hash_undefined__" : e, this;
};
var dn = Array.prototype.splice;

function vn(t) {
  var e = -1,
      n = null == t ? 0 : t.length;

  for (this.clear(); ++e < n;) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}

vn.prototype.clear = function () {
  this.__data__ = [], this.size = 0;
}, vn.prototype["delete"] = function (t) {
  var e = this.__data__,
      n = pn(e, t);
  return !(n < 0) && (n == e.length - 1 ? e.pop() : dn.call(e, n, 1), --this.size, !0);
}, vn.prototype.get = function (t) {
  var e = this.__data__,
      n = pn(e, t);
  return n < 0 ? void 0 : e[n][1];
}, vn.prototype.has = function (t) {
  return pn(this.__data__, t) > -1;
}, vn.prototype.set = function (t, e) {
  var n = this.__data__,
      r = pn(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
};
var gn = ft(O, "Map");

function yn(t, e) {
  var n,
      r,
      i = t.__data__;
  return ("string" == (r = typeof (n = e)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof e ? "string" : "hash"] : i.map;
}

function _n(t) {
  var e = -1,
      n = null == t ? 0 : t.length;

  for (this.clear(); ++e < n;) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}

_n.prototype.clear = function () {
  this.size = 0, this.__data__ = {
    hash: new hn(),
    map: new (gn || vn)(),
    string: new hn()
  };
}, _n.prototype["delete"] = function (t) {
  var e = yn(this, t)["delete"](t);
  return this.size -= e ? 1 : 0, e;
}, _n.prototype.get = function (t) {
  return yn(this, t).get(t);
}, _n.prototype.has = function (t) {
  return yn(this, t).has(t);
}, _n.prototype.set = function (t, e) {
  var n = yn(this, t),
      r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
};

function mn(t, e) {
  if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");

  var n = function n() {
    var r = arguments,
        i = e ? e.apply(this, r) : r[0],
        o = n.cache;
    if (o.has(i)) return o.get(i);
    var a = t.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };

  return n.cache = new (mn.Cache || _n)(), n;
}

mn.Cache = _n;

var bn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    xn = /\\(\\)?/g,
    wn = function (t) {
  var e = mn(t, function (t) {
    return 500 === n.size && n.clear(), t;
  }),
      n = e.cache;
  return e;
}(function (t) {
  var e = [];
  return 46 === t.charCodeAt(0) && e.push(""), t.replace(bn, function (t, n, r, i) {
    e.push(r ? i.replace(xn, "$1") : n || t);
  }), e;
});

function On(t) {
  return null == t ? "" : F(t);
}

function En(t, e) {
  return I(t) ? t : un(t, e) ? [t] : wn(On(t));
}

function Tn(t) {
  if ("string" == typeof t || j(t)) return t;
  var e = t + "";
  return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
}

function Sn(t, e) {
  for (var n = 0, r = (e = En(e, t)).length; null != t && n < r;) {
    t = t[Tn(e[n++])];
  }

  return n && n == r ? t : void 0;
}

function Mn(t, e, n) {
  var r = null == t ? void 0 : Sn(t, e);
  return void 0 === r ? n : r;
}

function An(t, e) {
  for (var n = -1, r = e.length, i = Array(r), o = null == t; ++n < r;) {
    i[n] = o ? void 0 : Mn(t, e[n]);
  }

  return i;
}

function kn(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r;) {
    t[i + n] = e[n];
  }

  return t;
}

var Ln = E ? E.isConcatSpreadable : void 0;

function Cn(t) {
  return I(t) || Le(t) || !!(Ln && t && t[Ln]);
}

function Rn(t, e, n, r, i) {
  var o = -1,
      a = t.length;

  for (n || (n = Cn), i || (i = []); ++o < a;) {
    var s = t[o];
    e > 0 && n(s) ? e > 1 ? Rn(s, e - 1, n, r, i) : kn(i, s) : r || (i[i.length] = s);
  }

  return i;
}

function jn(t) {
  return (null == t ? 0 : t.length) ? Rn(t, 1) : [];
}

function Pn(t) {
  return Wt(ye(t, void 0, jn), t + "");
}

var Dn = Pn(An),
    In = qe(Object.getPrototypeOf, Object),
    Nn = Function.prototype,
    Bn = Object.prototype,
    Fn = Nn.toString,
    zn = Bn.hasOwnProperty,
    Vn = Fn.call(Object);

function Gn(t) {
  if (!R(t) || "[object Object]" != C(t)) return !1;
  var e = In(t);
  if (null === e) return !0;
  var n = zn.call(e, "constructor") && e.constructor;
  return "function" == typeof n && n instanceof n && Fn.call(n) == Vn;
}

function Un(t) {
  if (!R(t)) return !1;
  var e = C(t);
  return "[object Error]" == e || "[object DOMException]" == e || "string" == typeof t.message && "string" == typeof t.name && !Gn(t);
}

var Hn = _e(function (t, e) {
  try {
    return _t(t, void 0, e);
  } catch (t) {
    return Un(t) ? t : new Error(t);
  }
});

function Wn(t, e) {
  var n;
  if ("function" != typeof e) throw new TypeError("Expected a function");
  return t = Z(t), function () {
    return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = void 0), n;
  };
}

var qn = _e(function (t, e, n) {
  var r = 1;

  if (n.length) {
    var i = oe(n, te(qn));
    r |= 32;
  }

  return ce(t, r, e, n, i);
});

qn.placeholder = {};

var Yn = Pn(function (t, e) {
  return qt(e, function (e) {
    e = Tn(e), fe(t, e, qn(t[e], t));
  }), t;
}),
    Xn = _e(function (t, e, n) {
  var r = 3;

  if (n.length) {
    var i = oe(n, te(Xn));
    r |= 32;
  }

  return ce(e, r, t, n, i);
});

function $n(t, e, n) {
  var r = -1,
      i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), (n = n > i ? i : n) < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;

  for (var o = Array(i); ++r < i;) {
    o[r] = t[r + e];
  }

  return o;
}

function Zn(t, e, n) {
  var r = t.length;
  return n = void 0 === n ? r : n, !e && n >= r ? t : $n(t, e, n);
}

Xn.placeholder = {};
var Kn = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

function Jn(t) {
  return Kn.test(t);
}

var Qn = "[\\ud800-\\udfff]",
    tr = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
    er = "\\ud83c[\\udffb-\\udfff]",
    nr = "[^\\ud800-\\udfff]",
    rr = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    ir = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    or = "(?:" + tr + "|" + er + ")" + "?",
    ar = "[\\ufe0e\\ufe0f]?" + or + ("(?:\\u200d(?:" + [nr, rr, ir].join("|") + ")[\\ufe0e\\ufe0f]?" + or + ")*"),
    sr = "(?:" + [nr + tr + "?", tr, rr, ir, Qn].join("|") + ")",
    ur = RegExp(er + "(?=" + er + ")|" + sr + ar, "g");

function cr(t) {
  return Jn(t) ? function (t) {
    return t.match(ur) || [];
  }(t) : function (t) {
    return t.split("");
  }(t);
}

function lr(t) {
  return function (e) {
    var n = Jn(e = On(e)) ? cr(e) : void 0,
        r = n ? n[0] : e.charAt(0),
        i = n ? Zn(n, 1).join("") : e.slice(1);
    return r[t]() + i;
  };
}

var fr = lr("toUpperCase");

function hr(t) {
  return fr(On(t).toLowerCase());
}

function pr(t, e, n, r) {
  var i = -1,
      o = null == t ? 0 : t.length;

  for (r && o && (n = t[++i]); ++i < o;) {
    n = e(n, t[i], i, t);
  }

  return n;
}

function dr(t) {
  return function (e) {
    return null == t ? void 0 : t[e];
  };
}

var vr = dr({
  "À": "A",
  "Á": "A",
  "Â": "A",
  "Ã": "A",
  "Ä": "A",
  "Å": "A",
  "à": "a",
  "á": "a",
  "â": "a",
  "ã": "a",
  "ä": "a",
  "å": "a",
  "Ç": "C",
  "ç": "c",
  "Ð": "D",
  "ð": "d",
  "È": "E",
  "É": "E",
  "Ê": "E",
  "Ë": "E",
  "è": "e",
  "é": "e",
  "ê": "e",
  "ë": "e",
  "Ì": "I",
  "Í": "I",
  "Î": "I",
  "Ï": "I",
  "ì": "i",
  "í": "i",
  "î": "i",
  "ï": "i",
  "Ñ": "N",
  "ñ": "n",
  "Ò": "O",
  "Ó": "O",
  "Ô": "O",
  "Õ": "O",
  "Ö": "O",
  "Ø": "O",
  "ò": "o",
  "ó": "o",
  "ô": "o",
  "õ": "o",
  "ö": "o",
  "ø": "o",
  "Ù": "U",
  "Ú": "U",
  "Û": "U",
  "Ü": "U",
  "ù": "u",
  "ú": "u",
  "û": "u",
  "ü": "u",
  "Ý": "Y",
  "ý": "y",
  "ÿ": "y",
  "Æ": "Ae",
  "æ": "ae",
  "Þ": "Th",
  "þ": "th",
  "ß": "ss",
  "Ā": "A",
  "Ă": "A",
  "Ą": "A",
  "ā": "a",
  "ă": "a",
  "ą": "a",
  "Ć": "C",
  "Ĉ": "C",
  "Ċ": "C",
  "Č": "C",
  "ć": "c",
  "ĉ": "c",
  "ċ": "c",
  "č": "c",
  "Ď": "D",
  "Đ": "D",
  "ď": "d",
  "đ": "d",
  "Ē": "E",
  "Ĕ": "E",
  "Ė": "E",
  "Ę": "E",
  "Ě": "E",
  "ē": "e",
  "ĕ": "e",
  "ė": "e",
  "ę": "e",
  "ě": "e",
  "Ĝ": "G",
  "Ğ": "G",
  "Ġ": "G",
  "Ģ": "G",
  "ĝ": "g",
  "ğ": "g",
  "ġ": "g",
  "ģ": "g",
  "Ĥ": "H",
  "Ħ": "H",
  "ĥ": "h",
  "ħ": "h",
  "Ĩ": "I",
  "Ī": "I",
  "Ĭ": "I",
  "Į": "I",
  "İ": "I",
  "ĩ": "i",
  "ī": "i",
  "ĭ": "i",
  "į": "i",
  "ı": "i",
  "Ĵ": "J",
  "ĵ": "j",
  "Ķ": "K",
  "ķ": "k",
  "ĸ": "k",
  "Ĺ": "L",
  "Ļ": "L",
  "Ľ": "L",
  "Ŀ": "L",
  "Ł": "L",
  "ĺ": "l",
  "ļ": "l",
  "ľ": "l",
  "ŀ": "l",
  "ł": "l",
  "Ń": "N",
  "Ņ": "N",
  "Ň": "N",
  "Ŋ": "N",
  "ń": "n",
  "ņ": "n",
  "ň": "n",
  "ŋ": "n",
  "Ō": "O",
  "Ŏ": "O",
  "Ő": "O",
  "ō": "o",
  "ŏ": "o",
  "ő": "o",
  "Ŕ": "R",
  "Ŗ": "R",
  "Ř": "R",
  "ŕ": "r",
  "ŗ": "r",
  "ř": "r",
  "Ś": "S",
  "Ŝ": "S",
  "Ş": "S",
  "Š": "S",
  "ś": "s",
  "ŝ": "s",
  "ş": "s",
  "š": "s",
  "Ţ": "T",
  "Ť": "T",
  "Ŧ": "T",
  "ţ": "t",
  "ť": "t",
  "ŧ": "t",
  "Ũ": "U",
  "Ū": "U",
  "Ŭ": "U",
  "Ů": "U",
  "Ű": "U",
  "Ų": "U",
  "ũ": "u",
  "ū": "u",
  "ŭ": "u",
  "ů": "u",
  "ű": "u",
  "ų": "u",
  "Ŵ": "W",
  "ŵ": "w",
  "Ŷ": "Y",
  "ŷ": "y",
  "Ÿ": "Y",
  "Ź": "Z",
  "Ż": "Z",
  "Ž": "Z",
  "ź": "z",
  "ż": "z",
  "ž": "z",
  "Ĳ": "IJ",
  "ĳ": "ij",
  "Œ": "Oe",
  "œ": "oe",
  "ŉ": "'n",
  "ſ": "s"
}),
    gr = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    yr = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");

function _r(t) {
  return (t = On(t)) && t.replace(gr, vr).replace(yr, "");
}

var mr = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
var br = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
var xr = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    wr = "[" + xr + "]",
    Or = "\\d+",
    Er = "[\\u2700-\\u27bf]",
    Tr = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
    Sr = "[^\\ud800-\\udfff" + xr + Or + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
    Mr = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    Ar = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    kr = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
    Lr = "(?:" + Tr + "|" + Sr + ")",
    Cr = "(?:" + kr + "|" + Sr + ")",
    Rr = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
    jr = "[\\ufe0e\\ufe0f]?" + Rr + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", Mr, Ar].join("|") + ")[\\ufe0e\\ufe0f]?" + Rr + ")*"),
    Pr = "(?:" + [Er, Mr, Ar].join("|") + ")" + jr,
    Dr = RegExp([kr + "?" + Tr + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [wr, kr, "$"].join("|") + ")", Cr + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [wr, kr + Lr, "$"].join("|") + ")", kr + "?" + Lr + "+(?:['’](?:d|ll|m|re|s|t|ve))?", kr + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Or, Pr].join("|"), "g");

function Ir(t, e, n) {
  return t = On(t), void 0 === (e = n ? void 0 : e) ? function (t) {
    return br.test(t);
  }(t) ? function (t) {
    return t.match(Dr) || [];
  }(t) : function (t) {
    return t.match(mr) || [];
  }(t) : t.match(e) || [];
}

var Nr = RegExp("['’]", "g");

function Br(t) {
  return function (e) {
    return pr(Ir(_r(e).replace(Nr, "")), t, "");
  };
}

var Fr = Br(function (t, e, n) {
  return e = e.toLowerCase(), t + (n ? hr(e) : e);
});
var zr = O.isFinite,
    Vr = Math.min;

function Gr(t) {
  var e = Math[t];
  return function (t, n) {
    if (t = X(t), (n = null == n ? 0 : Vr(Z(n), 292)) && zr(t)) {
      var r = (On(t) + "e").split("e");
      return +((r = (On(e(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
    }

    return e(t);
  };
}

var Ur = Gr("ceil");

function Hr(t) {
  var e = Dt(t);
  return e.__chain__ = !0, e;
}

var Wr = Math.ceil,
    qr = Math.max;

function Yr(t, e, n) {
  return t == t && (void 0 !== n && (t = t <= n ? t : n), void 0 !== e && (t = t >= e ? t : e)), t;
}

function Xr(t) {
  var e = this.__data__ = new vn(t);
  this.size = e.size;
}

function $r(t, e) {
  return t && ve(e, Ze(e), t);
}

Xr.prototype.clear = function () {
  this.__data__ = new vn(), this.size = 0;
}, Xr.prototype["delete"] = function (t) {
  var e = this.__data__,
      n = e["delete"](t);
  return this.size = e.size, n;
}, Xr.prototype.get = function (t) {
  return this.__data__.get(t);
}, Xr.prototype.has = function (t) {
  return this.__data__.has(t);
}, Xr.prototype.set = function (t, e) {
  var n = this.__data__;

  if (n instanceof vn) {
    var r = n.__data__;
    if (!gn || r.length < 199) return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new _n(r);
  }

  return n.set(t, e), this.size = n.size, this;
};
var Zr = "object" == typeof exports && exports && !exports.nodeType && exports,
    Kr = Zr && "object" == typeof module && module && !module.nodeType && module,
    Jr = Kr && Kr.exports === Zr ? O.Buffer : void 0,
    Qr = Jr ? Jr.allocUnsafe : void 0;

function ti(t, e) {
  if (e) return t.slice();
  var n = t.length,
      r = Qr ? Qr(n) : new t.constructor(n);
  return t.copy(r), r;
}

function ei(t, e) {
  for (var n = -1, r = null == t ? 0 : t.length, i = 0, o = []; ++n < r;) {
    var a = t[n];
    e(a, n, t) && (o[i++] = a);
  }

  return o;
}

function ni() {
  return [];
}

var ri = Object.prototype.propertyIsEnumerable,
    ii = Object.getOwnPropertySymbols,
    oi = ii ? function (t) {
  return null == t ? [] : (t = Object(t), ei(ii(t), function (e) {
    return ri.call(t, e);
  }));
} : ni;
var ai = Object.getOwnPropertySymbols ? function (t) {
  for (var e = []; t;) {
    kn(e, oi(t)), t = In(t);
  }

  return e;
} : ni;

function si(t, e, n) {
  var r = e(t);
  return I(t) ? r : kn(r, n(t));
}

function ui(t) {
  return si(t, Ze, oi);
}

function ci(t) {
  return si(t, en, ai);
}

var li = ft(O, "DataView"),
    fi = ft(O, "Promise"),
    hi = ft(O, "Set"),
    pi = rt(li),
    di = rt(gn),
    vi = rt(fi),
    gi = rt(hi),
    yi = rt(ht),
    _i = C;
(li && "[object DataView]" != _i(new li(new ArrayBuffer(1))) || gn && "[object Map]" != _i(new gn()) || fi && "[object Promise]" != _i(fi.resolve()) || hi && "[object Set]" != _i(new hi()) || ht && "[object WeakMap]" != _i(new ht())) && (_i = function _i(t) {
  var e = C(t),
      n = "[object Object]" == e ? t.constructor : void 0,
      r = n ? rt(n) : "";
  if (r) switch (r) {
    case pi:
      return "[object DataView]";

    case di:
      return "[object Map]";

    case vi:
      return "[object Promise]";

    case gi:
      return "[object Set]";

    case yi:
      return "[object WeakMap]";
  }
  return e;
});
var mi = _i,
    bi = Object.prototype.hasOwnProperty;
var xi = O.Uint8Array;

function wi(t) {
  var e = new t.constructor(t.byteLength);
  return new xi(e).set(new xi(t)), e;
}

var Oi = /\w*$/;
var Ei = E ? E.prototype : void 0,
    Ti = Ei ? Ei.valueOf : void 0;

function Si(t, e) {
  var n = e ? wi(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}

function Mi(t, e, n) {
  var r,
      i = t.constructor;

  switch (e) {
    case "[object ArrayBuffer]":
      return wi(t);

    case "[object Boolean]":
    case "[object Date]":
      return new i(+t);

    case "[object DataView]":
      return function (t, e) {
        var n = e ? wi(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.byteLength);
      }(t, n);

    case "[object Float32Array]":
    case "[object Float64Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object Int32Array]":
    case "[object Uint8Array]":
    case "[object Uint8ClampedArray]":
    case "[object Uint16Array]":
    case "[object Uint32Array]":
      return Si(t, n);

    case "[object Map]":
      return new i();

    case "[object Number]":
    case "[object String]":
      return new i(t);

    case "[object RegExp]":
      return function (t) {
        var e = new t.constructor(t.source, Oi.exec(t));
        return e.lastIndex = t.lastIndex, e;
      }(t);

    case "[object Set]":
      return new i();

    case "[object Symbol]":
      return r = t, Ti ? Object(Ti.call(r)) : {};
  }
}

function Ai(t) {
  return "function" != typeof t.constructor || Ee(t) ? {} : gt(In(t));
}

var ki = Ve && Ve.isMap,
    Li = ki ? Ne(ki) : function (t) {
  return R(t) && "[object Map]" == mi(t);
};
var Ci = Ve && Ve.isSet,
    Ri = Ci ? Ne(Ci) : function (t) {
  return R(t) && "[object Set]" == mi(t);
},
    ji = {};

function Pi(t, e, n, r, i, o) {
  var a,
      s = 1 & e,
      u = 2 & e,
      c = 4 & e;
  if (n && (a = i ? n(t, r, i, o) : n(t)), void 0 !== a) return a;
  if (!G(t)) return t;
  var l = I(t);

  if (l) {
    if (a = function (t) {
      var e = t.length,
          n = new t.constructor(e);
      return e && "string" == typeof t[0] && bi.call(t, "index") && (n.index = t.index, n.input = t.input), n;
    }(t), !s) return Rt(t, a);
  } else {
    var f = mi(t),
        h = "[object Function]" == f || "[object GeneratorFunction]" == f;
    if (De(t)) return ti(t, s);

    if ("[object Object]" == f || "[object Arguments]" == f || h && !i) {
      if (a = u || h ? {} : Ai(t), !s) return u ? function (t, e) {
        return ve(t, ai(t), e);
      }(t, function (t, e) {
        return t && ve(e, en(e), t);
      }(a, t)) : function (t, e) {
        return ve(t, oi(t), e);
      }(t, $r(a, t));
    } else {
      if (!ji[f]) return i ? t : {};
      a = Mi(t, f, s);
    }
  }

  o || (o = new Xr());
  var p = o.get(t);
  if (p) return p;
  o.set(t, a), Ri(t) ? t.forEach(function (r) {
    a.add(Pi(r, e, n, r, t, o));
  }) : Li(t) && t.forEach(function (r, i) {
    a.set(i, Pi(r, e, n, i, t, o));
  });
  var d = c ? u ? ci : ui : u ? keysIn : Ze,
      v = l ? void 0 : d(t);
  return qt(v || t, function (r, i) {
    v && (r = t[i = r]), de(a, i, Pi(r, e, n, i, t, o));
  }), a;
}

ji["[object Arguments]"] = ji["[object Array]"] = ji["[object ArrayBuffer]"] = ji["[object DataView]"] = ji["[object Boolean]"] = ji["[object Date]"] = ji["[object Float32Array]"] = ji["[object Float64Array]"] = ji["[object Int8Array]"] = ji["[object Int16Array]"] = ji["[object Int32Array]"] = ji["[object Map]"] = ji["[object Number]"] = ji["[object Object]"] = ji["[object RegExp]"] = ji["[object Set]"] = ji["[object String]"] = ji["[object Symbol]"] = ji["[object Uint8Array]"] = ji["[object Uint8ClampedArray]"] = ji["[object Uint16Array]"] = ji["[object Uint32Array]"] = !0, ji["[object Error]"] = ji["[object Function]"] = ji["[object WeakMap]"] = !1;

function Di(t) {
  return Pi(t, 5);
}

function Ii(t) {
  var e = -1,
      n = null == t ? 0 : t.length;

  for (this.__data__ = new _n(); ++e < n;) {
    this.add(t[e]);
  }
}

function Ni(t, e) {
  for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
    if (e(t[n], n, t)) return !0;
  }

  return !1;
}

function Bi(t, e) {
  return t.has(e);
}

Ii.prototype.add = Ii.prototype.push = function (t) {
  return this.__data__.set(t, "__lodash_hash_undefined__"), this;
}, Ii.prototype.has = function (t) {
  return this.__data__.has(t);
};

function Fi(t, e, n, r, i, o) {
  var a = 1 & n,
      s = t.length,
      u = e.length;
  if (s != u && !(a && u > s)) return !1;
  var c = o.get(t);
  if (c && o.get(e)) return c == e;
  var l = -1,
      f = !0,
      h = 2 & n ? new Ii() : void 0;

  for (o.set(t, e), o.set(e, t); ++l < s;) {
    var p = t[l],
        d = e[l];
    if (r) var v = a ? r(d, p, l, e, t, o) : r(p, d, l, t, e, o);

    if (void 0 !== v) {
      if (v) continue;
      f = !1;
      break;
    }

    if (h) {
      if (!Ni(e, function (t, e) {
        if (!Bi(h, e) && (p === t || i(p, t, n, r, o))) return h.push(e);
      })) {
        f = !1;
        break;
      }
    } else if (p !== d && !i(p, d, n, r, o)) {
      f = !1;
      break;
    }
  }

  return o["delete"](t), o["delete"](e), f;
}

function zi(t) {
  var e = -1,
      n = Array(t.size);
  return t.forEach(function (t, r) {
    n[++e] = [r, t];
  }), n;
}

function Vi(t) {
  var e = -1,
      n = Array(t.size);
  return t.forEach(function (t) {
    n[++e] = t;
  }), n;
}

var Gi = E ? E.prototype : void 0,
    Ui = Gi ? Gi.valueOf : void 0;
var Hi = Object.prototype.hasOwnProperty;
var Wi = Object.prototype.hasOwnProperty;

function qi(t, e, n, r, i, o) {
  var a = I(t),
      s = I(e),
      u = a ? "[object Array]" : mi(t),
      c = s ? "[object Array]" : mi(e),
      l = "[object Object]" == (u = "[object Arguments]" == u ? "[object Object]" : u),
      f = "[object Object]" == (c = "[object Arguments]" == c ? "[object Object]" : c),
      h = u == c;

  if (h && De(t)) {
    if (!De(e)) return !1;
    a = !0, l = !1;
  }

  if (h && !l) return o || (o = new Xr()), a || Ue(t) ? Fi(t, e, n, r, i, o) : function (t, e, n, r, i, o, a) {
    switch (n) {
      case "[object DataView]":
        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
        t = t.buffer, e = e.buffer;

      case "[object ArrayBuffer]":
        return !(t.byteLength != e.byteLength || !o(new xi(t), new xi(e)));

      case "[object Boolean]":
      case "[object Date]":
      case "[object Number]":
        return he(+t, +e);

      case "[object Error]":
        return t.name == e.name && t.message == e.message;

      case "[object RegExp]":
      case "[object String]":
        return t == e + "";

      case "[object Map]":
        var s = zi;

      case "[object Set]":
        var u = 1 & r;
        if (s || (s = Vi), t.size != e.size && !u) return !1;
        var c = a.get(t);
        if (c) return c == e;
        r |= 2, a.set(t, e);
        var l = Fi(s(t), s(e), r, i, o, a);
        return a["delete"](t), l;

      case "[object Symbol]":
        if (Ui) return Ui.call(t) == Ui.call(e);
    }

    return !1;
  }(t, e, u, n, r, i, o);

  if (!(1 & n)) {
    var p = l && Wi.call(t, "__wrapped__"),
        d = f && Wi.call(e, "__wrapped__");

    if (p || d) {
      var v = p ? t.value() : t,
          g = d ? e.value() : e;
      return o || (o = new Xr()), i(v, g, n, r, o);
    }
  }

  return !!h && (o || (o = new Xr()), function (t, e, n, r, i, o) {
    var a = 1 & n,
        s = ui(t),
        u = s.length;
    if (u != ui(e).length && !a) return !1;

    for (var c = u; c--;) {
      var l = s[c];
      if (!(a ? l in e : Hi.call(e, l))) return !1;
    }

    var f = o.get(t);
    if (f && o.get(e)) return f == e;
    var h = !0;
    o.set(t, e), o.set(e, t);

    for (var p = a; ++c < u;) {
      var d = t[l = s[c]],
          v = e[l];
      if (r) var g = a ? r(v, d, l, e, t, o) : r(d, v, l, t, e, o);

      if (!(void 0 === g ? d === v || i(d, v, n, r, o) : g)) {
        h = !1;
        break;
      }

      p || (p = "constructor" == l);
    }

    if (h && !p) {
      var y = t.constructor,
          _ = e.constructor;
      y != _ && "constructor" in t && "constructor" in e && !("function" == typeof y && y instanceof y && "function" == typeof _ && _ instanceof _) && (h = !1);
    }

    return o["delete"](t), o["delete"](e), h;
  }(t, e, n, r, i, o));
}

function Yi(t, e, n, r, i) {
  return t === e || (null == t || null == e || !R(t) && !R(e) ? t != t && e != e : qi(t, e, n, r, Yi, i));
}

function Xi(t, e, n, r) {
  var i = n.length,
      o = i,
      a = !r;
  if (null == t) return !o;

  for (t = Object(t); i--;) {
    var s = n[i];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
  }

  for (; ++i < o;) {
    var u = (s = n[i])[0],
        c = t[u],
        l = s[1];

    if (a && s[2]) {
      if (void 0 === c && !(u in t)) return !1;
    } else {
      var f = new Xr();
      if (r) var h = r(c, l, u, t, e, f);
      if (!(void 0 === h ? Yi(l, c, 3, r, f) : h)) return !1;
    }
  }

  return !0;
}

function $i(t) {
  return t == t && !G(t);
}

function Zi(t) {
  for (var e = Ze(t), n = e.length; n--;) {
    var r = e[n],
        i = t[r];
    e[n] = [r, i, $i(i)];
  }

  return e;
}

function Ki(t, e) {
  return function (n) {
    return null != n && n[t] === e && (void 0 !== e || t in Object(n));
  };
}

function Ji(t) {
  var e = Zi(t);
  return 1 == e.length && e[0][2] ? Ki(e[0][0], e[0][1]) : function (n) {
    return n === t || Xi(n, t, e);
  };
}

function Qi(t, e) {
  return null != t && e in Object(t);
}

function to(t, e, n) {
  for (var r = -1, i = (e = En(e, t)).length, o = !1; ++r < i;) {
    var a = Tn(e[r]);
    if (!(o = null != t && n(t, a))) break;
    t = t[a];
  }

  return o || ++r != i ? o : !!(i = null == t ? 0 : t.length) && me(i) && ne(a, i) && (I(t) || Le(t));
}

function eo(t, e) {
  return null != t && to(t, e, Qi);
}

function no(t, e) {
  return un(t) && $i(e) ? Ki(Tn(t), e) : function (n) {
    var r = Mn(n, t);
    return void 0 === r && r === e ? eo(n, t) : Yi(e, r, 3);
  };
}

function ro(t) {
  return function (e) {
    return null == e ? void 0 : e[t];
  };
}

function io(t) {
  return un(t) ? ro(Tn(t)) : function (t) {
    return function (e) {
      return Sn(e, t);
    };
  }(t);
}

function oo(t) {
  return "function" == typeof t ? t : null == t ? K : "object" == typeof t ? I(t) ? no(t[0], t[1]) : Ji(t) : io(t);
}

function ao(t, e, n) {
  var r = n.length;
  if (null == t) return !r;

  for (t = Object(t); r--;) {
    var i = n[r],
        o = e[i],
        a = t[i];
    if (void 0 === a && !(i in t) || !o(a)) return !1;
  }

  return !0;
}

function so(t, e, n, r) {
  for (var i = -1, o = null == t ? 0 : t.length; ++i < o;) {
    var a = t[i];
    e(r, a, n(a), t);
  }

  return r;
}

function uo(t) {
  return function (e, n, r) {
    for (var i = -1, o = Object(e), a = r(e), s = a.length; s--;) {
      var u = a[t ? s : ++i];
      if (!1 === n(o[u], u, o)) break;
    }

    return e;
  };
}

var co = uo();

function lo(t, e) {
  return t && co(t, e, Ze);
}

function fo(t, e) {
  return function (n, r) {
    if (null == n) return n;
    if (!be(n)) return t(n, r);

    for (var i = n.length, o = e ? i : -1, a = Object(n); (e ? o-- : ++o < i) && !1 !== r(a[o], o, a);) {
      ;
    }

    return n;
  };
}

var ho = fo(lo);

function po(t, e, n, r) {
  return ho(t, function (t, i, o) {
    e(r, t, n(t), o);
  }), r;
}

function vo(t, e) {
  return function (n, r) {
    var i = I(n) ? so : po,
        o = e ? e() : {};
    return i(n, t, oo(r), o);
  };
}

var go = Object.prototype.hasOwnProperty,
    yo = vo(function (t, e, n) {
  go.call(t, n) ? ++t[n] : fe(t, n, 1);
});

function _o(t, e, n) {
  var r = ce(t, 8, void 0, void 0, void 0, void 0, void 0, e = n ? void 0 : e);
  return r.placeholder = _o.placeholder, r;
}

_o.placeholder = {};

function mo(t, e, n) {
  var r = ce(t, 16, void 0, void 0, void 0, void 0, void 0, e = n ? void 0 : e);
  return r.placeholder = mo.placeholder, r;
}

mo.placeholder = {};

var bo = function bo() {
  return O.Date.now();
},
    xo = Math.max,
    wo = Math.min;

function Oo(t, e, n) {
  var r,
      i,
      o,
      a,
      s,
      u,
      c = 0,
      l = !1,
      f = !1,
      h = !0;
  if ("function" != typeof t) throw new TypeError("Expected a function");

  function p(e) {
    var n = r,
        o = i;
    return r = i = void 0, c = e, a = t.apply(o, n);
  }

  function d(t) {
    return c = t, s = setTimeout(g, e), l ? p(t) : a;
  }

  function v(t) {
    var n = t - u;
    return void 0 === u || n >= e || n < 0 || f && t - c >= o;
  }

  function g() {
    var t = bo();
    if (v(t)) return y(t);
    s = setTimeout(g, function (t) {
      var n = e - (t - u);
      return f ? wo(n, o - (t - c)) : n;
    }(t));
  }

  function y(t) {
    return s = void 0, h && r ? p(t) : (r = i = void 0, a);
  }

  function _() {
    var t = bo(),
        n = v(t);

    if (r = arguments, i = this, u = t, n) {
      if (void 0 === s) return d(u);
      if (f) return clearTimeout(s), s = setTimeout(g, e), p(u);
    }

    return void 0 === s && (s = setTimeout(g, e)), a;
  }

  return e = X(e) || 0, G(n) && (l = !!n.leading, o = (f = "maxWait" in n) ? xo(X(n.maxWait) || 0, e) : o, h = "trailing" in n ? !!n.trailing : h), _.cancel = function () {
    void 0 !== s && clearTimeout(s), c = 0, r = u = i = s = void 0;
  }, _.flush = function () {
    return void 0 === s ? a : y(bo());
  }, _;
}

var Eo = Object.prototype,
    To = Eo.hasOwnProperty,
    So = _e(function (t, e) {
  t = Object(t);
  var n = -1,
      r = e.length,
      i = r > 2 ? e[2] : void 0;

  for (i && xe(e[0], e[1], i) && (r = 1); ++n < r;) {
    for (var o = e[n], a = en(o), s = -1, u = a.length; ++s < u;) {
      var c = a[s],
          l = t[c];
      (void 0 === l || he(l, Eo[c]) && !To.call(t, c)) && (t[c] = o[c]);
    }
  }

  return t;
});

function Mo(t, e, n) {
  (void 0 === n || he(t[e], n)) && (void 0 !== n || e in t) || fe(t, e, n);
}

function Ao(t) {
  return R(t) && be(t);
}

function ko(t, e) {
  if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
}

function Lo(t) {
  return ve(t, en(t));
}

function Co(t, e, n, r, i) {
  t !== e && co(e, function (o, a) {
    if (i || (i = new Xr()), G(o)) !function (t, e, n, r, i, o, a) {
      var s = ko(t, n),
          u = ko(e, n),
          c = a.get(u);
      if (c) Mo(t, n, c);else {
        var l = o ? o(s, u, n + "", t, e, a) : void 0,
            f = void 0 === l;

        if (f) {
          var h = I(u),
              p = !h && De(u),
              d = !h && !p && Ue(u);
          l = u, h || p || d ? I(s) ? l = s : Ao(s) ? l = Rt(s) : p ? (f = !1, l = ti(u, !0)) : d ? (f = !1, l = Si(u, !0)) : l = [] : Gn(u) || Le(u) ? (l = s, Le(s) ? l = Lo(s) : G(s) && !J(s) || (l = Ai(u))) : f = !1;
        }

        f && (a.set(u, l), i(l, u, r, o, a), a["delete"](u)), Mo(t, n, l);
      }
    }(t, e, a, n, Co, r, i);else {
      var s = r ? r(ko(t, a), o, a + "", t, e, i) : void 0;
      void 0 === s && (s = o), Mo(t, a, s);
    }
  }, en);
}

function Ro(t, e, n, r, i, o) {
  return G(t) && G(e) && (o.set(e, t), Co(t, e, void 0, Ro, o), o["delete"](e)), t;
}

var jo = we(function (t, e, n, r) {
  Co(t, e, n, r);
}),
    Po = _e(function (t) {
  return t.push(void 0, Ro), _t(jo, void 0, t);
});

function Do(t, e, n) {
  if ("function" != typeof t) throw new TypeError("Expected a function");
  return setTimeout(function () {
    t.apply(void 0, n);
  }, e);
}

var Io = _e(function (t, e) {
  return Do(t, 1, e);
}),
    No = _e(function (t, e, n) {
  return Do(t, X(e) || 0, n);
});

function Bo(t, e, n) {
  for (var r = -1, i = null == t ? 0 : t.length; ++r < i;) {
    if (n(e, t[r])) return !0;
  }

  return !1;
}

function Fo(t, e, n, r) {
  var i = -1,
      o = Zt,
      a = !0,
      s = t.length,
      u = [],
      c = e.length;
  if (!s) return u;
  n && (e = D(e, Ne(n))), r ? (o = Bo, a = !1) : e.length >= 200 && (o = Bi, a = !1, e = new Ii(e));

  t: for (; ++i < s;) {
    var l = t[i],
        f = null == n ? l : n(l);

    if (l = r || 0 !== l ? l : 0, a && f == f) {
      for (var h = c; h--;) {
        if (e[h] === f) continue t;
      }

      u.push(l);
    } else o(e, f, r) || u.push(l);
  }

  return u;
}

var zo = _e(function (t, e) {
  return Ao(t) ? Fo(t, Rn(e, 1, Ao, !0)) : [];
});

function Vo(t) {
  var e = null == t ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}

var Go = _e(function (t, e) {
  var n = Vo(e);
  return Ao(n) && (n = void 0), Ao(t) ? Fo(t, Rn(e, 1, Ao, !0), oo(n)) : [];
}),
    Uo = _e(function (t, e) {
  var n = Vo(e);
  return Ao(n) && (n = void 0), Ao(t) ? Fo(t, Rn(e, 1, Ao, !0), void 0, n) : [];
}),
    Ho = z(function (t, e) {
  return t / e;
}, 1);

function Wo(t, e, n, r) {
  for (var i = t.length, o = r ? i : -1; (r ? o-- : ++o < i) && e(t[o], o, t);) {
    ;
  }

  return n ? $n(t, r ? 0 : o, r ? o + 1 : i) : $n(t, r ? o + 1 : 0, r ? i : o);
}

function qo(t) {
  return "function" == typeof t ? t : K;
}

function Yo(t, e) {
  return (I(t) ? qt : ho)(t, qo(e));
}

function Xo(t, e) {
  for (var n = null == t ? 0 : t.length; n-- && !1 !== e(t[n], n, t);) {
    ;
  }

  return t;
}

var $o = uo(!0);

function Zo(t, e) {
  return t && $o(t, e, Ze);
}

var Ko = fo(Zo, !0);

function Jo(t, e) {
  return (I(t) ? Xo : Ko)(t, qo(e));
}

function Qo(t) {
  return function (e) {
    var n = mi(e);
    return "[object Map]" == n ? zi(e) : "[object Set]" == n ? function (t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = [t, t];
      }), n;
    }(e) : function (t, e) {
      return D(e, function (e) {
        return [e, t[e]];
      });
    }(e, t(e));
  };
}

var ta = Qo(Ze),
    ea = Qo(en),
    na = dr({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}),
    ra = /[&<>"']/g,
    ia = RegExp(ra.source);

function oa(t) {
  return (t = On(t)) && ia.test(t) ? t.replace(ra, na) : t;
}

var aa = /[\\^$.*+?()[\]{}|]/g,
    sa = RegExp(aa.source);

function ua(t, e) {
  for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
    if (!e(t[n], n, t)) return !1;
  }

  return !0;
}

function ca(t, e) {
  var n = !0;
  return ho(t, function (t, r, i) {
    return n = !!e(t, r, i);
  }), n;
}

function la(t) {
  return t ? Yr(Z(t), 0, 4294967295) : 0;
}

function fa(t, e) {
  var n = [];
  return ho(t, function (t, r, i) {
    e(t, r, i) && n.push(t);
  }), n;
}

function ha(t) {
  return function (e, n, r) {
    var i = Object(e);

    if (!be(e)) {
      var o = oo(n);
      e = Ze(e), n = function n(t) {
        return o(i[t], t, i);
      };
    }

    var a = t(e, n, r);
    return a > -1 ? i[o ? e[a] : a] : void 0;
  };
}

var pa = Math.max;

function da(t, e, n) {
  var r = null == t ? 0 : t.length;
  if (!r) return -1;
  var i = null == n ? 0 : Z(n);
  return i < 0 && (i = pa(r + i, 0)), Yt(t, oo(e), i);
}

var va = ha(da);

function ga(t, e, n) {
  var r;
  return n(t, function (t, n, i) {
    if (e(t, n, i)) return r = n, !1;
  }), r;
}

var ya = Math.max,
    _a = Math.min;

function ma(t, e, n) {
  var r = null == t ? 0 : t.length;
  if (!r) return -1;
  var i = r - 1;
  return void 0 !== n && (i = Z(n), i = n < 0 ? ya(r + i, 0) : _a(i, r - 1)), Yt(t, oo(e), i, !0);
}

var ba = ha(ma);

function xa(t) {
  return t && t.length ? t[0] : void 0;
}

function wa(t, e) {
  var n = -1,
      r = be(t) ? Array(t.length) : [];
  return ho(t, function (t, i, o) {
    r[++n] = e(t, i, o);
  }), r;
}

function Oa(t, e) {
  return (I(t) ? D : wa)(t, oo(e));
}

var Ea = Gr("floor");

function Ta(t) {
  return Pn(function (e) {
    var n = e.length,
        r = n,
        i = Ct.prototype.thru;

    for (t && e.reverse(); r--;) {
      var o = e[r];
      if ("function" != typeof o) throw new TypeError("Expected a function");
      if (i && !a && "wrapper" == Lt(o)) var a = new Ct([], !0);
    }

    for (r = a ? r : n; ++r < n;) {
      var s = Lt(o = e[r]),
          u = "wrapper" == s ? Mt(o) : void 0;
      a = u && It(u[0]) && 424 == u[1] && !u[4].length && 1 == u[9] ? a[Lt(u[0])].apply(a, u[3]) : 1 == o.length && It(o) ? a[s]() : a.thru(o);
    }

    return function () {
      var t = arguments,
          r = t[0];
      if (a && 1 == t.length && I(r)) return a.plant(r).value();

      for (var i = 0, o = n ? e[i].apply(this, t) : r; ++i < n;) {
        o = e[i].call(this, o);
      }

      return o;
    };
  });
}

var Sa = Ta(),
    Ma = Ta(!0);

function Aa(t, e) {
  return ei(e, function (e) {
    return J(t[e]);
  });
}

var ka = Object.prototype.hasOwnProperty,
    La = vo(function (t, e, n) {
  ka.call(t, n) ? t[n].push(e) : fe(t, n, [e]);
});

function Ca(t, e) {
  return t > e;
}

function Ra(t) {
  return function (e, n) {
    return "string" == typeof e && "string" == typeof n || (e = X(e), n = X(n)), t(e, n);
  };
}

var ja = Ra(Ca),
    Pa = Ra(function (t, e) {
  return t >= e;
}),
    Da = Object.prototype.hasOwnProperty;

function Ia(t, e) {
  return null != t && Da.call(t, e);
}

var Na = Math.max,
    Ba = Math.min;

function Fa(t) {
  return "string" == typeof t || !I(t) && R(t) && "[object String]" == C(t);
}

function za(t, e) {
  return D(e, function (e) {
    return t[e];
  });
}

function Va(t) {
  return null == t ? [] : za(t, Ze(t));
}

var Ga = Math.max;
var Ua = Math.max;
var Ha = Math.min;

function Wa(t, e, n) {
  for (var r = n ? Bo : Zt, i = t[0].length, o = t.length, a = o, s = Array(o), u = 1 / 0, c = []; a--;) {
    var l = t[a];
    a && e && (l = D(l, Ne(e))), u = Ha(l.length, u), s[a] = !n && (e || i >= 120 && l.length >= 120) ? new Ii(a && l) : void 0;
  }

  l = t[0];
  var f = -1,
      h = s[0];

  t: for (; ++f < i && c.length < u;) {
    var p = l[f],
        d = e ? e(p) : p;

    if (p = n || 0 !== p ? p : 0, !(h ? Bi(h, d) : r(c, d, n))) {
      for (a = o; --a;) {
        var v = s[a];
        if (!(v ? Bi(v, d) : r(t[a], d, n))) continue t;
      }

      h && h.push(d), c.push(p);
    }
  }

  return c;
}

function qa(t) {
  return Ao(t) ? t : [];
}

var Ya = _e(function (t) {
  var e = D(t, qa);
  return e.length && e[0] === t[0] ? Wa(e) : [];
}),
    Xa = _e(function (t) {
  var e = Vo(t),
      n = D(t, qa);
  return e === Vo(n) ? e = void 0 : n.pop(), n.length && n[0] === t[0] ? Wa(n, oo(e)) : [];
}),
    $a = _e(function (t) {
  var e = Vo(t),
      n = D(t, qa);
  return (e = "function" == typeof e ? e : void 0) && n.pop(), n.length && n[0] === t[0] ? Wa(n, void 0, e) : [];
});

function Za(t, e) {
  return function (n, r) {
    return function (t, e, n, r) {
      return lo(t, function (t, i, o) {
        e(r, n(t), i, o);
      }), r;
    }(n, t, e(r), {});
  };
}

var Ka = Object.prototype.toString,
    Ja = Za(function (t, e, n) {
  null != e && "function" != typeof e.toString && (e = Ka.call(e)), t[e] = n;
}, Ut(K)),
    Qa = Object.prototype,
    ts = Qa.hasOwnProperty,
    es = Qa.toString,
    ns = Za(function (t, e, n) {
  null != e && "function" != typeof e.toString && (e = es.call(e)), ts.call(t, e) ? t[e].push(n) : t[e] = [n];
}, oo);

function rs(t, e) {
  return e.length < 2 ? t : Sn(t, $n(e, 0, -1));
}

function is(t, e, n) {
  var r = null == (t = rs(t, e = En(e, t))) ? t : t[Tn(Vo(e))];
  return null == r ? void 0 : _t(r, t, n);
}

var os = _e(is),
    as = _e(function (t, e, n) {
  var r = -1,
      i = "function" == typeof e,
      o = be(t) ? Array(t.length) : [];
  return ho(t, function (t) {
    o[++r] = i ? _t(e, t, n) : is(t, e, n);
  }), o;
});

var ss = Ve && Ve.isArrayBuffer,
    us = ss ? Ne(ss) : function (t) {
  return R(t) && "[object ArrayBuffer]" == C(t);
};
var cs = Ve && Ve.isDate,
    ls = cs ? Ne(cs) : function (t) {
  return R(t) && "[object Date]" == C(t);
};
var fs = Object.prototype.hasOwnProperty;
var hs = O.isFinite;

function ps(t) {
  return "number" == typeof t && t == Z(t);
}

function ds(t) {
  return "number" == typeof t || R(t) && "[object Number]" == C(t);
}

var vs = tt ? J : Ce;
var gs = Ve && Ve.isRegExp,
    ys = gs ? Ne(gs) : function (t) {
  return R(t) && "[object RegExp]" == C(t);
};
var _s = Array.prototype.join;
var ms = Br(function (t, e, n) {
  return t + (n ? "-" : "") + e.toLowerCase();
}),
    bs = vo(function (t, e, n) {
  fe(t, n, e);
});
var xs = Math.max,
    ws = Math.min;
var Os = Br(function (t, e, n) {
  return t + (n ? " " : "") + e.toLowerCase();
}),
    Es = lr("toLowerCase");

function Ts(t, e) {
  return t < e;
}

var Ss = Ra(Ts),
    Ms = Ra(function (t, e) {
  return t <= e;
});

function As(t, e, n) {
  for (var r = -1, i = t.length; ++r < i;) {
    var o = t[r],
        a = e(o);
    if (null != a && (void 0 === s ? a == a && !j(a) : n(a, s))) var s = a,
        u = o;
  }

  return u;
}

function ks(t, e) {
  for (var n, r = -1, i = t.length; ++r < i;) {
    var o = e(t[r]);
    void 0 !== o && (n = void 0 === n ? o : n + o);
  }

  return n;
}

function Ls(t, e) {
  var n = null == t ? 0 : t.length;
  return n ? ks(t, e) / n : NaN;
}

var Cs = we(function (t, e, n) {
  Co(t, e, n);
}),
    Rs = _e(function (t, e) {
  return function (n) {
    return is(n, t, e);
  };
}),
    js = _e(function (t, e) {
  return function (n) {
    return is(t, n, e);
  };
});

function Ps(t, e, n) {
  var r = Ze(e),
      i = Aa(e, r),
      o = !(G(n) && "chain" in n && !n.chain),
      a = J(t);
  return qt(i, function (n) {
    var r = e[n];
    t[n] = r, a && (t.prototype[n] = function () {
      var e = this.__chain__;

      if (o || e) {
        var n = t(this.__wrapped__),
            i = n.__actions__ = Rt(this.__actions__);
        return i.push({
          func: r,
          args: arguments,
          thisArg: t
        }), n.__chain__ = e, n;
      }

      return r.apply(t, kn([this.value()], arguments));
    });
  }), t;
}

var Ds = z(function (t, e) {
  return t * e;
}, 1);

function Is(t) {
  if ("function" != typeof t) throw new TypeError("Expected a function");
  return function () {
    var e = arguments;

    switch (e.length) {
      case 0:
        return !t.call(this);

      case 1:
        return !t.call(this, e[0]);

      case 2:
        return !t.call(this, e[0], e[1]);

      case 3:
        return !t.call(this, e[0], e[1], e[2]);
    }

    return !t.apply(this, e);
  };
}

var Ns = E ? E.iterator : void 0;

function Bs(t) {
  if (!t) return [];
  if (be(t)) return Fa(t) ? cr(t) : Rt(t);
  if (Ns && t[Ns]) return function (t) {
    for (var e, n = []; !(e = t.next()).done;) {
      n.push(e.value);
    }

    return n;
  }(t[Ns]());
  var e = mi(t);
  return ("[object Map]" == e ? zi : "[object Set]" == e ? Vi : Va)(t);
}

function Fs(t, e) {
  var n = t.length;
  if (n) return ne(e += e < 0 ? n : 0, n) ? t[e] : void 0;
}

function zs(t, e) {
  return null == (t = rs(t, e = En(e, t))) || delete t[Tn(Vo(e))];
}

function Vs(t) {
  return Gn(t) ? void 0 : t;
}

var Gs = Pn(function (t, e) {
  var n = {};
  if (null == t) return n;
  var r = !1;
  e = D(e, function (e) {
    return e = En(e, t), r || (r = e.length > 1), e;
  }), ve(t, ci(t), n), r && (n = Pi(n, 7, Vs));

  for (var i = e.length; i--;) {
    zs(n, e[i]);
  }

  return n;
});

function Us(t, e, n, r) {
  if (!G(t)) return t;

  for (var i = -1, o = (e = En(e, t)).length, a = o - 1, s = t; null != s && ++i < o;) {
    var u = Tn(e[i]),
        c = n;

    if (i != a) {
      var l = s[u];
      void 0 === (c = r ? r(l, u, s) : void 0) && (c = G(l) ? l : ne(e[i + 1]) ? [] : {});
    }

    de(s, u, c), s = s[u];
  }

  return t;
}

function Hs(t, e, n) {
  for (var r = -1, i = e.length, o = {}; ++r < i;) {
    var a = e[r],
        s = Sn(t, a);
    n(s, a) && Us(o, En(a, t), s);
  }

  return o;
}

function Ws(t, e) {
  if (null == t) return {};
  var n = D(ci(t), function (t) {
    return [t];
  });
  return e = oo(e), Hs(t, n, function (t, n) {
    return e(t, n[0]);
  });
}

function qs(t, e) {
  if (t !== e) {
    var n = void 0 !== t,
        r = null === t,
        i = t == t,
        o = j(t),
        a = void 0 !== e,
        s = null === e,
        u = e == e,
        c = j(e);
    if (!s && !c && !o && t > e || o && a && u && !s && !c || r && a && u || !n && u || !i) return 1;
    if (!r && !o && !c && t < e || c && n && i && !r && !o || s && n && i || !a && i || !u) return -1;
  }

  return 0;
}

function Ys(t, e, n) {
  var r = -1;
  return e = D(e.length ? e : [K], Ne(oo)), function (t, e) {
    var n = t.length;

    for (t.sort(e); n--;) {
      t[n] = t[n].value;
    }

    return t;
  }(wa(t, function (t, n, i) {
    return {
      criteria: D(e, function (e) {
        return e(t);
      }),
      index: ++r,
      value: t
    };
  }), function (t, e) {
    return function (t, e, n) {
      for (var r = -1, i = t.criteria, o = e.criteria, a = i.length, s = n.length; ++r < a;) {
        var u = qs(i[r], o[r]);
        if (u) return r >= s ? u : u * ("desc" == n[r] ? -1 : 1);
      }

      return t.index - e.index;
    }(t, e, n);
  });
}

function Xs(t) {
  return Pn(function (e) {
    return e = D(e, Ne(oo)), _e(function (n) {
      var r = this;
      return t(e, function (t) {
        return _t(t, r, n);
      });
    });
  });
}

var $s = Xs(D),
    Zs = _e,
    Ks = Math.min,
    Js = Zs(function (t, e) {
  var n = (e = 1 == e.length && I(e[0]) ? D(e[0], Ne(oo)) : D(Rn(e, 1), Ne(oo))).length;
  return _e(function (r) {
    for (var i = -1, o = Ks(r.length, n); ++i < o;) {
      r[i] = e[i].call(this, r[i]);
    }

    return _t(t, this, r);
  });
}),
    Qs = Xs(ua),
    tu = Xs(Ni),
    eu = Math.floor;

function nu(t, e) {
  var n = "";
  if (!t || e < 1 || e > 9007199254740991) return n;

  do {
    e % 2 && (n += t), (e = eu(e / 2)) && (t += t);
  } while (e);

  return n;
}

var ru = ro("length"),
    iu = "[\\ud800-\\udfff]",
    ou = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
    au = "\\ud83c[\\udffb-\\udfff]",
    su = "[^\\ud800-\\udfff]",
    uu = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    cu = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    lu = "(?:" + ou + "|" + au + ")" + "?",
    fu = "[\\ufe0e\\ufe0f]?" + lu + ("(?:\\u200d(?:" + [su, uu, cu].join("|") + ")[\\ufe0e\\ufe0f]?" + lu + ")*"),
    hu = "(?:" + [su + ou + "?", ou, uu, cu, iu].join("|") + ")",
    pu = RegExp(au + "(?=" + au + ")|" + hu + fu, "g");

function du(t) {
  return Jn(t) ? function (t) {
    for (var e = pu.lastIndex = 0; pu.test(t);) {
      ++e;
    }

    return e;
  }(t) : ru(t);
}

var vu = Math.ceil;

function gu(t, e) {
  var n = (e = void 0 === e ? " " : F(e)).length;
  if (n < 2) return n ? nu(e, t) : e;
  var r = nu(e, vu(t / du(e)));
  return Jn(e) ? Zn(cr(r), 0, t).join("") : r.slice(0, t);
}

var yu = Math.ceil,
    _u = Math.floor;
var mu = /^\s+/,
    bu = O.parseInt;

var xu = _e(function (t, e) {
  return ce(t, 32, void 0, e, oe(e, te(xu)));
});

xu.placeholder = {};

var wu = _e(function (t, e) {
  return ce(t, 64, void 0, e, oe(e, te(wu)));
});

wu.placeholder = {};
var Ou = vo(function (t, e, n) {
  t[n ? 0 : 1].push(e);
}, function () {
  return [[], []];
});
var Eu = Pn(function (t, e) {
  return null == t ? {} : function (t, e) {
    return Hs(t, e, function (e, n) {
      return eo(t, n);
    });
  }(t, e);
});

function Tu(t, e, n, r) {
  for (var i = n - 1, o = t.length; ++i < o;) {
    if (r(t[i], e)) return i;
  }

  return -1;
}

var Su = Array.prototype.splice;

function Mu(t, e, n, r) {
  var i = r ? Tu : $t,
      o = -1,
      a = e.length,
      s = t;

  for (t === e && (e = Rt(e)), n && (s = D(t, Ne(n))); ++o < a;) {
    for (var u = 0, c = e[o], l = n ? n(c) : c; (u = i(s, l, u, r)) > -1;) {
      s !== t && Su.call(s, u, 1), Su.call(t, u, 1);
    }
  }

  return t;
}

function Au(t, e) {
  return t && t.length && e && e.length ? Mu(t, e) : t;
}

var ku = _e(Au);

var Lu = Array.prototype.splice;

function Cu(t, e) {
  for (var n = t ? e.length : 0, r = n - 1; n--;) {
    var i = e[n];

    if (n == r || i !== o) {
      var o = i;
      ne(i) ? Lu.call(t, i, 1) : zs(t, i);
    }
  }

  return t;
}

var Ru = Pn(function (t, e) {
  var n = null == t ? 0 : t.length,
      r = An(t, e);
  return Cu(t, D(e, function (t) {
    return ne(t, n) ? +t : t;
  }).sort(qs)), r;
}),
    ju = Math.floor,
    Pu = Math.random;

function Du(t, e) {
  return t + ju(Pu() * (e - t + 1));
}

var Iu = parseFloat,
    Nu = Math.min,
    Bu = Math.random;
var Fu = Math.ceil,
    zu = Math.max;

function Vu(t) {
  return function (e, n, r) {
    return r && "number" != typeof r && xe(e, n, r) && (n = r = void 0), e = $(e), void 0 === n ? (n = e, e = 0) : n = $(n), function (t, e, n, r) {
      for (var i = -1, o = zu(Fu((e - t) / (n || 1)), 0), a = Array(o); o--;) {
        a[r ? o : ++i] = t, t += n;
      }

      return a;
    }(e, n, r = void 0 === r ? e < n ? 1 : -1 : $(r), t);
  };
}

var Gu = Vu(),
    Uu = Vu(!0),
    Hu = Pn(function (t, e) {
  return ce(t, 256, void 0, void 0, void 0, e);
});

function Wu(t, e, n, r, i) {
  return i(t, function (t, i, o) {
    n = r ? (r = !1, t) : e(n, t, i, o);
  }), n;
}

function qu(t, e, n, r) {
  var i = null == t ? 0 : t.length;

  for (r && i && (n = t[--i]); i--;) {
    n = e(n, t[i], i, t);
  }

  return n;
}

var Yu = Array.prototype.reverse;

function Xu(t) {
  return null == t ? t : Yu.call(t);
}

var $u = Gr("round");

function Zu(t) {
  var e = t.length;
  return e ? t[Du(0, e - 1)] : void 0;
}

function Ku(t) {
  return Zu(Va(t));
}

function Ju(t, e) {
  var n = -1,
      r = t.length,
      i = r - 1;

  for (e = void 0 === e ? r : e; ++n < e;) {
    var o = Du(n, i),
        a = t[o];
    t[o] = t[n], t[n] = a;
  }

  return t.length = e, t;
}

function Qu(t, e) {
  return Ju(Rt(t), Yr(e, 0, t.length));
}

function tc(t, e) {
  var n = Va(t);
  return Ju(n, Yr(e, 0, n.length));
}

function ec(t) {
  return Ju(Rt(t));
}

function nc(t) {
  return Ju(Va(t));
}

var rc = Br(function (t, e, n) {
  return t + (n ? "_" : "") + e.toLowerCase();
});

function ic(t, e) {
  var n;
  return ho(t, function (t, r, i) {
    return !(n = e(t, r, i));
  }), !!n;
}

var oc = _e(function (t, e) {
  if (null == t) return [];
  var n = e.length;
  return n > 1 && xe(t, e[0], e[1]) ? e = [] : n > 2 && xe(e[0], e[1], e[2]) && (e = [e[0]]), Ys(t, Rn(e, 1), []);
}),
    ac = Math.floor,
    sc = Math.min;

function uc(t, e, n, r) {
  e = n(e);

  for (var i = 0, o = null == t ? 0 : t.length, a = e != e, s = null === e, u = j(e), c = void 0 === e; i < o;) {
    var l = ac((i + o) / 2),
        f = n(t[l]),
        h = void 0 !== f,
        p = null === f,
        d = f == f,
        v = j(f);
    if (a) var g = r || d;else g = c ? d && (r || h) : s ? d && h && (r || !p) : u ? d && h && !p && (r || !v) : !p && !v && (r ? f <= e : f < e);
    g ? i = l + 1 : o = l;
  }

  return sc(o, 4294967294);
}

function cc(t, e, n) {
  var r = 0,
      i = null == t ? r : t.length;

  if ("number" == typeof e && e == e && i <= 2147483647) {
    for (; r < i;) {
      var o = r + i >>> 1,
          a = t[o];
      null !== a && !j(a) && (n ? a <= e : a < e) ? r = o + 1 : i = o;
    }

    return i;
  }

  return uc(t, e, K, n);
}

function lc(t, e) {
  for (var n = -1, r = t.length, i = 0, o = []; ++n < r;) {
    var a = t[n],
        s = e ? e(a) : a;

    if (!n || !he(s, u)) {
      var u = s;
      o[i++] = 0 === a ? 0 : a;
    }
  }

  return o;
}

var fc = Math.max;
var hc = Br(function (t, e, n) {
  return t + (n ? " " : "") + fr(e);
});
var pc = z(function (t, e) {
  return t - e;
}, 0);
var dc = Object.prototype,
    vc = dc.hasOwnProperty;

function gc(t, e, n, r) {
  return void 0 === t || he(t, dc[n]) && !vc.call(r, n) ? e : t;
}

var yc = {
  "\\": "\\",
  "'": "'",
  "\n": "n",
  "\r": "r",
  "\u2028": "u2028",
  "\u2029": "u2029"
};

function _c(t) {
  return "\\" + yc[t];
}

var mc = /<%=([\s\S]+?)%>/g,
    bc = {
  escape: /<%-([\s\S]+?)%>/g,
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: mc,
  variable: "",
  imports: {
    _: {
      escape: oa
    }
  }
},
    xc = /\b__p \+= '';/g,
    wc = /\b(__p \+=) '' \+/g,
    Oc = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
    Ec = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
    Tc = /($^)/,
    Sc = /['\n\r\u2028\u2029\\]/g,
    Mc = Object.prototype.hasOwnProperty;

function Ac(t, e) {
  return e(t);
}

var kc = Math.min;

function Lc(t, e) {
  var n = t;
  return n instanceof Tt && (n = n.value()), pr(e, function (t, e) {
    return e.func.apply(e.thisArg, kn([t], e.args));
  }, n);
}

function Cc() {
  return Lc(this.__wrapped__, this.__actions__);
}

function Rc(t, e) {
  for (var n = t.length; n-- && $t(e, t[n], 0) > -1;) {
    ;
  }

  return n;
}

function jc(t, e) {
  for (var n = -1, r = t.length; ++n < r && $t(e, t[n], 0) > -1;) {
    ;
  }

  return n;
}

var Pc = /^\s+|\s+$/g;
var Dc = /\s+$/;
var Ic = /^\s+/;
var Nc = /\w*$/;
var Bc = dr({
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
}),
    Fc = /&(?:amp|lt|gt|quot|#39);/g,
    zc = RegExp(Fc.source);
var Vc = hi && 1 / Vi(new hi([, -0]))[1] == 1 / 0 ? function (t) {
  return new hi(t);
} : St;

function Gc(t, e, n) {
  var r = -1,
      i = Zt,
      o = t.length,
      a = !0,
      s = [],
      u = s;
  if (n) a = !1, i = Bo;else if (o >= 200) {
    var c = e ? null : Vc(t);
    if (c) return Vi(c);
    a = !1, i = Bi, u = new Ii();
  } else u = e ? [] : s;

  t: for (; ++r < o;) {
    var l = t[r],
        f = e ? e(l) : l;

    if (l = n || 0 !== l ? l : 0, a && f == f) {
      for (var h = u.length; h--;) {
        if (u[h] === f) continue t;
      }

      e && u.push(f), s.push(l);
    } else i(u, f, n) || (u !== s && u.push(f), s.push(l));
  }

  return s;
}

var Uc = _e(function (t) {
  return Gc(Rn(t, 1, Ao, !0));
}),
    Hc = _e(function (t) {
  var e = Vo(t);
  return Ao(e) && (e = void 0), Gc(Rn(t, 1, Ao, !0), oo(e));
}),
    Wc = _e(function (t) {
  var e = Vo(t);
  return e = "function" == typeof e ? e : void 0, Gc(Rn(t, 1, Ao, !0), void 0, e);
});

function qc(t) {
  return t && t.length ? Gc(t) : [];
}

var Yc = 0;
var Xc = Math.max;

function $c(t) {
  if (!t || !t.length) return [];
  var e = 0;
  return t = ei(t, function (t) {
    if (Ao(t)) return e = Xc(t.length, e), !0;
  }), Te(e, function (e) {
    return D(t, ro(e));
  });
}

function Zc(t, e) {
  if (!t || !t.length) return [];
  var n = $c(t);
  return null == e ? n : D(n, function (t) {
    return _t(e, void 0, t);
  });
}

function Kc(t, e, n, r) {
  return Us(t, e, n(Sn(t, e)), r);
}

var Jc = Br(function (t, e, n) {
  return t + (n ? " " : "") + e.toUpperCase();
});

var Qc = _e(function (t, e) {
  return Ao(t) ? Fo(t, e) : [];
});

var tl = Pn(function (t) {
  var e = t.length,
      n = e ? t[0] : 0,
      r = this.__wrapped__,
      i = function i(e) {
    return An(e, t);
  };

  return !(e > 1 || this.__actions__.length) && r instanceof Tt && ne(n) ? ((r = r.slice(n, +n + (e ? 1 : 0))).__actions__.push({
    func: Ac,
    args: [i],
    thisArg: void 0
  }), new Ct(r, this.__chain__).thru(function (t) {
    return e && !t.length && t.push(void 0), t;
  })) : this.thru(i);
});

function el(t, e, n) {
  var r = t.length;
  if (r < 2) return r ? Gc(t[0]) : [];

  for (var i = -1, o = Array(r); ++i < r;) {
    for (var a = t[i], s = -1; ++s < r;) {
      s != i && (o[i] = Fo(o[i] || a, t[s], e, n));
    }
  }

  return Gc(Rn(o, 1), e, n);
}

var nl = _e(function (t) {
  return el(ei(t, Ao));
}),
    rl = _e(function (t) {
  var e = Vo(t);
  return Ao(e) && (e = void 0), el(ei(t, Ao), oo(e));
}),
    il = _e(function (t) {
  var e = Vo(t);
  return e = "function" == typeof e ? e : void 0, el(ei(t, Ao), void 0, e);
}),
    ol = _e($c);

function al(t, e, n) {
  for (var r = -1, i = t.length, o = e.length, a = {}; ++r < i;) {
    var s = r < o ? e[r] : void 0;
    n(a, t[r], s);
  }

  return a;
}

var sl = _e(function (t) {
  var e = t.length,
      n = e > 1 ? t[e - 1] : void 0;
  return n = "function" == typeof n ? (t.pop(), n) : void 0, Zc(t, n);
}),
    ul = {
  chunk: function chunk(t, e, n) {
    e = (n ? xe(t, e, n) : void 0 === e) ? 1 : qr(Z(e), 0);
    var r = null == t ? 0 : t.length;
    if (!r || e < 1) return [];

    for (var i = 0, o = 0, a = Array(Wr(r / e)); i < r;) {
      a[o++] = $n(t, i, i += e);
    }

    return a;
  },
  compact: function compact(t) {
    for (var e = -1, n = null == t ? 0 : t.length, r = 0, i = []; ++e < n;) {
      var o = t[e];
      o && (i[r++] = o);
    }

    return i;
  },
  concat: function concat() {
    var t = arguments.length;
    if (!t) return [];

    for (var e = Array(t - 1), n = arguments[0], r = t; r--;) {
      e[r - 1] = arguments[r];
    }

    return kn(I(n) ? Rt(n) : [n], Rn(e, 1));
  },
  difference: zo,
  differenceBy: Go,
  differenceWith: Uo,
  drop: function drop(t, e, n) {
    var r = null == t ? 0 : t.length;
    return r ? $n(t, (e = n || void 0 === e ? 1 : Z(e)) < 0 ? 0 : e, r) : [];
  },
  dropRight: function dropRight(t, e, n) {
    var r = null == t ? 0 : t.length;
    return r ? $n(t, 0, (e = r - (e = n || void 0 === e ? 1 : Z(e))) < 0 ? 0 : e) : [];
  },
  dropRightWhile: function dropRightWhile(t, e) {
    return t && t.length ? Wo(t, oo(e), !0, !0) : [];
  },
  dropWhile: function dropWhile(t, e) {
    return t && t.length ? Wo(t, oo(e), !0) : [];
  },
  fill: function fill(t, e, n, r) {
    var i = null == t ? 0 : t.length;
    return i ? (n && "number" != typeof n && xe(t, e, n) && (n = 0, r = i), function (t, e, n, r) {
      var i = t.length;

      for ((n = Z(n)) < 0 && (n = -n > i ? 0 : i + n), (r = void 0 === r || r > i ? i : Z(r)) < 0 && (r += i), r = n > r ? 0 : la(r); n < r;) {
        t[n++] = e;
      }

      return t;
    }(t, e, n, r)) : [];
  },
  findIndex: da,
  findLastIndex: ma,
  first: xa,
  flatten: jn,
  flattenDeep: function flattenDeep(t) {
    return (null == t ? 0 : t.length) ? Rn(t, 1 / 0) : [];
  },
  flattenDepth: function flattenDepth(t, e) {
    return (null == t ? 0 : t.length) ? Rn(t, e = void 0 === e ? 1 : Z(e)) : [];
  },
  fromPairs: function fromPairs(t) {
    for (var e = -1, n = null == t ? 0 : t.length, r = {}; ++e < n;) {
      var i = t[e];
      r[i[0]] = i[1];
    }

    return r;
  },
  head: xa,
  indexOf: function indexOf(t, e, n) {
    var r = null == t ? 0 : t.length;
    if (!r) return -1;
    var i = null == n ? 0 : Z(n);
    return i < 0 && (i = Ua(r + i, 0)), $t(t, e, i);
  },
  initial: function initial(t) {
    return (null == t ? 0 : t.length) ? $n(t, 0, -1) : [];
  },
  intersection: Ya,
  intersectionBy: Xa,
  intersectionWith: $a,
  join: function join(t, e) {
    return null == t ? "" : _s.call(t, e);
  },
  last: Vo,
  lastIndexOf: function lastIndexOf(t, e, n) {
    var r = null == t ? 0 : t.length;
    if (!r) return -1;
    var i = r;
    return void 0 !== n && (i = (i = Z(n)) < 0 ? xs(r + i, 0) : ws(i, r - 1)), e == e ? function (t, e, n) {
      for (var r = n + 1; r--;) {
        if (t[r] === e) return r;
      }

      return r;
    }(t, e, i) : Yt(t, Xt, i, !0);
  },
  nth: function nth(t, e) {
    return t && t.length ? Fs(t, Z(e)) : void 0;
  },
  pull: ku,
  pullAll: Au,
  pullAllBy: function pullAllBy(t, e, n) {
    return t && t.length && e && e.length ? Mu(t, e, oo(n)) : t;
  },
  pullAllWith: function pullAllWith(t, e, n) {
    return t && t.length && e && e.length ? Mu(t, e, void 0, n) : t;
  },
  pullAt: Ru,
  remove: function remove(t, e) {
    var n = [];
    if (!t || !t.length) return n;
    var r = -1,
        i = [],
        o = t.length;

    for (e = oo(e); ++r < o;) {
      var a = t[r];
      e(a, r, t) && (n.push(a), i.push(r));
    }

    return Cu(t, i), n;
  },
  reverse: Xu,
  slice: function slice(t, e, n) {
    var r = null == t ? 0 : t.length;
    return r ? (n && "number" != typeof n && xe(t, e, n) ? (e = 0, n = r) : (e = null == e ? 0 : Z(e), n = void 0 === n ? r : Z(n)), $n(t, e, n)) : [];
  },
  sortedIndex: function sortedIndex(t, e) {
    return cc(t, e);
  },
  sortedIndexBy: function sortedIndexBy(t, e, n) {
    return uc(t, e, oo(n));
  },
  sortedIndexOf: function sortedIndexOf(t, e) {
    var n = null == t ? 0 : t.length;

    if (n) {
      var r = cc(t, e);
      if (r < n && he(t[r], e)) return r;
    }

    return -1;
  },
  sortedLastIndex: function sortedLastIndex(t, e) {
    return cc(t, e, !0);
  },
  sortedLastIndexBy: function sortedLastIndexBy(t, e, n) {
    return uc(t, e, oo(n), !0);
  },
  sortedLastIndexOf: function sortedLastIndexOf(t, e) {
    if (null == t ? 0 : t.length) {
      var n = cc(t, e, !0) - 1;
      if (he(t[n], e)) return n;
    }

    return -1;
  },
  sortedUniq: function sortedUniq(t) {
    return t && t.length ? lc(t) : [];
  },
  sortedUniqBy: function sortedUniqBy(t, e) {
    return t && t.length ? lc(t, oo(e)) : [];
  },
  tail: function tail(t) {
    var e = null == t ? 0 : t.length;
    return e ? $n(t, 1, e) : [];
  },
  take: function take(t, e, n) {
    return t && t.length ? $n(t, 0, (e = n || void 0 === e ? 1 : Z(e)) < 0 ? 0 : e) : [];
  },
  takeRight: function takeRight(t, e, n) {
    var r = null == t ? 0 : t.length;
    return r ? $n(t, (e = r - (e = n || void 0 === e ? 1 : Z(e))) < 0 ? 0 : e, r) : [];
  },
  takeRightWhile: function takeRightWhile(t, e) {
    return t && t.length ? Wo(t, oo(e), !1, !0) : [];
  },
  takeWhile: function takeWhile(t, e) {
    return t && t.length ? Wo(t, oo(e)) : [];
  },
  union: Uc,
  unionBy: Hc,
  unionWith: Wc,
  uniq: qc,
  uniqBy: function uniqBy(t, e) {
    return t && t.length ? Gc(t, oo(e)) : [];
  },
  uniqWith: function uniqWith(t, e) {
    return e = "function" == typeof e ? e : void 0, t && t.length ? Gc(t, void 0, e) : [];
  },
  unzip: $c,
  unzipWith: Zc,
  without: Qc,
  xor: nl,
  xorBy: rl,
  xorWith: il,
  zip: ol,
  zipObject: function zipObject(t, e) {
    return al(t || [], e || [], de);
  },
  zipObjectDeep: function zipObjectDeep(t, e) {
    return al(t || [], e || [], Us);
  },
  zipWith: sl
},
    cl = {
  countBy: yo,
  each: Yo,
  eachRight: Jo,
  every: function every(t, e, n) {
    var r = I(t) ? ua : ca;
    return n && xe(t, e, n) && (e = void 0), r(t, oo(e));
  },
  filter: function filter(t, e) {
    return (I(t) ? ei : fa)(t, oo(e));
  },
  find: va,
  findLast: ba,
  flatMap: function flatMap(t, e) {
    return Rn(Oa(t, e), 1);
  },
  flatMapDeep: function flatMapDeep(t, e) {
    return Rn(Oa(t, e), 1 / 0);
  },
  flatMapDepth: function flatMapDepth(t, e, n) {
    return n = void 0 === n ? 1 : Z(n), Rn(Oa(t, e), n);
  },
  forEach: Yo,
  forEachRight: Jo,
  groupBy: La,
  includes: function includes(t, e, n, r) {
    t = be(t) ? t : Va(t), n = n && !r ? Z(n) : 0;
    var i = t.length;
    return n < 0 && (n = Ga(i + n, 0)), Fa(t) ? n <= i && t.indexOf(e, n) > -1 : !!i && $t(t, e, n) > -1;
  },
  invokeMap: as,
  keyBy: bs,
  map: Oa,
  orderBy: function orderBy(t, e, n, r) {
    return null == t ? [] : (I(e) || (e = null == e ? [] : [e]), I(n = r ? void 0 : n) || (n = null == n ? [] : [n]), Ys(t, e, n));
  },
  partition: Ou,
  reduce: function reduce(t, e, n) {
    var r = I(t) ? pr : Wu,
        i = arguments.length < 3;
    return r(t, oo(e), n, i, ho);
  },
  reduceRight: function reduceRight(t, e, n) {
    var r = I(t) ? qu : Wu,
        i = arguments.length < 3;
    return r(t, oo(e), n, i, Ko);
  },
  reject: function reject(t, e) {
    return (I(t) ? ei : fa)(t, Is(oo(e)));
  },
  sample: function sample(t) {
    return (I(t) ? Zu : Ku)(t);
  },
  sampleSize: function sampleSize(t, e, n) {
    return e = (n ? xe(t, e, n) : void 0 === e) ? 1 : Z(e), (I(t) ? Qu : tc)(t, e);
  },
  shuffle: function shuffle(t) {
    return (I(t) ? ec : nc)(t);
  },
  size: function size(t) {
    if (null == t) return 0;
    if (be(t)) return Fa(t) ? du(t) : t.length;
    var e = mi(t);
    return "[object Map]" == e || "[object Set]" == e ? t.size : $e(t).length;
  },
  some: function some(t, e, n) {
    var r = I(t) ? Ni : ic;
    return n && xe(t, e, n) && (e = void 0), r(t, oo(e));
  },
  sortBy: oc
},
    ll = bo,
    fl = {
  after: function after(t, e) {
    if ("function" != typeof e) throw new TypeError("Expected a function");
    return t = Z(t), function () {
      if (--t < 1) return e.apply(this, arguments);
    };
  },
  ary: le,
  before: Wn,
  bind: qn,
  bindKey: Xn,
  curry: _o,
  curryRight: mo,
  debounce: Oo,
  defer: Io,
  delay: No,
  flip: function flip(t) {
    return ce(t, 512);
  },
  memoize: mn,
  negate: Is,
  once: function once(t) {
    return Wn(2, t);
  },
  overArgs: Js,
  partial: xu,
  partialRight: wu,
  rearg: Hu,
  rest: function rest(t, e) {
    if ("function" != typeof t) throw new TypeError("Expected a function");
    return _e(t, e = void 0 === e ? e : Z(e));
  },
  spread: function spread(t, e) {
    if ("function" != typeof t) throw new TypeError("Expected a function");
    return e = null == e ? 0 : fc(Z(e), 0), _e(function (n) {
      var r = n[e],
          i = Zn(n, 0, e);
      return r && kn(i, r), _t(t, this, i);
    });
  },
  throttle: function throttle(t, e, n) {
    var r = !0,
        i = !0;
    if ("function" != typeof t) throw new TypeError("Expected a function");
    return G(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Oo(t, e, {
      leading: r,
      maxWait: e,
      trailing: i
    });
  },
  unary: function unary(t) {
    return le(t, 1);
  },
  wrap: function wrap(t, e) {
    return xu(qo(e), t);
  }
},
    hl = {
  castArray: function castArray() {
    if (!arguments.length) return [];
    var t = arguments[0];
    return I(t) ? t : [t];
  },
  clone: function clone(t) {
    return Pi(t, 4);
  },
  cloneDeep: Di,
  cloneDeepWith: function cloneDeepWith(t, e) {
    return Pi(t, 5, e = "function" == typeof e ? e : void 0);
  },
  cloneWith: function cloneWith(t, e) {
    return Pi(t, 4, e = "function" == typeof e ? e : void 0);
  },
  conformsTo: function conformsTo(t, e) {
    return null == e || ao(t, e, Ze(e));
  },
  eq: he,
  gt: ja,
  gte: Pa,
  isArguments: Le,
  isArray: I,
  isArrayBuffer: us,
  isArrayLike: be,
  isArrayLikeObject: Ao,
  isBoolean: function isBoolean(t) {
    return !0 === t || !1 === t || R(t) && "[object Boolean]" == C(t);
  },
  isBuffer: De,
  isDate: ls,
  isElement: function isElement(t) {
    return R(t) && 1 === t.nodeType && !Gn(t);
  },
  isEmpty: function isEmpty(t) {
    if (null == t) return !0;
    if (be(t) && (I(t) || "string" == typeof t || "function" == typeof t.splice || De(t) || Ue(t) || Le(t))) return !t.length;
    var e = mi(t);
    if ("[object Map]" == e || "[object Set]" == e) return !t.size;
    if (Ee(t)) return !$e(t).length;

    for (var n in t) {
      if (fs.call(t, n)) return !1;
    }

    return !0;
  },
  isEqual: function isEqual(t, e) {
    return Yi(t, e);
  },
  isEqualWith: function isEqualWith(t, e, n) {
    var r = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
    return void 0 === r ? Yi(t, e, void 0, n) : !!r;
  },
  isError: Un,
  isFinite: function isFinite(t) {
    return "number" == typeof t && hs(t);
  },
  isFunction: J,
  isInteger: ps,
  isLength: me,
  isMap: Li,
  isMatch: function isMatch(t, e) {
    return t === e || Xi(t, e, Zi(e));
  },
  isMatchWith: function isMatchWith(t, e, n) {
    return n = "function" == typeof n ? n : void 0, Xi(t, e, Zi(e), n);
  },
  isNaN: function isNaN(t) {
    return ds(t) && t != +t;
  },
  isNative: function isNative(t) {
    if (vs(t)) throw new Error("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
    return lt(t);
  },
  isNil: function isNil(t) {
    return null == t;
  },
  isNull: function isNull(t) {
    return null === t;
  },
  isNumber: ds,
  isObject: G,
  isObjectLike: R,
  isPlainObject: Gn,
  isRegExp: ys,
  isSafeInteger: function isSafeInteger(t) {
    return ps(t) && t >= -9007199254740991 && t <= 9007199254740991;
  },
  isSet: Ri,
  isString: Fa,
  isSymbol: j,
  isTypedArray: Ue,
  isUndefined: function isUndefined(t) {
    return void 0 === t;
  },
  isWeakMap: function isWeakMap(t) {
    return R(t) && "[object WeakMap]" == mi(t);
  },
  isWeakSet: function isWeakSet(t) {
    return R(t) && "[object WeakSet]" == C(t);
  },
  lt: Ss,
  lte: Ms,
  toArray: Bs,
  toFinite: $,
  toInteger: Z,
  toLength: la,
  toNumber: X,
  toPlainObject: Lo,
  toSafeInteger: function toSafeInteger(t) {
    return t ? Yr(Z(t), -9007199254740991, 9007199254740991) : 0 === t ? t : 0;
  },
  toString: On
},
    pl = {
  add: V,
  ceil: Ur,
  divide: Ho,
  floor: Ea,
  max: function max(t) {
    return t && t.length ? As(t, K, Ca) : void 0;
  },
  maxBy: function maxBy(t, e) {
    return t && t.length ? As(t, oo(e), Ca) : void 0;
  },
  mean: function mean(t) {
    return Ls(t, K);
  },
  meanBy: function meanBy(t, e) {
    return Ls(t, oo(e));
  },
  min: function min(t) {
    return t && t.length ? As(t, K, Ts) : void 0;
  },
  minBy: function minBy(t, e) {
    return t && t.length ? As(t, oo(e), Ts) : void 0;
  },
  multiply: Ds,
  round: $u,
  subtract: pc,
  sum: function sum(t) {
    return t && t.length ? ks(t, K) : 0;
  },
  sumBy: function sumBy(t, e) {
    return t && t.length ? ks(t, oo(e)) : 0;
  }
},
    dl = function dl(t, e, n) {
  return void 0 === n && (n = e, e = void 0), void 0 !== n && (n = (n = X(n)) == n ? n : 0), void 0 !== e && (e = (e = X(e)) == e ? e : 0), Yr(X(t), e, n);
},
    vl = function vl(t, e, n) {
  return e = $(e), void 0 === n ? (n = e, e = 0) : n = $(n), function (t, e, n) {
    return t >= Ba(e, n) && t < Na(e, n);
  }(t = X(t), e, n);
},
    gl = function gl(t, e, n) {
  if (n && "boolean" != typeof n && xe(t, e, n) && (e = n = void 0), void 0 === n && ("boolean" == typeof e ? (n = e, e = void 0) : "boolean" == typeof t && (n = t, t = void 0)), void 0 === t && void 0 === e ? (t = 0, e = 1) : (t = $(t), void 0 === e ? (e = t, t = 0) : e = $(e)), t > e) {
    var r = t;
    t = e, e = r;
  }

  if (n || t % 1 || e % 1) {
    var i = Bu();
    return Nu(t + i * (e - t + Iu("1e-" + ((i + "").length - 1))), e);
  }

  return Du(t, e);
},
    yl = {
  assign: Je,
  assignIn: nn,
  assignInWith: rn,
  assignWith: on,
  at: Dn,
  create: function create(t, e) {
    var n = gt(t);
    return null == e ? n : $r(n, e);
  },
  defaults: So,
  defaultsDeep: Po,
  entries: ta,
  entriesIn: ea,
  extend: nn,
  extendWith: rn,
  findKey: function findKey(t, e) {
    return ga(t, oo(e), lo);
  },
  findLastKey: function findLastKey(t, e) {
    return ga(t, oo(e), Zo);
  },
  forIn: function forIn(t, e) {
    return null == t ? t : co(t, qo(e), en);
  },
  forInRight: function forInRight(t, e) {
    return null == t ? t : $o(t, qo(e), en);
  },
  forOwn: function forOwn(t, e) {
    return t && lo(t, qo(e));
  },
  forOwnRight: function forOwnRight(t, e) {
    return t && Zo(t, qo(e));
  },
  functions: function functions(t) {
    return null == t ? [] : Aa(t, Ze(t));
  },
  functionsIn: function functionsIn(t) {
    return null == t ? [] : Aa(t, en(t));
  },
  get: Mn,
  has: function has(t, e) {
    return null != t && to(t, e, Ia);
  },
  hasIn: eo,
  invert: Ja,
  invertBy: ns,
  invoke: os,
  keys: Ze,
  keysIn: en,
  mapKeys: function mapKeys(t, e) {
    var n = {};
    return e = oo(e), lo(t, function (t, r, i) {
      fe(n, e(t, r, i), t);
    }), n;
  },
  mapValues: function mapValues(t, e) {
    var n = {};
    return e = oo(e), lo(t, function (t, r, i) {
      fe(n, r, e(t, r, i));
    }), n;
  },
  merge: Cs,
  mergeWith: jo,
  omit: Gs,
  omitBy: function omitBy(t, e) {
    return Ws(t, Is(oo(e)));
  },
  pick: Eu,
  pickBy: Ws,
  result: function result(t, e, n) {
    var r = -1,
        i = (e = En(e, t)).length;

    for (i || (i = 1, t = void 0); ++r < i;) {
      var o = null == t ? void 0 : t[Tn(e[r])];
      void 0 === o && (r = i, o = n), t = J(o) ? o.call(t) : o;
    }

    return t;
  },
  set: function set(t, e, n) {
    return null == t ? t : Us(t, e, n);
  },
  setWith: function setWith(t, e, n, r) {
    return r = "function" == typeof r ? r : void 0, null == t ? t : Us(t, e, n, r);
  },
  toPairs: ta,
  toPairsIn: ea,
  transform: function transform(t, e, n) {
    var r = I(t),
        i = r || De(t) || Ue(t);

    if (e = oo(e), null == n) {
      var o = t && t.constructor;
      n = i ? r ? new o() : [] : G(t) && J(o) ? gt(In(t)) : {};
    }

    return (i ? qt : lo)(t, function (t, r, i) {
      return e(n, t, r, i);
    }), n;
  },
  unset: function unset(t, e) {
    return null == t || zs(t, e);
  },
  update: function update(t, e, n) {
    return null == t ? t : Kc(t, e, qo(n));
  },
  updateWith: function updateWith(t, e, n, r) {
    return r = "function" == typeof r ? r : void 0, null == t ? t : Kc(t, e, qo(n), r);
  },
  values: Va,
  valuesIn: function valuesIn(t) {
    return null == t ? [] : za(t, en(t));
  }
},
    _l = {
  at: tl,
  chain: Hr,
  commit: function commit() {
    return new Ct(this.value(), this.__chain__);
  },
  lodash: Dt,
  next: function next() {
    void 0 === this.__values__ && (this.__values__ = Bs(this.value()));
    var t = this.__index__ >= this.__values__.length;
    return {
      done: t,
      value: t ? void 0 : this.__values__[this.__index__++]
    };
  },
  plant: function plant(t) {
    for (var e, n = this; n instanceof Et;) {
      var r = jt(n);
      r.__index__ = 0, r.__values__ = void 0, e ? i.__wrapped__ = r : e = r;
      var i = r;
      n = n.__wrapped__;
    }

    return i.__wrapped__ = t, e;
  },
  reverse: function reverse() {
    var t = this.__wrapped__;

    if (t instanceof Tt) {
      var e = t;
      return this.__actions__.length && (e = new Tt(this)), (e = e.reverse()).__actions__.push({
        func: Ac,
        args: [Xu],
        thisArg: void 0
      }), new Ct(e, this.__chain__);
    }

    return this.thru(Xu);
  },
  tap: function tap(t, e) {
    return e(t), t;
  },
  thru: Ac,
  toIterator: function toIterator() {
    return this;
  },
  toJSON: Cc,
  value: Cc,
  valueOf: Cc,
  wrapperChain: function wrapperChain() {
    return Hr(this);
  }
},
    ml = {
  camelCase: Fr,
  capitalize: hr,
  deburr: _r,
  endsWith: function endsWith(t, e, n) {
    t = On(t), e = F(e);
    var r = t.length,
        i = n = void 0 === n ? r : Yr(Z(n), 0, r);
    return (n -= e.length) >= 0 && t.slice(n, i) == e;
  },
  escape: oa,
  escapeRegExp: function escapeRegExp(t) {
    return (t = On(t)) && sa.test(t) ? t.replace(aa, "\\$&") : t;
  },
  kebabCase: ms,
  lowerCase: Os,
  lowerFirst: Es,
  pad: function pad(t, e, n) {
    t = On(t);
    var r = (e = Z(e)) ? du(t) : 0;
    if (!e || r >= e) return t;
    var i = (e - r) / 2;
    return gu(_u(i), n) + t + gu(yu(i), n);
  },
  padEnd: function padEnd(t, e, n) {
    t = On(t);
    var r = (e = Z(e)) ? du(t) : 0;
    return e && r < e ? t + gu(e - r, n) : t;
  },
  padStart: function padStart(t, e, n) {
    t = On(t);
    var r = (e = Z(e)) ? du(t) : 0;
    return e && r < e ? gu(e - r, n) + t : t;
  },
  parseInt: function parseInt(t, e, n) {
    return n || null == e ? e = 0 : e && (e = +e), bu(On(t).replace(mu, ""), e || 0);
  },
  repeat: function repeat(t, e, n) {
    return e = (n ? xe(t, e, n) : void 0 === e) ? 1 : Z(e), nu(On(t), e);
  },
  replace: function replace() {
    var t = arguments,
        e = On(t[0]);
    return t.length < 3 ? e : e.replace(t[1], t[2]);
  },
  snakeCase: rc,
  split: function split(t, e, n) {
    return n && "number" != typeof n && xe(t, e, n) && (e = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (t = On(t)) && ("string" == typeof e || null != e && !ys(e)) && !(e = F(e)) && Jn(t) ? Zn(cr(t), 0, n) : t.split(e, n) : [];
  },
  startCase: hc,
  startsWith: function startsWith(t, e, n) {
    return t = On(t), n = null == n ? 0 : Yr(Z(n), 0, t.length), e = F(e), t.slice(n, n + e.length) == e;
  },
  template: function template(t, e, n) {
    var r = bc.imports._.templateSettings || bc;
    n && xe(t, e, n) && (e = void 0), t = On(t), e = rn({}, e, r, gc);
    var i,
        o,
        a = rn({}, e.imports, r.imports, gc),
        s = Ze(a),
        u = za(a, s),
        c = 0,
        l = e.interpolate || Tc,
        f = "__p += '",
        h = RegExp((e.escape || Tc).source + "|" + l.source + "|" + (l === mc ? Ec : Tc).source + "|" + (e.evaluate || Tc).source + "|$", "g"),
        p = Mc.call(e, "sourceURL") ? "//# sourceURL=" + (e.sourceURL + "").replace(/[\r\n]/g, " ") + "\n" : "";
    t.replace(h, function (e, n, r, a, s, u) {
      return r || (r = a), f += t.slice(c, u).replace(Sc, _c), n && (i = !0, f += "' +\n__e(" + n + ") +\n'"), s && (o = !0, f += "';\n" + s + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), c = u + e.length, e;
    }), f += "';\n";
    var d = Mc.call(e, "variable") && e.variable;
    d || (f = "with (obj) {\n" + f + "\n}\n"), f = (o ? f.replace(xc, "") : f).replace(wc, "$1").replace(Oc, "$1;"), f = "function(" + (d || "obj") + ") {\n" + (d ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
    var v = Hn(function () {
      return Function(s, p + "return " + f).apply(void 0, u);
    });
    if (v.source = f, Un(v)) throw v;
    return v;
  },
  templateSettings: bc,
  toLower: function toLower(t) {
    return On(t).toLowerCase();
  },
  toUpper: function toUpper(t) {
    return On(t).toUpperCase();
  },
  trim: function trim(t, e, n) {
    if ((t = On(t)) && (n || void 0 === e)) return t.replace(Pc, "");
    if (!t || !(e = F(e))) return t;
    var r = cr(t),
        i = cr(e);
    return Zn(r, jc(r, i), Rc(r, i) + 1).join("");
  },
  trimEnd: function trimEnd(t, e, n) {
    if ((t = On(t)) && (n || void 0 === e)) return t.replace(Dc, "");
    if (!t || !(e = F(e))) return t;
    var r = cr(t);
    return Zn(r, 0, Rc(r, cr(e)) + 1).join("");
  },
  trimStart: function trimStart(t, e, n) {
    if ((t = On(t)) && (n || void 0 === e)) return t.replace(Ic, "");
    if (!t || !(e = F(e))) return t;
    var r = cr(t);
    return Zn(r, jc(r, cr(e))).join("");
  },
  truncate: function truncate(t, e) {
    var n = 30,
        r = "...";

    if (G(e)) {
      var i = "separator" in e ? e.separator : i;
      n = "length" in e ? Z(e.length) : n, r = "omission" in e ? F(e.omission) : r;
    }

    var o = (t = On(t)).length;

    if (Jn(t)) {
      var a = cr(t);
      o = a.length;
    }

    if (n >= o) return t;
    var s = n - du(r);
    if (s < 1) return r;
    var u = a ? Zn(a, 0, s).join("") : t.slice(0, s);
    if (void 0 === i) return u + r;

    if (a && (s += u.length - s), ys(i)) {
      if (t.slice(s).search(i)) {
        var c,
            l = u;

        for (i.global || (i = RegExp(i.source, On(Nc.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(l);) {
          var f = c.index;
        }

        u = u.slice(0, void 0 === f ? s : f);
      }
    } else if (t.indexOf(F(i), s) != s) {
      var h = u.lastIndexOf(i);
      h > -1 && (u = u.slice(0, h));
    }

    return u + r;
  },
  unescape: function unescape(t) {
    return (t = On(t)) && zc.test(t) ? t.replace(Fc, Bc) : t;
  },
  upperCase: Jc,
  upperFirst: fr,
  words: Ir
},
    bl = {
  attempt: Hn,
  bindAll: Yn,
  cond: function cond(t) {
    var e = null == t ? 0 : t.length,
        n = oo;
    return t = e ? D(t, function (t) {
      if ("function" != typeof t[1]) throw new TypeError("Expected a function");
      return [n(t[0]), t[1]];
    }) : [], _e(function (n) {
      for (var r = -1; ++r < e;) {
        var i = t[r];
        if (_t(i[0], this, n)) return _t(i[1], this, n);
      }
    });
  },
  conforms: function conforms(t) {
    return function (t) {
      var e = Ze(t);
      return function (n) {
        return ao(n, t, e);
      };
    }(Pi(t, 1));
  },
  constant: Ut,
  defaultTo: function defaultTo(t, e) {
    return null == t || t != t ? e : t;
  },
  flow: Sa,
  flowRight: Ma,
  identity: K,
  iteratee: function iteratee(t) {
    return oo("function" == typeof t ? t : Pi(t, 1));
  },
  matches: function matches(t) {
    return Ji(Pi(t, 1));
  },
  matchesProperty: function matchesProperty(t, e) {
    return no(t, Pi(e, 1));
  },
  method: Rs,
  methodOf: js,
  mixin: Ps,
  noop: St,
  nthArg: function nthArg(t) {
    return t = Z(t), _e(function (e) {
      return Fs(e, t);
    });
  },
  over: $s,
  overEvery: Qs,
  overSome: tu,
  property: io,
  propertyOf: function propertyOf(t) {
    return function (e) {
      return null == t ? void 0 : Sn(t, e);
    };
  },
  range: Gu,
  rangeRight: Uu,
  stubArray: ni,
  stubFalse: Ce,
  stubObject: function stubObject() {
    return {};
  },
  stubString: function stubString() {
    return "";
  },
  stubTrue: function stubTrue() {
    return !0;
  },
  times: function times(t, e) {
    if ((t = Z(t)) < 1 || t > 9007199254740991) return [];
    var n = 4294967295,
        r = kc(t, 4294967295);
    t -= 4294967295;

    for (var i = Te(r, e = qo(e)); ++n < t;) {
      e(n);
    }

    return i;
  },
  toPath: function toPath(t) {
    return I(t) ? D(t, Tn) : j(t) ? [t] : Rt(wn(On(t)));
  },
  uniqueId: function uniqueId(t) {
    var e = ++Yc;
    return On(t) + e;
  }
};

var xl = Math.max,
    wl = Math.min;
var Ol = Math.min;
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var El,
    Tl,
    Sl = Array.prototype,
    Ml = Object.prototype.hasOwnProperty,
    Al = E ? E.iterator : void 0,
    kl = Math.max,
    Ll = Math.min,
    Cl = function (t) {
  return function (e, n, r) {
    if (null == r) {
      var i = G(n),
          o = i && Ze(n),
          a = o && o.length && Aa(n, o);
      (a ? a.length : i) || (r = n, n = e, e = this);
    }

    return t(e, n, r);
  };
}(Ps);

Dt.after = fl.after, Dt.ary = fl.ary, Dt.assign = yl.assign, Dt.assignIn = yl.assignIn, Dt.assignInWith = yl.assignInWith, Dt.assignWith = yl.assignWith, Dt.at = yl.at, Dt.before = fl.before, Dt.bind = fl.bind, Dt.bindAll = bl.bindAll, Dt.bindKey = fl.bindKey, Dt.castArray = hl.castArray, Dt.chain = _l.chain, Dt.chunk = ul.chunk, Dt.compact = ul.compact, Dt.concat = ul.concat, Dt.cond = bl.cond, Dt.conforms = bl.conforms, Dt.constant = bl.constant, Dt.countBy = cl.countBy, Dt.create = yl.create, Dt.curry = fl.curry, Dt.curryRight = fl.curryRight, Dt.debounce = fl.debounce, Dt.defaults = yl.defaults, Dt.defaultsDeep = yl.defaultsDeep, Dt.defer = fl.defer, Dt.delay = fl.delay, Dt.difference = ul.difference, Dt.differenceBy = ul.differenceBy, Dt.differenceWith = ul.differenceWith, Dt.drop = ul.drop, Dt.dropRight = ul.dropRight, Dt.dropRightWhile = ul.dropRightWhile, Dt.dropWhile = ul.dropWhile, Dt.fill = ul.fill, Dt.filter = cl.filter, Dt.flatMap = cl.flatMap, Dt.flatMapDeep = cl.flatMapDeep, Dt.flatMapDepth = cl.flatMapDepth, Dt.flatten = ul.flatten, Dt.flattenDeep = ul.flattenDeep, Dt.flattenDepth = ul.flattenDepth, Dt.flip = fl.flip, Dt.flow = bl.flow, Dt.flowRight = bl.flowRight, Dt.fromPairs = ul.fromPairs, Dt.functions = yl.functions, Dt.functionsIn = yl.functionsIn, Dt.groupBy = cl.groupBy, Dt.initial = ul.initial, Dt.intersection = ul.intersection, Dt.intersectionBy = ul.intersectionBy, Dt.intersectionWith = ul.intersectionWith, Dt.invert = yl.invert, Dt.invertBy = yl.invertBy, Dt.invokeMap = cl.invokeMap, Dt.iteratee = bl.iteratee, Dt.keyBy = cl.keyBy, Dt.keys = Ze, Dt.keysIn = yl.keysIn, Dt.map = cl.map, Dt.mapKeys = yl.mapKeys, Dt.mapValues = yl.mapValues, Dt.matches = bl.matches, Dt.matchesProperty = bl.matchesProperty, Dt.memoize = fl.memoize, Dt.merge = yl.merge, Dt.mergeWith = yl.mergeWith, Dt.method = bl.method, Dt.methodOf = bl.methodOf, Dt.mixin = Cl, Dt.negate = Is, Dt.nthArg = bl.nthArg, Dt.omit = yl.omit, Dt.omitBy = yl.omitBy, Dt.once = fl.once, Dt.orderBy = cl.orderBy, Dt.over = bl.over, Dt.overArgs = fl.overArgs, Dt.overEvery = bl.overEvery, Dt.overSome = bl.overSome, Dt.partial = fl.partial, Dt.partialRight = fl.partialRight, Dt.partition = cl.partition, Dt.pick = yl.pick, Dt.pickBy = yl.pickBy, Dt.property = bl.property, Dt.propertyOf = bl.propertyOf, Dt.pull = ul.pull, Dt.pullAll = ul.pullAll, Dt.pullAllBy = ul.pullAllBy, Dt.pullAllWith = ul.pullAllWith, Dt.pullAt = ul.pullAt, Dt.range = bl.range, Dt.rangeRight = bl.rangeRight, Dt.rearg = fl.rearg, Dt.reject = cl.reject, Dt.remove = ul.remove, Dt.rest = fl.rest, Dt.reverse = ul.reverse, Dt.sampleSize = cl.sampleSize, Dt.set = yl.set, Dt.setWith = yl.setWith, Dt.shuffle = cl.shuffle, Dt.slice = ul.slice, Dt.sortBy = cl.sortBy, Dt.sortedUniq = ul.sortedUniq, Dt.sortedUniqBy = ul.sortedUniqBy, Dt.split = ml.split, Dt.spread = fl.spread, Dt.tail = ul.tail, Dt.take = ul.take, Dt.takeRight = ul.takeRight, Dt.takeRightWhile = ul.takeRightWhile, Dt.takeWhile = ul.takeWhile, Dt.tap = _l.tap, Dt.throttle = fl.throttle, Dt.thru = Ac, Dt.toArray = hl.toArray, Dt.toPairs = yl.toPairs, Dt.toPairsIn = yl.toPairsIn, Dt.toPath = bl.toPath, Dt.toPlainObject = hl.toPlainObject, Dt.transform = yl.transform, Dt.unary = fl.unary, Dt.union = ul.union, Dt.unionBy = ul.unionBy, Dt.unionWith = ul.unionWith, Dt.uniq = ul.uniq, Dt.uniqBy = ul.uniqBy, Dt.uniqWith = ul.uniqWith, Dt.unset = yl.unset, Dt.unzip = ul.unzip, Dt.unzipWith = ul.unzipWith, Dt.update = yl.update, Dt.updateWith = yl.updateWith, Dt.values = yl.values, Dt.valuesIn = yl.valuesIn, Dt.without = ul.without, Dt.words = ml.words, Dt.wrap = fl.wrap, Dt.xor = ul.xor, Dt.xorBy = ul.xorBy, Dt.xorWith = ul.xorWith, Dt.zip = ul.zip, Dt.zipObject = ul.zipObject, Dt.zipObjectDeep = ul.zipObjectDeep, Dt.zipWith = ul.zipWith, Dt.entries = yl.toPairs, Dt.entriesIn = yl.toPairsIn, Dt.extend = yl.assignIn, Dt.extendWith = yl.assignInWith, Cl(Dt, Dt), Dt.add = pl.add, Dt.attempt = bl.attempt, Dt.camelCase = ml.camelCase, Dt.capitalize = ml.capitalize, Dt.ceil = pl.ceil, Dt.clamp = dl, Dt.clone = hl.clone, Dt.cloneDeep = hl.cloneDeep, Dt.cloneDeepWith = hl.cloneDeepWith, Dt.cloneWith = hl.cloneWith, Dt.conformsTo = hl.conformsTo, Dt.deburr = ml.deburr, Dt.defaultTo = bl.defaultTo, Dt.divide = pl.divide, Dt.endsWith = ml.endsWith, Dt.eq = hl.eq, Dt.escape = ml.escape, Dt.escapeRegExp = ml.escapeRegExp, Dt.every = cl.every, Dt.find = cl.find, Dt.findIndex = ul.findIndex, Dt.findKey = yl.findKey, Dt.findLast = cl.findLast, Dt.findLastIndex = ul.findLastIndex, Dt.findLastKey = yl.findLastKey, Dt.floor = pl.floor, Dt.forEach = cl.forEach, Dt.forEachRight = cl.forEachRight, Dt.forIn = yl.forIn, Dt.forInRight = yl.forInRight, Dt.forOwn = yl.forOwn, Dt.forOwnRight = yl.forOwnRight, Dt.get = yl.get, Dt.gt = hl.gt, Dt.gte = hl.gte, Dt.has = yl.has, Dt.hasIn = yl.hasIn, Dt.head = ul.head, Dt.identity = K, Dt.includes = cl.includes, Dt.indexOf = ul.indexOf, Dt.inRange = vl, Dt.invoke = yl.invoke, Dt.isArguments = hl.isArguments, Dt.isArray = I, Dt.isArrayBuffer = hl.isArrayBuffer, Dt.isArrayLike = hl.isArrayLike, Dt.isArrayLikeObject = hl.isArrayLikeObject, Dt.isBoolean = hl.isBoolean, Dt.isBuffer = hl.isBuffer, Dt.isDate = hl.isDate, Dt.isElement = hl.isElement, Dt.isEmpty = hl.isEmpty, Dt.isEqual = hl.isEqual, Dt.isEqualWith = hl.isEqualWith, Dt.isError = hl.isError, Dt.isFinite = hl.isFinite, Dt.isFunction = hl.isFunction, Dt.isInteger = hl.isInteger, Dt.isLength = hl.isLength, Dt.isMap = hl.isMap, Dt.isMatch = hl.isMatch, Dt.isMatchWith = hl.isMatchWith, Dt.isNaN = hl.isNaN, Dt.isNative = hl.isNative, Dt.isNil = hl.isNil, Dt.isNull = hl.isNull, Dt.isNumber = hl.isNumber, Dt.isObject = G, Dt.isObjectLike = hl.isObjectLike, Dt.isPlainObject = hl.isPlainObject, Dt.isRegExp = hl.isRegExp, Dt.isSafeInteger = hl.isSafeInteger, Dt.isSet = hl.isSet, Dt.isString = hl.isString, Dt.isSymbol = hl.isSymbol, Dt.isTypedArray = hl.isTypedArray, Dt.isUndefined = hl.isUndefined, Dt.isWeakMap = hl.isWeakMap, Dt.isWeakSet = hl.isWeakSet, Dt.join = ul.join, Dt.kebabCase = ml.kebabCase, Dt.last = Vo, Dt.lastIndexOf = ul.lastIndexOf, Dt.lowerCase = ml.lowerCase, Dt.lowerFirst = ml.lowerFirst, Dt.lt = hl.lt, Dt.lte = hl.lte, Dt.max = pl.max, Dt.maxBy = pl.maxBy, Dt.mean = pl.mean, Dt.meanBy = pl.meanBy, Dt.min = pl.min, Dt.minBy = pl.minBy, Dt.stubArray = bl.stubArray, Dt.stubFalse = bl.stubFalse, Dt.stubObject = bl.stubObject, Dt.stubString = bl.stubString, Dt.stubTrue = bl.stubTrue, Dt.multiply = pl.multiply, Dt.nth = ul.nth, Dt.noop = bl.noop, Dt.now = ll, Dt.pad = ml.pad, Dt.padEnd = ml.padEnd, Dt.padStart = ml.padStart, Dt.parseInt = ml.parseInt, Dt.random = gl, Dt.reduce = cl.reduce, Dt.reduceRight = cl.reduceRight, Dt.repeat = ml.repeat, Dt.replace = ml.replace, Dt.result = yl.result, Dt.round = pl.round, Dt.sample = cl.sample, Dt.size = cl.size, Dt.snakeCase = ml.snakeCase, Dt.some = cl.some, Dt.sortedIndex = ul.sortedIndex, Dt.sortedIndexBy = ul.sortedIndexBy, Dt.sortedIndexOf = ul.sortedIndexOf, Dt.sortedLastIndex = ul.sortedLastIndex, Dt.sortedLastIndexBy = ul.sortedLastIndexBy, Dt.sortedLastIndexOf = ul.sortedLastIndexOf, Dt.startCase = ml.startCase, Dt.startsWith = ml.startsWith, Dt.subtract = pl.subtract, Dt.sum = pl.sum, Dt.sumBy = pl.sumBy, Dt.template = ml.template, Dt.times = bl.times, Dt.toFinite = hl.toFinite, Dt.toInteger = Z, Dt.toLength = hl.toLength, Dt.toLower = ml.toLower, Dt.toNumber = hl.toNumber, Dt.toSafeInteger = hl.toSafeInteger, Dt.toString = hl.toString, Dt.toUpper = ml.toUpper, Dt.trim = ml.trim, Dt.trimEnd = ml.trimEnd, Dt.trimStart = ml.trimStart, Dt.truncate = ml.truncate, Dt.unescape = ml.unescape, Dt.uniqueId = bl.uniqueId, Dt.upperCase = ml.upperCase, Dt.upperFirst = ml.upperFirst, Dt.each = cl.forEach, Dt.eachRight = cl.forEachRight, Dt.first = ul.head, Cl(Dt, (El = {}, lo(Dt, function (t, e) {
  Ml.call(Dt.prototype, e) || (El[e] = t);
}), El), {
  chain: !1
}), Dt.VERSION = "4.17.15", (Dt.templateSettings = ml.templateSettings).imports._ = Dt, qt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (t) {
  Dt[t].placeholder = Dt;
}), qt(["drop", "take"], function (t, e) {
  Tt.prototype[t] = function (n) {
    n = void 0 === n ? 1 : kl(Z(n), 0);
    var r = this.__filtered__ && !e ? new Tt(this) : this.clone();
    return r.__filtered__ ? r.__takeCount__ = Ll(n, r.__takeCount__) : r.__views__.push({
      size: Ll(n, 4294967295),
      type: t + (r.__dir__ < 0 ? "Right" : "")
    }), r;
  }, Tt.prototype[t + "Right"] = function (e) {
    return this.reverse()[t](e).reverse();
  };
}), qt(["filter", "map", "takeWhile"], function (t, e) {
  var n = e + 1,
      r = 1 == n || 3 == n;

  Tt.prototype[t] = function (t) {
    var e = this.clone();
    return e.__iteratees__.push({
      iteratee: oo(t),
      type: n
    }), e.__filtered__ = e.__filtered__ || r, e;
  };
}), qt(["head", "last"], function (t, e) {
  var n = "take" + (e ? "Right" : "");

  Tt.prototype[t] = function () {
    return this[n](1).value()[0];
  };
}), qt(["initial", "tail"], function (t, e) {
  var n = "drop" + (e ? "" : "Right");

  Tt.prototype[t] = function () {
    return this.__filtered__ ? new Tt(this) : this[n](1);
  };
}), Tt.prototype.compact = function () {
  return this.filter(K);
}, Tt.prototype.find = function (t) {
  return this.filter(t).head();
}, Tt.prototype.findLast = function (t) {
  return this.reverse().find(t);
}, Tt.prototype.invokeMap = _e(function (t, e) {
  return "function" == typeof t ? new Tt(this) : this.map(function (n) {
    return is(n, t, e);
  });
}), Tt.prototype.reject = function (t) {
  return this.filter(Is(oo(t)));
}, Tt.prototype.slice = function (t, e) {
  t = Z(t);
  var n = this;
  return n.__filtered__ && (t > 0 || e < 0) ? new Tt(n) : (t < 0 ? n = n.takeRight(-t) : t && (n = n.drop(t)), void 0 !== e && (n = (e = Z(e)) < 0 ? n.dropRight(-e) : n.take(e - t)), n);
}, Tt.prototype.takeRightWhile = function (t) {
  return this.reverse().takeWhile(t).reverse();
}, Tt.prototype.toArray = function () {
  return this.take(4294967295);
}, lo(Tt.prototype, function (t, e) {
  var n = /^(?:filter|find|map|reject)|While$/.test(e),
      r = /^(?:head|last)$/.test(e),
      i = Dt[r ? "take" + ("last" == e ? "Right" : "") : e],
      o = r || /^find/.test(e);
  i && (Dt.prototype[e] = function () {
    var e = this.__wrapped__,
        a = r ? [1] : arguments,
        s = e instanceof Tt,
        u = a[0],
        c = s || I(e),
        l = function l(t) {
      var e = i.apply(Dt, kn([t], a));
      return r && f ? e[0] : e;
    };

    c && n && "function" == typeof u && 1 != u.length && (s = c = !1);
    var f = this.__chain__,
        h = !!this.__actions__.length,
        p = o && !f,
        d = s && !h;

    if (!o && c) {
      e = d ? e : new Tt(this);
      var v = t.apply(e, a);
      return v.__actions__.push({
        func: Ac,
        args: [l],
        thisArg: void 0
      }), new Ct(v, f);
    }

    return p && d ? t.apply(this, a) : (v = this.thru(l), p ? r ? v.value()[0] : v.value() : v);
  });
}), qt(["pop", "push", "shift", "sort", "splice", "unshift"], function (t) {
  var e = Sl[t],
      n = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
      r = /^(?:pop|shift)$/.test(t);

  Dt.prototype[t] = function () {
    var t = arguments;

    if (r && !this.__chain__) {
      var i = this.value();
      return e.apply(I(i) ? i : [], t);
    }

    return this[n](function (n) {
      return e.apply(I(n) ? n : [], t);
    });
  };
}), lo(Tt.prototype, function (t, e) {
  var n = Dt[e];

  if (n) {
    var r = n.name + "";
    Ml.call(At, r) || (At[r] = []), At[r].push({
      name: e,
      func: n
    });
  }
}), At[ae(void 0, 2).name] = [{
  name: "wrapper",
  func: void 0
}], Tt.prototype.clone = function () {
  var t = new Tt(this.__wrapped__);
  return t.__actions__ = Rt(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = Rt(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = Rt(this.__views__), t;
}, Tt.prototype.reverse = function () {
  if (this.__filtered__) {
    var t = new Tt(this);
    t.__dir__ = -1, t.__filtered__ = !0;
  } else (t = this.clone()).__dir__ *= -1;

  return t;
}, Tt.prototype.value = function () {
  var t = this.__wrapped__.value(),
      e = this.__dir__,
      n = I(t),
      r = e < 0,
      i = n ? t.length : 0,
      o = function (t, e, n) {
    for (var r = -1, i = n.length; ++r < i;) {
      var o = n[r],
          a = o.size;

      switch (o.type) {
        case "drop":
          t += a;
          break;

        case "dropRight":
          e -= a;
          break;

        case "take":
          e = wl(e, t + a);
          break;

        case "takeRight":
          t = xl(t, e - a);
      }
    }

    return {
      start: t,
      end: e
    };
  }(0, i, this.__views__),
      a = o.start,
      s = o.end,
      u = s - a,
      c = r ? s : a - 1,
      l = this.__iteratees__,
      f = l.length,
      h = 0,
      p = Ol(u, this.__takeCount__);

  if (!n || !r && i == u && p == u) return Lc(t, this.__actions__);
  var d = [];

  t: for (; u-- && h < p;) {
    for (var v = -1, g = t[c += e]; ++v < f;) {
      var y = l[v],
          _ = y.iteratee,
          m = y.type,
          b = _(g);

      if (2 == m) g = b;else if (!b) {
        if (1 == m) continue t;
        break t;
      }
    }

    d[h++] = g;
  }

  return d;
}, Dt.prototype.at = _l.at, Dt.prototype.chain = _l.wrapperChain, Dt.prototype.commit = _l.commit, Dt.prototype.next = _l.next, Dt.prototype.plant = _l.plant, Dt.prototype.reverse = _l.reverse, Dt.prototype.toJSON = Dt.prototype.valueOf = Dt.prototype.value = _l.value, Dt.prototype.first = Dt.prototype.head, Al && (Dt.prototype[Al] = _l.toIterator), function (t) {
  t.debounce = Oo, t.clone = Di, t.merge = Cs, t.removeArrayDuplicates = qc, t.getDimensions = function (t) {
    return {
      width: parseFloat(t.style.width.replace("px", "") || t.offsetWidth),
      height: parseFloat(t.style.height.replace("px", "") || t.offsetHeight)
    };
  }, t.getTranslationValues = function (t) {
    var e = t.getAttribute("transform").match(/translate\([0-9]+\.?[0-9]*,[0-9]+\.?[0-9]*\)/);

    if (e[0]) {
      var n = e[0].replace(/translate\(/, "").replace(/\)/, "").split(",");
      return {
        tx: n[0],
        ty: n[1]
      };
    }

    return null;
  }, t.getTranformOffsets = function (t) {
    var e = /\(([^)]+)\)/.exec(t)[1].split(",");
    return {
      x: parseFloat(e[0]),
      y: parseFloat(e[1])
    };
  }, t.capitalizeFirstLetter = function (t) {
    return t[0].toUpperCase() + t.slice(1);
  }, t.convertValueToPercentage = function (t, e) {
    var n = t / e.reduce(function (t, e) {
      return t + e.value;
    }, 0) * 100;
    return n < 1 ? n.toPrecision(1) : Math.floor(n);
  }, t.arrayDifferences = function (t, e) {
    var n = {
      missing: [],
      added: []
    };
    return t.forEach(function (t) {
      -1 === e.indexOf(t) && n.missing.push(t);
    }), e.forEach(function (e) {
      -1 === t.indexOf(e) && n.added.push(e);
    }), n;
  }, t.getDuplicateValues = function (t) {
    var e = [],
        n = [];
    return t.forEach(function (t) {
      -1 !== e.indexOf(t) && -1 === n.indexOf(t) && n.push(t), e.push(t);
    }), n;
  }, t.moveToFront = function (t) {
    return t.each(function () {
      this.parentNode.appendChild(this);
    });
  }, t.getProperty = function (t) {
    for (var e = [], n = 1; n < arguments.length; n++) {
      e[n - 1] = arguments[n];
    }

    var r = t;

    if (r) {
      for (var i = 0, o = e; i < o.length; i++) {
        var a = o[i];
        if (!r[a]) return null;
        r = r[a];
      }

      return r;
    }

    return null;
  }, t.flipSVGCoordinatesBasedOnOrientation = function (t, e) {
    return e === c.HORIZONTAL ? {
      y0: t.x0,
      y1: t.x1,
      x0: t.y0,
      x1: t.y1
    } : t;
  }, t.generateSVGPathString = function (e, n) {
    var r = t.flipSVGCoordinatesBasedOnOrientation(e, n),
        i = r.x0,
        o = r.x1,
        a = r.y0,
        s = r.y1;
    return "M" + i + "," + a + "L" + i + "," + s + "L" + o + "," + s + "L" + o + "," + a + "L" + i + "," + a;
  };
}(Tl || (Tl = {}));
var Rl = {
  position: d.BOTTOM,
  clickable: !0,
  enabled: !0,
  items: {
    status: {
      ACTIVE: 1,
      DISABLED: 0
    },
    horizontalSpace: 12,
    verticalSpace: 24,
    textYOffset: 8
  },
  checkbox: {
    radius: 6.5,
    spaceAfter: 4
  }
},
    jl = {
  x: {
    numberOfTicks: 5
  },
  y: {
    numberOfTicks: 5
  }
},
    Pl = {
  datapoint: {
    horizontalOffset: 10,
    enabled: !0
  },
  title: {
    verticalOffset: .75,
    width: .4
  }
},
    Dl = Tl.merge({}, Pl, {
  gridline: {
    enabled: !0,
    threshold: .25
  }
}),
    Il = Tl.merge({}, Dl, {
  datapoint: {
    verticalOffset: 4
  },
  gridline: {
    enabled: !1
  }
}),
    Nl = {
  addSpaceOnEdges: 1
},
    Bl = {
  width: "100%",
  height: "100%",
  resizable: !0,
  tooltip: Pl,
  legend: Rl,
  style: {
    prefix: "cc"
  }
},
    Fl = Tl.merge({}, Bl, {
  axes: {},
  timeScale: Nl,
  grid: jl,
  tooltip: Dl
}),
    zl = Tl.merge({}, Fl, {
  bars: {
    maxWidth: 16
  },
  timeScale: Tl.merge(Nl, {
    addSpaceOnEdges: 1
  }),
  tooltip: Il
}),
    Vl = Tl.merge({}, zl, {}),
    Gl = Tl.merge({}, zl, {}),
    Ul = Tl.merge({}, zl, {
  bars: Tl.merge({}, zl.bars, {
    dividerSize: 1.5
  })
}),
    Hl = Tl.merge({}, Fl, {
  points: {
    radius: 3,
    filled: !1
  }
}),
    Wl = Tl.merge({}, Fl, {
  points: {
    radius: 4,
    fillOpacity: .3,
    filled: !0
  }
}),
    ql = Tl.merge({}, Bl, {
  pie: {
    radiusOffset: -15,
    innerRadius: 2,
    padAngle: .007,
    hoverArc: {
      outerRadiusOffset: 3
    },
    xOffset: 30,
    yOffset: 20,
    yOffsetCallout: 10,
    callout: {
      minSliceDegree: 5,
      offsetX: 15,
      offsetY: 12,
      horizontalLineLength: 8,
      textMargin: 2
    },
    labels: {
      formatter: null
    }
  }
}),
    Yl = {
  chart: Bl,
  axisChart: Fl,
  simpleBarChart: Vl,
  groupedBarChart: Gl,
  stackedBarChart: Ul,
  lineChart: Hl,
  scatterChart: Wl,
  pieChart: ql,
  donutChart: Tl.merge({}, ql, {
    donut: {
      center: {
        numberFontSize: function numberFontSize(t) {
          return Math.min(t / 100 * 24, 24) + "px";
        },
        titleFontSize: function titleFontSize(t) {
          return Math.min(t / 100 * 15, 15) + "px";
        },
        titleYPosition: function titleYPosition(t) {
          return Math.min(t / 80 * 20, 20);
        },
        numberFormatter: function numberFormatter(t) {
          return Math.floor(t).toLocaleString();
        }
      }
    }
  })
},
    Xl = {
  opacity: {
    unselected: .3,
    selected: 1
  }
},
    $l = {
  "default": {
    duration: 300
  },
  pie_slice_mouseover: {
    duration: 100
  },
  pie_chart_titles: {
    duration: 375
  },
  graph_element_mouseover_fill_update: {
    duration: 100
  },
  graph_element_mouseout_fill_update: {
    duration: 100
  }
},
    Zl = {
  ticks: {
    number: 7,
    rotateIfSmallerThan: 30
  }
},
    Kl = {
  "default": {
    size: 24
  }
},
    Jl = Object.freeze({
  __proto__: null,
  legend: Rl,
  grid: jl,
  baseTooltip: Pl,
  axisChartTooltip: Dl,
  barChartTooltip: Il,
  options: Yl,
  lines: Xl,
  transitions: $l,
  axis: Zl,
  spacers: Kl
});

var Ql = function (t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = {
    10: "#fff0f1",
    20: "#fcd0d3",
    30: "#ffa4a9",
    40: "#ff767c",
    50: "#fb4b53",
    60: "#da1e28",
    70: "#a51920",
    80: "#750e13",
    90: "#570408",
    100: "#2c080a"
  },
      r = {
    10: "#fff0f6",
    20: "#ffcfe1",
    30: "#ffa0c2",
    40: "#fa75a6",
    50: "#ee538b",
    60: "#d12765",
    70: "#a11950",
    80: "#760a3a",
    90: "#57002b",
    100: "#2a0a16"
  },
      i = {
    10: "#f7f1ff",
    20: "#e6d6ff",
    30: "#d0b0ff",
    40: "#bb8eff",
    50: "#a66efa",
    60: "#8a3ffc",
    70: "#6e32c9",
    80: "#4f2196",
    90: "#38146b",
    100: "#1e1033"
  },
      o = {
    10: "#edf4ff",
    20: "#c9deff",
    30: "#97c1ff",
    40: "#6ea6ff",
    50: "#408bfc",
    60: "#0062ff",
    70: "#054ada",
    80: "#0530ad",
    90: "#061f80",
    100: "#051243"
  },
      a = {
    10: "#e3f6ff",
    20: "#b3e6ff",
    30: "#6ccaff",
    40: "#30b0ff",
    50: "#1191e6",
    60: "#0072c3",
    70: "#0058a1",
    80: "#003d73",
    90: "#002b50",
    100: "#07192b"
  },
      s = {
    10: "#dbfbfb",
    20: "#92eeee",
    30: "#20d5d2",
    40: "#00bab6",
    50: "#009c98",
    60: "#007d79",
    70: "#006161",
    80: "#004548",
    90: "#003137",
    100: "#081a1c"
  },
      u = {
    10: "#dafbe4",
    20: "#9deeb2",
    30: "#56d679",
    40: "#3dbb61",
    50: "#24a148",
    60: "#198038",
    70: "#10642a",
    80: "#054719",
    90: "#01330f",
    100: "#081b09"
  },
      c = {
    10: "#f2f4f8",
    20: "#d5d9e0",
    30: "#b9bfc7",
    40: "#9fa5ad",
    50: "#868d95",
    60: "#697077",
    70: "#50565b",
    80: "#373d42",
    90: "#242a2e",
    100: "#13171a"
  },
      l = {
    10: "#f3f3f3",
    20: "#dcdcdc",
    30: "#bebebe",
    40: "#a4a4a4",
    50: "#8c8c8c",
    60: "#6f6f6f",
    70: "#565656",
    80: "#3d3d3d",
    90: "#282828",
    100: "#171717"
  },
      f = {
    10: "#f7f3f1",
    20: "#e0dbda",
    30: "#c1bcbb",
    40: "#a7a2a2",
    50: "#8f8b8b",
    60: "#726e6e",
    70: "#595555",
    80: "#403c3c",
    90: "#2b2828",
    100: "#1a1717"
  },
      h = {
    black: {
      100: "#000000"
    },
    blue: o,
    coolGray: c,
    cyan: a,
    gray: l,
    green: u,
    magenta: r,
    orange: {
      40: "#fc7b1e"
    },
    purple: i,
    red: n,
    teal: s,
    warmGray: f,
    white: {
      0: "#ffffff"
    },
    yellow: {
      20: "#fdd13a"
    }
  };
  e.black = "#000000", e.black100 = "#000000", e.white = "#ffffff", e.white0 = "#ffffff", e.yellow = "#fdd13a", e.yellow20 = "#fdd13a", e.orange = "#fc7b1e", e.orange40 = "#fc7b1e", e.red10 = "#fff0f1", e.red20 = "#fcd0d3", e.red30 = "#ffa4a9", e.red40 = "#ff767c", e.red50 = "#fb4b53", e.red60 = "#da1e28", e.red70 = "#a51920", e.red80 = "#750e13", e.red90 = "#570408", e.red100 = "#2c080a", e.red = n, e.magenta10 = "#fff0f6", e.magenta20 = "#ffcfe1", e.magenta30 = "#ffa0c2", e.magenta40 = "#fa75a6", e.magenta50 = "#ee538b", e.magenta60 = "#d12765", e.magenta70 = "#a11950", e.magenta80 = "#760a3a", e.magenta90 = "#57002b", e.magenta100 = "#2a0a16", e.magenta = r, e.purple10 = "#f7f1ff", e.purple20 = "#e6d6ff", e.purple30 = "#d0b0ff", e.purple40 = "#bb8eff", e.purple50 = "#a66efa", e.purple60 = "#8a3ffc", e.purple70 = "#6e32c9", e.purple80 = "#4f2196", e.purple90 = "#38146b", e.purple100 = "#1e1033", e.purple = i, e.blue10 = "#edf4ff", e.blue20 = "#c9deff", e.blue30 = "#97c1ff", e.blue40 = "#6ea6ff", e.blue50 = "#408bfc", e.blue60 = "#0062ff", e.blue70 = "#054ada", e.blue80 = "#0530ad", e.blue90 = "#061f80", e.blue100 = "#051243", e.blue = o, e.cyan10 = "#e3f6ff", e.cyan20 = "#b3e6ff", e.cyan30 = "#6ccaff", e.cyan40 = "#30b0ff", e.cyan50 = "#1191e6", e.cyan60 = "#0072c3", e.cyan70 = "#0058a1", e.cyan80 = "#003d73", e.cyan90 = "#002b50", e.cyan100 = "#07192b", e.cyan = a, e.teal10 = "#dbfbfb", e.teal20 = "#92eeee", e.teal30 = "#20d5d2", e.teal40 = "#00bab6", e.teal50 = "#009c98", e.teal60 = "#007d79", e.teal70 = "#006161", e.teal80 = "#004548", e.teal90 = "#003137", e.teal100 = "#081a1c", e.teal = s, e.green10 = "#dafbe4", e.green20 = "#9deeb2", e.green30 = "#56d679", e.green40 = "#3dbb61", e.green50 = "#24a148", e.green60 = "#198038", e.green70 = "#10642a", e.green80 = "#054719", e.green90 = "#01330f", e.green100 = "#081b09", e.green = u, e.coolGray10 = "#f2f4f8", e.coolGray20 = "#d5d9e0", e.coolGray30 = "#b9bfc7", e.coolGray40 = "#9fa5ad", e.coolGray50 = "#868d95", e.coolGray60 = "#697077", e.coolGray70 = "#50565b", e.coolGray80 = "#373d42", e.coolGray90 = "#242a2e", e.coolGray100 = "#13171a", e.coolGray = c, e.gray10 = "#f3f3f3", e.gray20 = "#dcdcdc", e.gray30 = "#bebebe", e.gray40 = "#a4a4a4", e.gray50 = "#8c8c8c", e.gray60 = "#6f6f6f", e.gray70 = "#565656", e.gray80 = "#3d3d3d", e.gray90 = "#282828", e.gray100 = "#171717", e.gray = l, e.warmGray10 = "#f7f3f1", e.warmGray20 = "#e0dbda", e.warmGray30 = "#c1bcbb", e.warmGray40 = "#a7a2a2", e.warmGray50 = "#8f8b8b", e.warmGray60 = "#726e6e", e.warmGray70 = "#595555", e.warmGray80 = "#403c3c", e.warmGray90 = "#2b2828", e.warmGray100 = "#1a1717", e.warmGray = f, e.colors = h, e.rgba = function (t, e) {
    var n = [t.substring(1, 3), t.substring(3, 5), t.substring(5, 7)].map(function (t) {
      return parseInt(t, 16);
    });
    return "rgba(".concat(n[0], ", ").concat(n[1], ", ").concat(n[2], ", ").concat(e, ")");
  };
});

!function (t) {
  t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") && t["default"];
}(Ql);
Ql.black, Ql.black100, Ql.white, Ql.white0, Ql.yellow, Ql.yellow20, Ql.orange, Ql.orange40, Ql.red10, Ql.red20, Ql.red30, Ql.red40, Ql.red50, Ql.red60, Ql.red70, Ql.red80, Ql.red90, Ql.red100;

var tf = Ql.red,
    ef = (Ql.magenta10, Ql.magenta20, Ql.magenta30, Ql.magenta40, Ql.magenta50, Ql.magenta60, Ql.magenta70, Ql.magenta80, Ql.magenta90, Ql.magenta100, Ql.magenta),
    nf = (Ql.purple10, Ql.purple20, Ql.purple30, Ql.purple40, Ql.purple50, Ql.purple60, Ql.purple70, Ql.purple80, Ql.purple90, Ql.purple100, Ql.purple),
    rf = (Ql.blue10, Ql.blue20, Ql.blue30, Ql.blue40, Ql.blue50, Ql.blue60, Ql.blue70, Ql.blue80, Ql.blue90, Ql.blue100, Ql.blue),
    of = (Ql.cyan10, Ql.cyan20, Ql.cyan30, Ql.cyan40, Ql.cyan50, Ql.cyan60, Ql.cyan70, Ql.cyan80, Ql.cyan90, Ql.cyan100, Ql.cyan),
    af = (Ql.teal10, Ql.teal20, Ql.teal30, Ql.teal40, Ql.teal50, Ql.teal60, Ql.teal70, Ql.teal80, Ql.teal90, Ql.teal100, Ql.teal),
    sf = (Ql.green10, Ql.green20, Ql.green30, Ql.green40, Ql.green50, Ql.green60, Ql.green70, Ql.green80, Ql.green90, Ql.green100, Ql.green),
    uf = (Ql.coolGray10, Ql.coolGray20, Ql.coolGray30, Ql.coolGray40, Ql.coolGray50, Ql.coolGray60, Ql.coolGray70, Ql.coolGray80, Ql.coolGray90, Ql.coolGray100, Ql.coolGray, Ql.gray10, Ql.gray20, Ql.gray30, Ql.gray40, Ql.gray50, Ql.gray60, Ql.gray70, Ql.gray80, Ql.gray90, Ql.gray100, Ql.gray, Ql.warmGray10, Ql.warmGray20, Ql.warmGray30, Ql.warmGray40, Ql.warmGray50, Ql.warmGray60, Ql.warmGray70, Ql.warmGray80, Ql.warmGray90, Ql.warmGray100, Ql.warmGray, Ql.colors, Ql.rgba, function (t, e) {
  return t[e];
}),
    cf = function cf(t) {
  return uf(rf, t);
},
    lf = function lf(t) {
  return uf(of, t);
},
    ff = function ff(t) {
  return uf(sf, t);
},
    hf = function hf(t) {
  return uf(ef, t);
},
    pf = function pf(t) {
  return uf(nf, t);
},
    df = function df(t) {
  return uf(tf, t);
},
    vf = function vf(t) {
  return uf(af, t);
},
    gf = [pf(70), lf(50), vf(70), hf(70), df(50), df(90), ff(60), cf(80), hf(50), "#b28600", vf(50), lf(90), "#8a3800", pf(50)],
    yf = [pf(60), lf(40), vf(60), hf(40), df(50), df(10), ff(30), cf(50), hf(60), "#d2a106", vf(40), lf(20), "#ba4e00", pf(30)],
    _f = gf,
    mf = yf,
    bf = yf,
    xf = gf,
    wf = Object.freeze({
  __proto__: null,
  WHITE: gf,
  DARK: yf,
  G10: _f,
  G90: mf,
  G100: bf,
  DEFAULT: xf
});

function Of(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}

function Ef(t) {
  var e;
  return 1 === t.length && (e = t, t = function t(_t2, n) {
    return Of(e(_t2), n);
  }), {
    left: function left(e, n, r, i) {
      for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
        var o = r + i >>> 1;
        t(e[o], n) < 0 ? r = o + 1 : i = o;
      }

      return r;
    },
    right: function right(e, n, r, i) {
      for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
        var o = r + i >>> 1;
        t(e[o], n) > 0 ? i = o : r = o + 1;
      }

      return r;
    }
  };
}

var Tf = Ef(Of).right;

function Sf(t, e) {
  var n,
      r,
      i,
      o = t.length,
      a = -1;

  if (null == e) {
    for (; ++a < o;) {
      if (null != (n = t[a]) && n >= n) for (r = i = n; ++a < o;) {
        null != (n = t[a]) && (r > n && (r = n), i < n && (i = n));
      }
    }
  } else for (; ++a < o;) {
    if (null != (n = e(t[a], a, t)) && n >= n) for (r = i = n; ++a < o;) {
      null != (n = e(t[a], a, t)) && (r > n && (r = n), i < n && (i = n));
    }
  }

  return [r, i];
}

function Mf(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;

  for (var r = -1, i = 0 | Math.max(0, Math.ceil((e - t) / n)), o = new Array(i); ++r < i;) {
    o[r] = t + r * n;
  }

  return o;
}

var Af = Math.sqrt(50),
    kf = Math.sqrt(10),
    Lf = Math.sqrt(2);

function Cf(t, e, n) {
  var r,
      i,
      o,
      a,
      s = -1;
  if (n = +n, (t = +t) === (e = +e) && n > 0) return [t];
  if ((r = e < t) && (i = t, t = e, e = i), 0 === (a = Rf(t, e, n)) || !isFinite(a)) return [];
  if (a > 0) for (t = Math.ceil(t / a), e = Math.floor(e / a), o = new Array(i = Math.ceil(e - t + 1)); ++s < i;) {
    o[s] = (t + s) * a;
  } else for (t = Math.floor(t * a), e = Math.ceil(e * a), o = new Array(i = Math.ceil(t - e + 1)); ++s < i;) {
    o[s] = (t - s) / a;
  }
  return r && o.reverse(), o;
}

function Rf(t, e, n) {
  var r = (e - t) / Math.max(0, n),
      i = Math.floor(Math.log(r) / Math.LN10),
      o = r / Math.pow(10, i);
  return i >= 0 ? (o >= Af ? 10 : o >= kf ? 5 : o >= Lf ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (o >= Af ? 10 : o >= kf ? 5 : o >= Lf ? 2 : 1);
}

function jf(t, e, n) {
  var r = Math.abs(e - t) / Math.max(0, n),
      i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
      o = r / i;
  return o >= Af ? i *= 10 : o >= kf ? i *= 5 : o >= Lf && (i *= 2), e < t ? -i : i;
}

function Pf(t, e) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      this.range(t);
      break;

    default:
      this.range(e).domain(t);
  }

  return this;
}

function Df() {}

function If(t, e) {
  var n = new Df();
  if (t instanceof Df) t.each(function (t, e) {
    n.set(e, t);
  });else if (Array.isArray(t)) {
    var r,
        i = -1,
        o = t.length;
    if (null == e) for (; ++i < o;) {
      n.set(i, t[i]);
    } else for (; ++i < o;) {
      n.set(e(r = t[i], i, t), r);
    }
  } else if (t) for (var a in t) {
    n.set(a, t[a]);
  }
  return n;
}

function Nf() {}

Df.prototype = If.prototype = {
  constructor: Df,
  has: function has(t) {
    return "$" + t in this;
  },
  get: function get(t) {
    return this["$" + t];
  },
  set: function set(t, e) {
    return this["$" + t] = e, this;
  },
  remove: function remove(t) {
    var e = "$" + t;
    return e in this && delete this[e];
  },
  clear: function clear() {
    for (var t in this) {
      "$" === t[0] && delete this[t];
    }
  },
  keys: function keys() {
    var t = [];

    for (var e in this) {
      "$" === e[0] && t.push(e.slice(1));
    }

    return t;
  },
  values: function values() {
    var t = [];

    for (var e in this) {
      "$" === e[0] && t.push(this[e]);
    }

    return t;
  },
  entries: function entries() {
    var t = [];

    for (var e in this) {
      "$" === e[0] && t.push({
        key: e.slice(1),
        value: this[e]
      });
    }

    return t;
  },
  size: function size() {
    var t = 0;

    for (var e in this) {
      "$" === e[0] && ++t;
    }

    return t;
  },
  empty: function empty() {
    for (var t in this) {
      if ("$" === t[0]) return !1;
    }

    return !0;
  },
  each: function each(t) {
    for (var e in this) {
      "$" === e[0] && t(this[e], e.slice(1), this);
    }
  }
};
var Bf = If.prototype;

Nf.prototype = function (t, e) {
  var n = new Nf();
  if (t instanceof Nf) t.each(function (t) {
    n.add(t);
  });else if (t) {
    var r = -1,
        i = t.length;
    if (null == e) for (; ++r < i;) {
      n.add(t[r]);
    } else for (; ++r < i;) {
      n.add(e(t[r], r, t));
    }
  }
  return n;
}.prototype = {
  constructor: Nf,
  has: Bf.has,
  add: function add(t) {
    return this["$" + (t += "")] = t, this;
  },
  remove: Bf.remove,
  clear: Bf.clear,
  values: Bf.keys,
  size: Bf.size,
  empty: Bf.empty,
  each: Bf.each
};

var Ff = Array.prototype,
    zf = Ff.map,
    Vf = Ff.slice,
    Gf = {
  name: "implicit"
};

function Uf() {
  var t = If(),
      e = [],
      n = [],
      r = Gf;

  function i(i) {
    var o = i + "",
        a = t.get(o);

    if (!a) {
      if (r !== Gf) return r;
      t.set(o, a = e.push(i));
    }

    return n[(a - 1) % n.length];
  }

  return i.domain = function (n) {
    if (!arguments.length) return e.slice();
    e = [], t = If();

    for (var r, o, a = -1, s = n.length; ++a < s;) {
      t.has(o = (r = n[a]) + "") || t.set(o, e.push(r));
    }

    return i;
  }, i.range = function (t) {
    return arguments.length ? (n = Vf.call(t), i) : n.slice();
  }, i.unknown = function (t) {
    return arguments.length ? (r = t, i) : r;
  }, i.copy = function () {
    return Uf(e, n).unknown(r);
  }, Pf.apply(i, arguments), i;
}

function Hf() {
  var t,
      e,
      n = Uf().unknown(void 0),
      r = n.domain,
      i = n.range,
      o = [0, 1],
      a = !1,
      s = 0,
      u = 0,
      c = .5;

  function l() {
    var n = r().length,
        l = o[1] < o[0],
        f = o[l - 0],
        h = o[1 - l];
    t = (h - f) / Math.max(1, n - s + 2 * u), a && (t = Math.floor(t)), f += (h - f - t * (n - s)) * c, e = t * (1 - s), a && (f = Math.round(f), e = Math.round(e));
    var p = Mf(n).map(function (e) {
      return f + t * e;
    });
    return i(l ? p.reverse() : p);
  }

  return delete n.unknown, n.domain = function (t) {
    return arguments.length ? (r(t), l()) : r();
  }, n.range = function (t) {
    return arguments.length ? (o = [+t[0], +t[1]], l()) : o.slice();
  }, n.rangeRound = function (t) {
    return o = [+t[0], +t[1]], a = !0, l();
  }, n.bandwidth = function () {
    return e;
  }, n.step = function () {
    return t;
  }, n.round = function (t) {
    return arguments.length ? (a = !!t, l()) : a;
  }, n.padding = function (t) {
    return arguments.length ? (s = Math.min(1, u = +t), l()) : s;
  }, n.paddingInner = function (t) {
    return arguments.length ? (s = Math.min(1, t), l()) : s;
  }, n.paddingOuter = function (t) {
    return arguments.length ? (u = +t, l()) : u;
  }, n.align = function (t) {
    return arguments.length ? (c = Math.max(0, Math.min(1, t)), l()) : c;
  }, n.copy = function () {
    return Hf(r(), o).round(a).paddingInner(s).paddingOuter(u).align(c);
  }, Pf.apply(l(), arguments);
}

function Wf(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}

function qf(t, e) {
  var n = Object.create(t.prototype);

  for (var r in e) {
    n[r] = e[r];
  }

  return n;
}

function Yf() {}

var Xf = "\\s*([+-]?\\d+)\\s*",
    $f = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    Zf = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    Kf = /^#([0-9a-f]{3,8})$/,
    Jf = new RegExp("^rgb\\(" + [Xf, Xf, Xf] + "\\)$"),
    Qf = new RegExp("^rgb\\(" + [Zf, Zf, Zf] + "\\)$"),
    th = new RegExp("^rgba\\(" + [Xf, Xf, Xf, $f] + "\\)$"),
    eh = new RegExp("^rgba\\(" + [Zf, Zf, Zf, $f] + "\\)$"),
    nh = new RegExp("^hsl\\(" + [$f, Zf, Zf] + "\\)$"),
    rh = new RegExp("^hsla\\(" + [$f, Zf, Zf, $f] + "\\)$"),
    ih = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};

function oh() {
  return this.rgb().formatHex();
}

function ah() {
  return this.rgb().formatRgb();
}

function sh(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = Kf.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? uh(e) : 3 === n ? new hh(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? new hh(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? new hh(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Jf.exec(t)) ? new hh(e[1], e[2], e[3], 1) : (e = Qf.exec(t)) ? new hh(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = th.exec(t)) ? ch(e[1], e[2], e[3], e[4]) : (e = eh.exec(t)) ? ch(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = nh.exec(t)) ? gh(e[1], e[2] / 100, e[3] / 100, 1) : (e = rh.exec(t)) ? gh(e[1], e[2] / 100, e[3] / 100, e[4]) : ih.hasOwnProperty(t) ? uh(ih[t]) : "transparent" === t ? new hh(NaN, NaN, NaN, 0) : null;
}

function uh(t) {
  return new hh(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
}

function ch(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new hh(t, e, n, r);
}

function lh(t) {
  return t instanceof Yf || (t = sh(t)), t ? new hh((t = t.rgb()).r, t.g, t.b, t.opacity) : new hh();
}

function fh(t, e, n, r) {
  return 1 === arguments.length ? lh(t) : new hh(t, e, n, null == r ? 1 : r);
}

function hh(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}

function ph() {
  return "#" + vh(this.r) + vh(this.g) + vh(this.b);
}

function dh() {
  var t = this.opacity;
  return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
}

function vh(t) {
  return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
}

function gh(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new _h(t, e, n, r);
}

function yh(t) {
  if (t instanceof _h) return new _h(t.h, t.s, t.l, t.opacity);
  if (t instanceof Yf || (t = sh(t)), !t) return new _h();
  if (t instanceof _h) return t;
  var e = (t = t.rgb()).r / 255,
      n = t.g / 255,
      r = t.b / 255,
      i = Math.min(e, n, r),
      o = Math.max(e, n, r),
      a = NaN,
      s = o - i,
      u = (o + i) / 2;
  return s ? (a = e === o ? (n - r) / s + 6 * (n < r) : n === o ? (r - e) / s + 2 : (e - n) / s + 4, s /= u < .5 ? o + i : 2 - o - i, a *= 60) : s = u > 0 && u < 1 ? 0 : a, new _h(a, s, u, t.opacity);
}

function _h(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}

function mh(t, e, n) {
  return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
}

function bh(t) {
  return function () {
    return t;
  };
}

function xh(t) {
  return 1 == (t = +t) ? wh : function (e, n) {
    return n - e ? function (t, e, n) {
      return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
        return Math.pow(t + r * e, n);
      };
    }(e, n, t) : bh(isNaN(e) ? n : e);
  };
}

function wh(t, e) {
  var n = e - t;
  return n ? function (t, e) {
    return function (n) {
      return t + n * e;
    };
  }(t, n) : bh(isNaN(t) ? e : t);
}

Wf(Yf, sh, {
  copy: function copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: oh,
  formatHex: oh,
  formatHsl: function formatHsl() {
    return yh(this).formatHsl();
  },
  formatRgb: ah,
  toString: ah
}), Wf(hh, fh, qf(Yf, {
  brighter: function brighter(t) {
    return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new hh(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker: function darker(t) {
    return t = null == t ? .7 : Math.pow(.7, t), new hh(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: ph,
  formatHex: ph,
  formatRgb: dh,
  toString: dh
})), Wf(_h, function (t, e, n, r) {
  return 1 === arguments.length ? yh(t) : new _h(t, e, n, null == r ? 1 : r);
}, qf(Yf, {
  brighter: function brighter(t) {
    return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new _h(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function darker(t) {
    return t = null == t ? .7 : Math.pow(.7, t), new _h(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function rgb() {
    var t = this.h % 360 + 360 * (this.h < 0),
        e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
        n = this.l,
        r = n + (n < .5 ? n : 1 - n) * e,
        i = 2 * n - r;
    return new hh(mh(t >= 240 ? t - 240 : t + 120, i, r), mh(t, i, r), mh(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var t = this.opacity;
    return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
  }
}));

var Oh = function t(e) {
  var n = xh(e);

  function r(t, e) {
    var r = n((t = fh(t)).r, (e = fh(e)).r),
        i = n(t.g, e.g),
        o = n(t.b, e.b),
        a = wh(t.opacity, e.opacity);
    return function (e) {
      return t.r = r(e), t.g = i(e), t.b = o(e), t.opacity = a(e), t + "";
    };
  }

  return r.gamma = t, r;
}(1);

function Eh(t, e) {
  e || (e = []);
  var n,
      r = t ? Math.min(e.length, t.length) : 0,
      i = e.slice();
  return function (o) {
    for (n = 0; n < r; ++n) {
      i[n] = t[n] * (1 - o) + e[n] * o;
    }

    return i;
  };
}

function Th(t, e) {
  var n,
      r = e ? e.length : 0,
      i = t ? Math.min(r, t.length) : 0,
      o = new Array(i),
      a = new Array(r);

  for (n = 0; n < i; ++n) {
    o[n] = Rh(t[n], e[n]);
  }

  for (; n < r; ++n) {
    a[n] = e[n];
  }

  return function (t) {
    for (n = 0; n < i; ++n) {
      a[n] = o[n](t);
    }

    return a;
  };
}

function Sh(t, e) {
  var n = new Date();
  return t = +t, e = +e, function (r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}

function Mh(t, e) {
  return t = +t, e = +e, function (n) {
    return t * (1 - n) + e * n;
  };
}

function Ah(t, e) {
  var n,
      r = {},
      i = {};

  for (n in null !== t && "object" == typeof t || (t = {}), null !== e && "object" == typeof e || (e = {}), e) {
    n in t ? r[n] = Rh(t[n], e[n]) : i[n] = e[n];
  }

  return function (t) {
    for (n in r) {
      i[n] = r[n](t);
    }

    return i;
  };
}

var kh = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    Lh = new RegExp(kh.source, "g");

function Ch(t, e) {
  var n,
      r,
      i,
      o = kh.lastIndex = Lh.lastIndex = 0,
      a = -1,
      s = [],
      u = [];

  for (t += "", e += ""; (n = kh.exec(t)) && (r = Lh.exec(e));) {
    (i = r.index) > o && (i = e.slice(o, i), s[a] ? s[a] += i : s[++a] = i), (n = n[0]) === (r = r[0]) ? s[a] ? s[a] += r : s[++a] = r : (s[++a] = null, u.push({
      i: a,
      x: Mh(n, r)
    })), o = Lh.lastIndex;
  }

  return o < e.length && (i = e.slice(o), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? u[0] ? function (t) {
    return function (e) {
      return t(e) + "";
    };
  }(u[0].x) : function (t) {
    return function () {
      return t;
    };
  }(e) : (e = u.length, function (t) {
    for (var n, r = 0; r < e; ++r) {
      s[(n = u[r]).i] = n.x(t);
    }

    return s.join("");
  });
}

function Rh(t, e) {
  var n,
      r = typeof e;
  return null == e || "boolean" === r ? bh(e) : ("number" === r ? Mh : "string" === r ? (n = sh(e)) ? (e = n, Oh) : Ch : e instanceof sh ? Oh : e instanceof Date ? Sh : function (t) {
    return ArrayBuffer.isView(t) && !(t instanceof DataView);
  }(e) ? Eh : Array.isArray(e) ? Th : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? Ah : Mh)(t, e);
}

function jh(t, e) {
  return t = +t, e = +e, function (n) {
    return Math.round(t * (1 - n) + e * n);
  };
}

var Ph,
    Dh,
    Ih,
    Nh,
    Bh = 180 / Math.PI,
    Fh = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

function zh(t, e, n, r, i, o) {
  var a, s, u;
  return (a = Math.sqrt(t * t + e * e)) && (t /= a, e /= a), (u = t * n + e * r) && (n -= t * u, r -= e * u), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, u /= s), t * r < e * n && (t = -t, e = -e, u = -u, a = -a), {
    translateX: i,
    translateY: o,
    rotate: Math.atan2(e, t) * Bh,
    skewX: Math.atan(u) * Bh,
    scaleX: a,
    scaleY: s
  };
}

function Vh(t, e, n, r) {
  function i(t) {
    return t.length ? t.pop() + " " : "";
  }

  return function (o, a) {
    var s = [],
        u = [];
    return o = t(o), a = t(a), function (t, r, i, o, a, s) {
      if (t !== i || r !== o) {
        var u = a.push("translate(", null, e, null, n);
        s.push({
          i: u - 4,
          x: Mh(t, i)
        }, {
          i: u - 2,
          x: Mh(r, o)
        });
      } else (i || o) && a.push("translate(" + i + e + o + n);
    }(o.translateX, o.translateY, a.translateX, a.translateY, s, u), function (t, e, n, o) {
      t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), o.push({
        i: n.push(i(n) + "rotate(", null, r) - 2,
        x: Mh(t, e)
      })) : e && n.push(i(n) + "rotate(" + e + r);
    }(o.rotate, a.rotate, s, u), function (t, e, n, o) {
      t !== e ? o.push({
        i: n.push(i(n) + "skewX(", null, r) - 2,
        x: Mh(t, e)
      }) : e && n.push(i(n) + "skewX(" + e + r);
    }(o.skewX, a.skewX, s, u), function (t, e, n, r, o, a) {
      if (t !== n || e !== r) {
        var s = o.push(i(o) + "scale(", null, ",", null, ")");
        a.push({
          i: s - 4,
          x: Mh(t, n)
        }, {
          i: s - 2,
          x: Mh(e, r)
        });
      } else 1 === n && 1 === r || o.push(i(o) + "scale(" + n + "," + r + ")");
    }(o.scaleX, o.scaleY, a.scaleX, a.scaleY, s, u), o = a = null, function (t) {
      for (var e, n = -1, r = u.length; ++n < r;) {
        s[(e = u[n]).i] = e.x(t);
      }

      return s.join("");
    };
  };
}

var Gh = Vh(function (t) {
  return "none" === t ? Fh : (Ph || (Ph = document.createElement("DIV"), Dh = document.documentElement, Ih = document.defaultView), Ph.style.transform = t, t = Ih.getComputedStyle(Dh.appendChild(Ph), null).getPropertyValue("transform"), Dh.removeChild(Ph), zh(+(t = t.slice(7, -1).split(","))[0], +t[1], +t[2], +t[3], +t[4], +t[5]));
}, "px, ", "px)", "deg)"),
    Uh = Vh(function (t) {
  return null == t ? Fh : (Nh || (Nh = document.createElementNS("http://www.w3.org/2000/svg", "g")), Nh.setAttribute("transform", t), (t = Nh.transform.baseVal.consolidate()) ? zh((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : Fh);
}, ", ", ")", ")");

function Hh(t) {
  return +t;
}

var Wh = [0, 1];

function qh(t) {
  return t;
}

function Yh(t, e) {
  return (e -= t = +t) ? function (n) {
    return (n - t) / e;
  } : function (t) {
    return function () {
      return t;
    };
  }(isNaN(e) ? NaN : .5);
}

function Xh(t) {
  var e,
      n = t[0],
      r = t[t.length - 1];
  return n > r && (e = n, n = r, r = e), function (t) {
    return Math.max(n, Math.min(r, t));
  };
}

function $h(t, e, n) {
  var r = t[0],
      i = t[1],
      o = e[0],
      a = e[1];
  return i < r ? (r = Yh(i, r), o = n(a, o)) : (r = Yh(r, i), o = n(o, a)), function (t) {
    return o(r(t));
  };
}

function Zh(t, e, n) {
  var r = Math.min(t.length, e.length) - 1,
      i = new Array(r),
      o = new Array(r),
      a = -1;

  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++a < r;) {
    i[a] = Yh(t[a], t[a + 1]), o[a] = n(e[a], e[a + 1]);
  }

  return function (e) {
    var n = Tf(t, e, 1, r) - 1;
    return o[n](i[n](e));
  };
}

function Kh(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}

function Jh() {
  var t,
      e,
      n,
      r,
      i,
      o,
      a = Wh,
      s = Wh,
      u = Rh,
      c = qh;

  function l() {
    return r = Math.min(a.length, s.length) > 2 ? Zh : $h, i = o = null, f;
  }

  function f(e) {
    return isNaN(e = +e) ? n : (i || (i = r(a.map(t), s, u)))(t(c(e)));
  }

  return f.invert = function (n) {
    return c(e((o || (o = r(s, a.map(t), Mh)))(n)));
  }, f.domain = function (t) {
    return arguments.length ? (a = zf.call(t, Hh), c === qh || (c = Xh(a)), l()) : a.slice();
  }, f.range = function (t) {
    return arguments.length ? (s = Vf.call(t), l()) : s.slice();
  }, f.rangeRound = function (t) {
    return s = Vf.call(t), u = jh, l();
  }, f.clamp = function (t) {
    return arguments.length ? (c = t ? Xh(a) : qh, f) : c !== qh;
  }, f.interpolate = function (t) {
    return arguments.length ? (u = t, l()) : u;
  }, f.unknown = function (t) {
    return arguments.length ? (n = t, f) : n;
  }, function (n, r) {
    return t = n, e = r, l();
  };
}

function Qh(t, e) {
  return Jh()(t, e);
}

function tp(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n,
      r = t.slice(0, n);
  return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
}

function ep(t) {
  return (t = tp(Math.abs(t))) ? t[1] : NaN;
}

var np,
    rp = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function ip(t) {
  if (!(e = rp.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new op({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}

function op(t) {
  this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
}

function ap(t, e) {
  var n = tp(t, e);
  if (!n) return t + "";
  var r = n[0],
      i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}

ip.prototype = op.prototype, op.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
};
var sp = {
  "%": function _(t, e) {
    return (100 * t).toFixed(e);
  },
  b: function b(t) {
    return Math.round(t).toString(2);
  },
  c: function c(t) {
    return t + "";
  },
  d: function d(t) {
    return Math.round(t).toString(10);
  },
  e: function e(t, _e2) {
    return t.toExponential(_e2);
  },
  f: function f(t, e) {
    return t.toFixed(e);
  },
  g: function g(t, e) {
    return t.toPrecision(e);
  },
  o: function o(t) {
    return Math.round(t).toString(8);
  },
  p: function p(t, e) {
    return ap(100 * t, e);
  },
  r: ap,
  s: function s(t, e) {
    var n = tp(t, e);
    if (!n) return t + "";
    var r = n[0],
        i = n[1],
        o = i - (np = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
        a = r.length;
    return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + tp(t, Math.max(0, e + o - 1))[0];
  },
  X: function X(t) {
    return Math.round(t).toString(16).toUpperCase();
  },
  x: function x(t) {
    return Math.round(t).toString(16);
  }
};

function up(t) {
  return t;
}

var cp,
    lp,
    fp,
    hp = Array.prototype.map,
    pp = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

function dp(t) {
  var e,
      n,
      r = void 0 === t.grouping || void 0 === t.thousands ? up : (e = hp.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
    for (var i = t.length, o = [], a = 0, s = e[0], u = 0; i > 0 && s > 0 && (u + s + 1 > r && (s = Math.max(1, r - u)), o.push(t.substring(i -= s, i + s)), !((u += s + 1) > r));) {
      s = e[a = (a + 1) % e.length];
    }

    return o.reverse().join(n);
  }),
      i = void 0 === t.currency ? "" : t.currency[0] + "",
      o = void 0 === t.currency ? "" : t.currency[1] + "",
      a = void 0 === t.decimal ? "." : t.decimal + "",
      s = void 0 === t.numerals ? up : function (t) {
    return function (e) {
      return e.replace(/[0-9]/g, function (e) {
        return t[+e];
      });
    };
  }(hp.call(t.numerals, String)),
      u = void 0 === t.percent ? "%" : t.percent + "",
      c = void 0 === t.minus ? "-" : t.minus + "",
      l = void 0 === t.nan ? "NaN" : t.nan + "";

  function f(t) {
    var e = (t = ip(t)).fill,
        n = t.align,
        f = t.sign,
        h = t.symbol,
        p = t.zero,
        d = t.width,
        v = t.comma,
        g = t.precision,
        y = t.trim,
        _ = t.type;
    "n" === _ ? (v = !0, _ = "g") : sp[_] || (void 0 === g && (g = 12), y = !0, _ = "g"), (p || "0" === e && "=" === n) && (p = !0, e = "0", n = "=");
    var m = "$" === h ? i : "#" === h && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "",
        b = "$" === h ? o : /[%p]/.test(_) ? u : "",
        x = sp[_],
        w = /[defgprs%]/.test(_);

    function O(t) {
      var i,
          o,
          u,
          h = m,
          O = b;
      if ("c" === _) O = x(t) + O, t = "";else {
        var E = (t = +t) < 0;
        if (t = isNaN(t) ? l : x(Math.abs(t), g), y && (t = function (t) {
          t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) {
            switch (t[r]) {
              case ".":
                i = e = r;
                break;

              case "0":
                0 === i && (i = r), e = r;
                break;

              default:
                if (!+t[r]) break t;
                i > 0 && (i = 0);
            }
          }

          return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
        }(t)), E && 0 == +t && (E = !1), h = (E ? "(" === f ? f : c : "-" === f || "(" === f ? "" : f) + h, O = ("s" === _ ? pp[8 + np / 3] : "") + O + (E && "(" === f ? ")" : ""), w) for (i = -1, o = t.length; ++i < o;) {
          if (48 > (u = t.charCodeAt(i)) || u > 57) {
            O = (46 === u ? a + t.slice(i + 1) : t.slice(i)) + O, t = t.slice(0, i);
            break;
          }
        }
      }
      v && !p && (t = r(t, 1 / 0));
      var T = h.length + t.length + O.length,
          S = T < d ? new Array(d - T + 1).join(e) : "";

      switch (v && p && (t = r(S + t, S.length ? d - O.length : 1 / 0), S = ""), n) {
        case "<":
          t = h + t + O + S;
          break;

        case "=":
          t = h + S + t + O;
          break;

        case "^":
          t = S.slice(0, T = S.length >> 1) + h + t + O + S.slice(T);
          break;

        default:
          t = S + h + t + O;
      }

      return s(t);
    }

    return g = void 0 === g ? 6 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g)), O.toString = function () {
      return t + "";
    }, O;
  }

  return {
    format: f,
    formatPrefix: function formatPrefix(t, e) {
      var n = f(((t = ip(t)).type = "f", t)),
          r = 3 * Math.max(-8, Math.min(8, Math.floor(ep(e) / 3))),
          i = Math.pow(10, -r),
          o = pp[8 + r / 3];
      return function (t) {
        return n(i * t) + o;
      };
    }
  };
}

function vp(t, e, n, r) {
  var i,
      o = jf(t, e, n);

  switch ((r = ip(null == r ? ",f" : r)).type) {
    case "s":
      var a = Math.max(Math.abs(t), Math.abs(e));
      return null != r.precision || isNaN(i = function (t, e) {
        return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(ep(e) / 3))) - ep(Math.abs(t)));
      }(o, a)) || (r.precision = i), fp(r, a);

    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      null != r.precision || isNaN(i = function (t, e) {
        return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, ep(e) - ep(t)) + 1;
      }(o, Math.max(Math.abs(t), Math.abs(e)))) || (r.precision = i - ("e" === r.type));
      break;

    case "f":
    case "%":
      null != r.precision || isNaN(i = function (t) {
        return Math.max(0, -ep(Math.abs(t)));
      }(o)) || (r.precision = i - 2 * ("%" === r.type));
  }

  return lp(r);
}

function gp(t) {
  var e = t.domain;
  return t.ticks = function (t) {
    var n = e();
    return Cf(n[0], n[n.length - 1], null == t ? 10 : t);
  }, t.tickFormat = function (t, n) {
    var r = e();
    return vp(r[0], r[r.length - 1], null == t ? 10 : t, n);
  }, t.nice = function (n) {
    null == n && (n = 10);
    var r,
        i = e(),
        o = 0,
        a = i.length - 1,
        s = i[o],
        u = i[a];
    return u < s && (r = s, s = u, u = r, r = o, o = a, a = r), (r = Rf(s, u, n)) > 0 ? r = Rf(s = Math.floor(s / r) * r, u = Math.ceil(u / r) * r, n) : r < 0 && (r = Rf(s = Math.ceil(s * r) / r, u = Math.floor(u * r) / r, n)), r > 0 ? (i[o] = Math.floor(s / r) * r, i[a] = Math.ceil(u / r) * r, e(i)) : r < 0 && (i[o] = Math.ceil(s * r) / r, i[a] = Math.floor(u * r) / r, e(i)), t;
  }, t;
}

function yp(t, e) {
  var n,
      r = 0,
      i = (t = t.slice()).length - 1,
      o = t[r],
      a = t[i];
  return a < o && (n = r, r = i, i = n, n = o, o = a, a = n), t[r] = e.floor(o), t[i] = e.ceil(a), t;
}

function _p(t) {
  return Math.log(t);
}

function mp(t) {
  return Math.exp(t);
}

function bp(t) {
  return -Math.log(-t);
}

function xp(t) {
  return -Math.exp(-t);
}

function wp(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}

function Op(t) {
  return function (e) {
    return -t(-e);
  };
}

function Ep(t) {
  var e,
      n,
      r = t(_p, mp),
      i = r.domain,
      o = 10;

  function a() {
    return e = function (t) {
      return t === Math.E ? Math.log : 10 === t && Math.log10 || 2 === t && Math.log2 || (t = Math.log(t), function (e) {
        return Math.log(e) / t;
      });
    }(o), n = function (t) {
      return 10 === t ? wp : t === Math.E ? Math.exp : function (e) {
        return Math.pow(t, e);
      };
    }(o), i()[0] < 0 ? (e = Op(e), n = Op(n), t(bp, xp)) : t(_p, mp), r;
  }

  return r.base = function (t) {
    return arguments.length ? (o = +t, a()) : o;
  }, r.domain = function (t) {
    return arguments.length ? (i(t), a()) : i();
  }, r.ticks = function (t) {
    var r,
        a = i(),
        s = a[0],
        u = a[a.length - 1];
    (r = u < s) && (h = s, s = u, u = h);
    var c,
        l,
        f,
        h = e(s),
        p = e(u),
        d = null == t ? 10 : +t,
        v = [];

    if (!(o % 1) && p - h < d) {
      if (h = Math.round(h) - 1, p = Math.round(p) + 1, s > 0) {
        for (; h < p; ++h) {
          for (l = 1, c = n(h); l < o; ++l) {
            if (!((f = c * l) < s)) {
              if (f > u) break;
              v.push(f);
            }
          }
        }
      } else for (; h < p; ++h) {
        for (l = o - 1, c = n(h); l >= 1; --l) {
          if (!((f = c * l) < s)) {
            if (f > u) break;
            v.push(f);
          }
        }
      }
    } else v = Cf(h, p, Math.min(p - h, d)).map(n);

    return r ? v.reverse() : v;
  }, r.tickFormat = function (t, i) {
    if (null == i && (i = 10 === o ? ".0e" : ","), "function" != typeof i && (i = lp(i)), t === 1 / 0) return i;
    null == t && (t = 10);
    var a = Math.max(1, o * t / r.ticks().length);
    return function (t) {
      var r = t / n(Math.round(e(t)));
      return r * o < o - .5 && (r *= o), r <= a ? i(t) : "";
    };
  }, r.nice = function () {
    return i(yp(i(), {
      floor: function floor(t) {
        return n(Math.floor(e(t)));
      },
      ceil: function ceil(t) {
        return n(Math.ceil(e(t)));
      }
    }));
  }, r;
}

cp = dp({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
}), lp = cp.format, fp = cp.formatPrefix;
var Tp = new Date(),
    Sp = new Date();

function Mp(t, e, n, r) {
  function i(e) {
    return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
  }

  return i.floor = function (e) {
    return t(e = new Date(+e)), e;
  }, i.ceil = function (n) {
    return t(n = new Date(n - 1)), e(n, 1), t(n), n;
  }, i.round = function (t) {
    var e = i(t),
        n = i.ceil(t);
    return t - e < n - t ? e : n;
  }, i.offset = function (t, n) {
    return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
  }, i.range = function (n, r, o) {
    var a,
        s = [];
    if (n = i.ceil(n), o = null == o ? 1 : Math.floor(o), !(n < r && o > 0)) return s;

    do {
      s.push(a = new Date(+n)), e(n, o), t(n);
    } while (a < n && n < r);

    return s;
  }, i.filter = function (n) {
    return Mp(function (e) {
      if (e >= e) for (; t(e), !n(e);) {
        e.setTime(e - 1);
      }
    }, function (t, r) {
      if (t >= t) if (r < 0) for (; ++r <= 0;) {
        for (; e(t, -1), !n(t);) {
          ;
        }
      } else for (; --r >= 0;) {
        for (; e(t, 1), !n(t);) {
          ;
        }
      }
    });
  }, n && (i.count = function (e, r) {
    return Tp.setTime(+e), Sp.setTime(+r), t(Tp), t(Sp), Math.floor(n(Tp, Sp));
  }, i.every = function (t) {
    return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
      return r(e) % t == 0;
    } : function (e) {
      return i.count(0, e) % t == 0;
    }) : i : null;
  }), i;
}

var Ap = Mp(function () {}, function (t, e) {
  t.setTime(+t + e);
}, function (t, e) {
  return e - t;
});

Ap.every = function (t) {
  return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? Mp(function (e) {
    e.setTime(Math.floor(e / t) * t);
  }, function (e, n) {
    e.setTime(+e + n * t);
  }, function (e, n) {
    return (n - e) / t;
  }) : Ap : null;
};

var kp = Mp(function (t) {
  t.setTime(t - t.getMilliseconds());
}, function (t, e) {
  t.setTime(+t + 1e3 * e);
}, function (t, e) {
  return (e - t) / 1e3;
}, function (t) {
  return t.getUTCSeconds();
}),
    Lp = Mp(function (t) {
  t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds());
}, function (t, e) {
  t.setTime(+t + 6e4 * e);
}, function (t, e) {
  return (e - t) / 6e4;
}, function (t) {
  return t.getMinutes();
}),
    Cp = Mp(function (t) {
  t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds() - 6e4 * t.getMinutes());
}, function (t, e) {
  t.setTime(+t + 36e5 * e);
}, function (t, e) {
  return (e - t) / 36e5;
}, function (t) {
  return t.getHours();
}),
    Rp = Mp(function (t) {
  t.setHours(0, 0, 0, 0);
}, function (t, e) {
  t.setDate(t.getDate() + e);
}, function (t, e) {
  return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 864e5;
}, function (t) {
  return t.getDate() - 1;
});

function jp(t) {
  return Mp(function (e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setDate(t.getDate() + 7 * e);
  }, function (t, e) {
    return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 6048e5;
  });
}

var Pp = jp(0),
    Dp = jp(1),
    Ip = (jp(2), jp(3), jp(4)),
    Np = (jp(5), jp(6), Mp(function (t) {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, function (t, e) {
  t.setMonth(t.getMonth() + e);
}, function (t, e) {
  return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
}, function (t) {
  return t.getMonth();
})),
    Bp = Mp(function (t) {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, function (t, e) {
  t.setFullYear(t.getFullYear() + e);
}, function (t, e) {
  return e.getFullYear() - t.getFullYear();
}, function (t) {
  return t.getFullYear();
});

Bp.every = function (t) {
  return isFinite(t = Math.floor(t)) && t > 0 ? Mp(function (e) {
    e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function (e, n) {
    e.setFullYear(e.getFullYear() + n * t);
  }) : null;
};

var Fp = Mp(function (t) {
  t.setUTCHours(0, 0, 0, 0);
}, function (t, e) {
  t.setUTCDate(t.getUTCDate() + e);
}, function (t, e) {
  return (e - t) / 864e5;
}, function (t) {
  return t.getUTCDate() - 1;
});

function zp(t) {
  return Mp(function (e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setUTCDate(t.getUTCDate() + 7 * e);
  }, function (t, e) {
    return (e - t) / 6048e5;
  });
}

var Vp = zp(0),
    Gp = zp(1),
    Up = (zp(2), zp(3), zp(4)),
    Hp = (zp(5), zp(6), Mp(function (t) {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, function (t, e) {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, function (t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}, function (t) {
  return t.getUTCFullYear();
}));

function Wp(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }

  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}

function qp(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }

  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}

function Yp(t, e, n) {
  return {
    y: t,
    m: e,
    d: n,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}

Hp.every = function (t) {
  return isFinite(t = Math.floor(t)) && t > 0 ? Mp(function (e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function (e, n) {
    e.setUTCFullYear(e.getUTCFullYear() + n * t);
  }) : null;
};

var Xp,
    $p,
    Zp = {
  "-": "",
  _: " ",
  0: "0"
},
    Kp = /^\s*\d+/,
    Jp = /^%/,
    Qp = /[\\^$*+?|[\]().{}]/g;

function td(t, e, n) {
  var r = t < 0 ? "-" : "",
      i = (r ? -t : t) + "",
      o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(e) + i : i);
}

function ed(t) {
  return t.replace(Qp, "\\$&");
}

function nd(t) {
  return new RegExp("^(?:" + t.map(ed).join("|") + ")", "i");
}

function rd(t) {
  for (var e = {}, n = -1, r = t.length; ++n < r;) {
    e[t[n].toLowerCase()] = n;
  }

  return e;
}

function id(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}

function od(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}

function ad(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}

function sd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}

function ud(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}

function cd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}

function ld(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}

function fd(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}

function hd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 1));
  return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
}

function pd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}

function dd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}

function vd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}

function gd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}

function yd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}

function _d(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}

function md(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}

function bd(t, e, n) {
  var r = Kp.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}

function xd(t, e, n) {
  var r = Jp.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}

function wd(t, e, n) {
  var r = Kp.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}

function Od(t, e, n) {
  var r = Kp.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}

function Ed(t, e) {
  return td(t.getDate(), e, 2);
}

function Td(t, e) {
  return td(t.getHours(), e, 2);
}

function Sd(t, e) {
  return td(t.getHours() % 12 || 12, e, 2);
}

function Md(t, e) {
  return td(1 + Rp.count(Bp(t), t), e, 3);
}

function Ad(t, e) {
  return td(t.getMilliseconds(), e, 3);
}

function kd(t, e) {
  return Ad(t, e) + "000";
}

function Ld(t, e) {
  return td(t.getMonth() + 1, e, 2);
}

function Cd(t, e) {
  return td(t.getMinutes(), e, 2);
}

function Rd(t, e) {
  return td(t.getSeconds(), e, 2);
}

function jd(t) {
  var e = t.getDay();
  return 0 === e ? 7 : e;
}

function Pd(t, e) {
  return td(Pp.count(Bp(t) - 1, t), e, 2);
}

function Dd(t, e) {
  var n = t.getDay();
  return t = n >= 4 || 0 === n ? Ip(t) : Ip.ceil(t), td(Ip.count(Bp(t), t) + (4 === Bp(t).getDay()), e, 2);
}

function Id(t) {
  return t.getDay();
}

function Nd(t, e) {
  return td(Dp.count(Bp(t) - 1, t), e, 2);
}

function Bd(t, e) {
  return td(t.getFullYear() % 100, e, 2);
}

function Fd(t, e) {
  return td(t.getFullYear() % 1e4, e, 4);
}

function zd(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + td(e / 60 | 0, "0", 2) + td(e % 60, "0", 2);
}

function Vd(t, e) {
  return td(t.getUTCDate(), e, 2);
}

function Gd(t, e) {
  return td(t.getUTCHours(), e, 2);
}

function Ud(t, e) {
  return td(t.getUTCHours() % 12 || 12, e, 2);
}

function Hd(t, e) {
  return td(1 + Fp.count(Hp(t), t), e, 3);
}

function Wd(t, e) {
  return td(t.getUTCMilliseconds(), e, 3);
}

function qd(t, e) {
  return Wd(t, e) + "000";
}

function Yd(t, e) {
  return td(t.getUTCMonth() + 1, e, 2);
}

function Xd(t, e) {
  return td(t.getUTCMinutes(), e, 2);
}

function $d(t, e) {
  return td(t.getUTCSeconds(), e, 2);
}

function Zd(t) {
  var e = t.getUTCDay();
  return 0 === e ? 7 : e;
}

function Kd(t, e) {
  return td(Vp.count(Hp(t) - 1, t), e, 2);
}

function Jd(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || 0 === n ? Up(t) : Up.ceil(t), td(Up.count(Hp(t), t) + (4 === Hp(t).getUTCDay()), e, 2);
}

function Qd(t) {
  return t.getUTCDay();
}

function tv(t, e) {
  return td(Gp.count(Hp(t) - 1, t), e, 2);
}

function ev(t, e) {
  return td(t.getUTCFullYear() % 100, e, 2);
}

function nv(t, e) {
  return td(t.getUTCFullYear() % 1e4, e, 4);
}

function rv() {
  return "+0000";
}

function iv() {
  return "%";
}

function ov(t) {
  return +t;
}

function av(t) {
  return Math.floor(+t / 1e3);
}

function sv(t) {
  return Xp = function (t) {
    var e = t.dateTime,
        n = t.date,
        r = t.time,
        i = t.periods,
        o = t.days,
        _a2 = t.shortDays,
        s = t.months,
        u = t.shortMonths,
        c = nd(i),
        l = rd(i),
        f = nd(o),
        h = rd(o),
        p = nd(_a2),
        d = rd(_a2),
        v = nd(s),
        g = rd(s),
        y = nd(u),
        _ = rd(u),
        m = {
      a: function a(t) {
        return _a2[t.getDay()];
      },
      A: function A(t) {
        return o[t.getDay()];
      },
      b: function b(t) {
        return u[t.getMonth()];
      },
      B: function B(t) {
        return s[t.getMonth()];
      },
      c: null,
      d: Ed,
      e: Ed,
      f: kd,
      H: Td,
      I: Sd,
      j: Md,
      L: Ad,
      m: Ld,
      M: Cd,
      p: function p(t) {
        return i[+(t.getHours() >= 12)];
      },
      q: function q(t) {
        return 1 + ~~(t.getMonth() / 3);
      },
      Q: ov,
      s: av,
      S: Rd,
      u: jd,
      U: Pd,
      V: Dd,
      w: Id,
      W: Nd,
      x: null,
      X: null,
      y: Bd,
      Y: Fd,
      Z: zd,
      "%": iv
    },
        b = {
      a: function a(t) {
        return _a2[t.getUTCDay()];
      },
      A: function A(t) {
        return o[t.getUTCDay()];
      },
      b: function b(t) {
        return u[t.getUTCMonth()];
      },
      B: function B(t) {
        return s[t.getUTCMonth()];
      },
      c: null,
      d: Vd,
      e: Vd,
      f: qd,
      H: Gd,
      I: Ud,
      j: Hd,
      L: Wd,
      m: Yd,
      M: Xd,
      p: function p(t) {
        return i[+(t.getUTCHours() >= 12)];
      },
      q: function q(t) {
        return 1 + ~~(t.getUTCMonth() / 3);
      },
      Q: ov,
      s: av,
      S: $d,
      u: Zd,
      U: Kd,
      V: Jd,
      w: Qd,
      W: tv,
      x: null,
      X: null,
      y: ev,
      Y: nv,
      Z: rv,
      "%": iv
    },
        x = {
      a: function a(t, e, n) {
        var r = p.exec(e.slice(n));
        return r ? (t.w = d[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      A: function A(t, e, n) {
        var r = f.exec(e.slice(n));
        return r ? (t.w = h[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      b: function b(t, e, n) {
        var r = y.exec(e.slice(n));
        return r ? (t.m = _[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      B: function B(t, e, n) {
        var r = v.exec(e.slice(n));
        return r ? (t.m = g[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      c: function c(t, n, r) {
        return E(t, e, n, r);
      },
      d: dd,
      e: dd,
      f: bd,
      H: gd,
      I: gd,
      j: vd,
      L: md,
      m: pd,
      M: yd,
      p: function p(t, e, n) {
        var r = c.exec(e.slice(n));
        return r ? (t.p = l[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      q: hd,
      Q: wd,
      s: Od,
      S: _d,
      u: od,
      U: ad,
      V: sd,
      w: id,
      W: ud,
      x: function x(t, e, r) {
        return E(t, n, e, r);
      },
      X: function X(t, e, n) {
        return E(t, r, e, n);
      },
      y: ld,
      Y: cd,
      Z: fd,
      "%": xd
    };

    function w(t, e) {
      return function (n) {
        var r,
            i,
            o,
            a = [],
            s = -1,
            u = 0,
            c = t.length;

        for (n instanceof Date || (n = new Date(+n)); ++s < c;) {
          37 === t.charCodeAt(s) && (a.push(t.slice(u, s)), null != (i = Zp[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (o = e[r]) && (r = o(n, i)), a.push(r), u = s + 1);
        }

        return a.push(t.slice(u, s)), a.join("");
      };
    }

    function O(t, e) {
      return function (n) {
        var r,
            i,
            o = Yp(1900, void 0, 1);
        if (E(o, t, n += "", 0) != n.length) return null;
        if ("Q" in o) return new Date(o.Q);
        if ("s" in o) return new Date(1e3 * o.s + ("L" in o ? o.L : 0));

        if (!e || "Z" in o || (o.Z = 0), "p" in o && (o.H = o.H % 12 + 12 * o.p), void 0 === o.m && (o.m = "q" in o ? o.q : 0), "V" in o) {
          if (o.V < 1 || o.V > 53) return null;
          "w" in o || (o.w = 1), "Z" in o ? (i = (r = qp(Yp(o.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? Gp.ceil(r) : Gp(r), r = Fp.offset(r, 7 * (o.V - 1)), o.y = r.getUTCFullYear(), o.m = r.getUTCMonth(), o.d = r.getUTCDate() + (o.w + 6) % 7) : (i = (r = Wp(Yp(o.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? Dp.ceil(r) : Dp(r), r = Rp.offset(r, 7 * (o.V - 1)), o.y = r.getFullYear(), o.m = r.getMonth(), o.d = r.getDate() + (o.w + 6) % 7);
        } else ("W" in o || "U" in o) && ("w" in o || (o.w = "u" in o ? o.u % 7 : "W" in o ? 1 : 0), i = "Z" in o ? qp(Yp(o.y, 0, 1)).getUTCDay() : Wp(Yp(o.y, 0, 1)).getDay(), o.m = 0, o.d = "W" in o ? (o.w + 6) % 7 + 7 * o.W - (i + 5) % 7 : o.w + 7 * o.U - (i + 6) % 7);

        return "Z" in o ? (o.H += o.Z / 100 | 0, o.M += o.Z % 100, qp(o)) : Wp(o);
      };
    }

    function E(t, e, n, r) {
      for (var i, o, a = 0, s = e.length, u = n.length; a < s;) {
        if (r >= u) return -1;

        if (37 === (i = e.charCodeAt(a++))) {
          if (i = e.charAt(a++), !(o = x[i in Zp ? e.charAt(a++) : i]) || (r = o(t, n, r)) < 0) return -1;
        } else if (i != n.charCodeAt(r++)) return -1;
      }

      return r;
    }

    return m.x = w(n, m), m.X = w(r, m), m.c = w(e, m), b.x = w(n, b), b.X = w(r, b), b.c = w(e, b), {
      format: function format(t) {
        var e = w(t += "", m);
        return e.toString = function () {
          return t;
        }, e;
      },
      parse: function parse(t) {
        var e = O(t += "", !1);
        return e.toString = function () {
          return t;
        }, e;
      },
      utcFormat: function utcFormat(t) {
        var e = w(t += "", b);
        return e.toString = function () {
          return t;
        }, e;
      },
      utcParse: function utcParse(t) {
        var e = O(t += "", !0);
        return e.toString = function () {
          return t;
        }, e;
      }
    };
  }(t), $p = Xp.format, Xp.parse, Xp.utcFormat, Xp.utcParse, Xp;
}

sv({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function uv(t) {
  return new Date(t);
}

function cv(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function lv(t, e, n, r, i, o, a, s, u) {
  var c = Qh(qh, qh),
      l = c.invert,
      f = c.domain,
      h = u(".%L"),
      p = u(":%S"),
      d = u("%I:%M"),
      v = u("%I %p"),
      g = u("%a %d"),
      y = u("%b %d"),
      _ = u("%B"),
      m = u("%Y"),
      b = [[a, 1, 1e3], [a, 5, 5e3], [a, 15, 15e3], [a, 30, 3e4], [o, 1, 6e4], [o, 5, 3e5], [o, 15, 9e5], [o, 30, 18e5], [i, 1, 36e5], [i, 3, 108e5], [i, 6, 216e5], [i, 12, 432e5], [r, 1, 864e5], [r, 2, 1728e5], [n, 1, 6048e5], [e, 1, 2592e6], [e, 3, 7776e6], [t, 1, 31536e6]];

  function x(s) {
    return (a(s) < s ? h : o(s) < s ? p : i(s) < s ? d : r(s) < s ? v : e(s) < s ? n(s) < s ? g : y : t(s) < s ? _ : m)(s);
  }

  function w(e, n, r, i) {
    if (null == e && (e = 10), "number" == typeof e) {
      var o = Math.abs(r - n) / e,
          a = Ef(function (t) {
        return t[2];
      }).right(b, o);
      a === b.length ? (i = jf(n / 31536e6, r / 31536e6, e), e = t) : a ? (i = (a = b[o / b[a - 1][2] < b[a][2] / o ? a - 1 : a])[1], e = a[0]) : (i = Math.max(jf(n, r, e), 1), e = s);
    }

    return null == i ? e : e.every(i);
  }

  return c.invert = function (t) {
    return new Date(l(t));
  }, c.domain = function (t) {
    return arguments.length ? f(zf.call(t, cv)) : f().map(uv);
  }, c.ticks = function (t, e) {
    var n,
        r = f(),
        i = r[0],
        o = r[r.length - 1],
        a = o < i;
    return a && (n = i, i = o, o = n), n = (n = w(t, i, o, e)) ? n.range(i, o + 1) : [], a ? n.reverse() : n;
  }, c.tickFormat = function (t, e) {
    return null == e ? x : u(e);
  }, c.nice = function (t, e) {
    var n = f();
    return (t = w(t, n[0], n[n.length - 1], e)) ? f(yp(n, t)) : c;
  }, c.copy = function () {
    return Kh(c, lv(t, e, n, r, i, o, a, s, u));
  }, c;
}

var fv = function () {
  function t(t) {
    this.state = {
      options: {}
    }, this.patternScale = {}, this.colorScale = {}, this.services = t;
  }

  return t.prototype.getDisplayData = function () {
    var t = Rl.items.status.ACTIVE,
        e = this.get("dataLabels");
    if (!this.get("data")) return null;
    var n = Tl.clone(this.get("data"));
    return n.datasets = n.datasets.filter(function (n) {
      return e[n.label] === t;
    }), n;
  }, t.prototype.getData = function () {
    return this.get("data");
  }, t.prototype.setData = function (t) {
    var e = this.generateDataLabels(t);
    return this.set({
      data: t,
      dataLabels: e
    }), this.state.data;
  }, t.prototype.generateDataLabels = function (t) {
    var e = {};
    return t.datasets.forEach(function (t) {
      e[t.label] = Rl.items.status.ACTIVE;
    }), e;
  }, t.prototype.getOptions = function () {
    return this.state.options;
  }, t.prototype.set = function (t, e) {
    void 0 === e && (e = !1), this.state = Object.assign({}, this.state, t), e || this.update();
  }, t.prototype.get = function (t) {
    return t ? this.state[t] : this.state;
  }, t.prototype.setOptions = function (t) {
    this.set({
      options: Tl.merge(this.getOptions(), t)
    });
  }, t.prototype.update = function () {
    this.getDisplayData() && (this.updateAllDataLabels(), this.setColorScale(), this.services.events.dispatchEvent("model-update"));
  }, t.prototype.setUpdateCallback = function (t) {
    this.updateCallback = t;
  }, t.prototype.toggleDataLabel = function (t) {
    var e = Rl.items.status,
        n = e.ACTIVE,
        r = e.DISABLED,
        i = this.get("dataLabels"),
        o = Object.keys(i).some(function (t) {
      return i[t] === r;
    }),
        a = Object.keys(i).filter(function (t) {
      return i[t] === n;
    });
    o ? 1 === a.length && a[0] === t ? Object.keys(i).forEach(function (t) {
      i[t] = n;
    }) : i[t] = i[t] === r ? n : r : Object.keys(i).forEach(function (e) {
      i[e] = e === t ? n : r;
    }), this.set({
      dataLabels: i
    });
  }, t.prototype.setColorScale = function () {
    var t = this;
    if (this.getDisplayData().datasets[0].fillColors) this.getDisplayData().datasets.forEach(function (e) {
      t.colorScale[e.label] = Uf().range(e.fillColors).domain(t.allDataLabels);
    });else {
      var e = xf;
      this.getData().datasets.forEach(function (n, r) {
        t.colorScale[n.label] = Uf().range([e[r]]).domain(t.allDataLabels);
      });
    }
  }, t.prototype.getFillColor = function (t, e, n) {
    var r = this.getOptions();
    return r.getFillColor ? r.getFillColor(t, e, n) : this.getFillScale()[t](e);
  }, t.prototype.getStrokeColor = function (t, e, n) {
    var r = this.getOptions();
    return r.getStrokeColor ? r.getStrokeColor(t, e, n) : this.colorScale[t](e);
  }, t.prototype.getFillScale = function () {
    return this.colorScale;
  }, t.prototype.updateAllDataLabels = function () {
    var t = this;
    this.allDataLabels ? this.getDisplayData().labels.forEach(function (e) {
      -1 === t.allDataLabels.indexOf(e) && t.allDataLabels.push(e);
    }) : this.allDataLabels = this.getDisplayData().labels;
  }, t;
}(),
    hv = function () {
  function t(t, e) {
    this.model = t, this.services = e, this.init();
  }

  return t.prototype.init = function () {}, t.prototype.update = function () {}, t.prototype.setModel = function (t) {
    this.model = t;
  }, t.prototype.setServices = function (t) {
    this.services = t;
  }, t;
}(),
    pv = "http://www.w3.org/1999/xhtml",
    dv = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: pv,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function vv(t) {
  var e = t += "",
      n = e.indexOf(":");
  return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), dv.hasOwnProperty(e) ? {
    space: dv[e],
    local: t
  } : t;
}

function gv(t) {
  return function () {
    var e = this.ownerDocument,
        n = this.namespaceURI;
    return n === pv && e.documentElement.namespaceURI === pv ? e.createElement(t) : e.createElementNS(n, t);
  };
}

function yv(t) {
  return function () {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}

function _v(t) {
  var e = vv(t);
  return (e.local ? yv : gv)(e);
}

function mv() {}

function bv(t) {
  return null == t ? mv : function () {
    return this.querySelector(t);
  };
}

function xv() {
  return [];
}

function wv(t) {
  return null == t ? xv : function () {
    return this.querySelectorAll(t);
  };
}

function Ov(t) {
  return function () {
    return this.matches(t);
  };
}

function Ev(t) {
  return new Array(t.length);
}

function Tv(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}

Tv.prototype = {
  constructor: Tv,
  appendChild: function appendChild(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function insertBefore(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function querySelector(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function querySelectorAll(t) {
    return this._parent.querySelectorAll(t);
  }
};

function Sv(t, e, n, r, i, o) {
  for (var a, s = 0, u = e.length, c = o.length; s < c; ++s) {
    (a = e[s]) ? (a.__data__ = o[s], r[s] = a) : n[s] = new Tv(t, o[s]);
  }

  for (; s < u; ++s) {
    (a = e[s]) && (i[s] = a);
  }
}

function Mv(t, e, n, r, i, o, a) {
  var s,
      u,
      c,
      l = {},
      f = e.length,
      h = o.length,
      p = new Array(f);

  for (s = 0; s < f; ++s) {
    (u = e[s]) && (p[s] = c = "$" + a.call(u, u.__data__, s, e), c in l ? i[s] = u : l[c] = u);
  }

  for (s = 0; s < h; ++s) {
    (u = l[c = "$" + a.call(t, o[s], s, o)]) ? (r[s] = u, u.__data__ = o[s], l[c] = null) : n[s] = new Tv(t, o[s]);
  }

  for (s = 0; s < f; ++s) {
    (u = e[s]) && l[p[s]] === u && (i[s] = u);
  }
}

function Av(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}

function kv(t) {
  return function () {
    this.removeAttribute(t);
  };
}

function Lv(t) {
  return function () {
    this.removeAttributeNS(t.space, t.local);
  };
}

function Cv(t, e) {
  return function () {
    this.setAttribute(t, e);
  };
}

function Rv(t, e) {
  return function () {
    this.setAttributeNS(t.space, t.local, e);
  };
}

function jv(t, e) {
  return function () {
    var n = e.apply(this, arguments);
    null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}

function Pv(t, e) {
  return function () {
    var n = e.apply(this, arguments);
    null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}

function Dv(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}

function Iv(t) {
  return function () {
    this.style.removeProperty(t);
  };
}

function Nv(t, e, n) {
  return function () {
    this.style.setProperty(t, e, n);
  };
}

function Bv(t, e, n) {
  return function () {
    var r = e.apply(this, arguments);
    null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}

function Fv(t, e) {
  return t.style.getPropertyValue(e) || Dv(t).getComputedStyle(t, null).getPropertyValue(e);
}

function zv(t) {
  return function () {
    delete this[t];
  };
}

function Vv(t, e) {
  return function () {
    this[t] = e;
  };
}

function Gv(t, e) {
  return function () {
    var n = e.apply(this, arguments);
    null == n ? delete this[t] : this[t] = n;
  };
}

function Uv(t) {
  return t.trim().split(/^|\s+/);
}

function Hv(t) {
  return t.classList || new Wv(t);
}

function Wv(t) {
  this._node = t, this._names = Uv(t.getAttribute("class") || "");
}

function qv(t, e) {
  for (var n = Hv(t), r = -1, i = e.length; ++r < i;) {
    n.add(e[r]);
  }
}

function Yv(t, e) {
  for (var n = Hv(t), r = -1, i = e.length; ++r < i;) {
    n.remove(e[r]);
  }
}

function Xv(t) {
  return function () {
    qv(this, t);
  };
}

function $v(t) {
  return function () {
    Yv(this, t);
  };
}

function Zv(t, e) {
  return function () {
    (e.apply(this, arguments) ? qv : Yv)(this, t);
  };
}

function Kv() {
  this.textContent = "";
}

function Jv(t) {
  return function () {
    this.textContent = t;
  };
}

function Qv(t) {
  return function () {
    var e = t.apply(this, arguments);
    this.textContent = null == e ? "" : e;
  };
}

function tg() {
  this.innerHTML = "";
}

function eg(t) {
  return function () {
    this.innerHTML = t;
  };
}

function ng(t) {
  return function () {
    var e = t.apply(this, arguments);
    this.innerHTML = null == e ? "" : e;
  };
}

function rg() {
  this.nextSibling && this.parentNode.appendChild(this);
}

function ig() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function og() {
  return null;
}

function ag() {
  var t = this.parentNode;
  t && t.removeChild(this);
}

function sg() {
  var t = this.cloneNode(!1),
      e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}

function ug() {
  var t = this.cloneNode(!0),
      e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}

Wv.prototype = {
  add: function add(t) {
    this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function remove(t) {
    var e = this._names.indexOf(t);

    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function contains(t) {
    return this._names.indexOf(t) >= 0;
  }
};
var cg = {},
    lg = null;
"undefined" != typeof document && ("onmouseenter" in document.documentElement || (cg = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}));

function fg(t, e, n) {
  return t = hg(t, e, n), function (e) {
    var n = e.relatedTarget;
    n && (n === this || 8 & n.compareDocumentPosition(this)) || t.call(this, e);
  };
}

function hg(t, e, n) {
  return function (r) {
    var i = lg;
    lg = r;

    try {
      t.call(this, this.__data__, e, n);
    } finally {
      lg = i;
    }
  };
}

function pg(t) {
  return t.trim().split(/^|\s+/).map(function (t) {
    var e = "",
        n = t.indexOf(".");
    return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
      type: t,
      name: e
    };
  });
}

function dg(t) {
  return function () {
    var e = this.__on;

    if (e) {
      for (var n, r = 0, i = -1, o = e.length; r < o; ++r) {
        n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.capture);
      }

      ++i ? e.length = i : delete this.__on;
    }
  };
}

function vg(t, e, n) {
  var r = cg.hasOwnProperty(t.type) ? fg : hg;
  return function (i, o, a) {
    var s,
        u = this.__on,
        c = r(e, o, a);
    if (u) for (var l = 0, f = u.length; l < f; ++l) {
      if ((s = u[l]).type === t.type && s.name === t.name) return this.removeEventListener(s.type, s.listener, s.capture), this.addEventListener(s.type, s.listener = c, s.capture = n), void (s.value = e);
    }
    this.addEventListener(t.type, c, n), s = {
      type: t.type,
      name: t.name,
      value: e,
      listener: c,
      capture: n
    }, u ? u.push(s) : this.__on = [s];
  };
}

function gg(t, e, n) {
  var r = Dv(t),
      i = r.CustomEvent;
  "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}

function yg(t, e) {
  return function () {
    return gg(this, t, e);
  };
}

function _g(t, e) {
  return function () {
    return gg(this, t, e.apply(this, arguments));
  };
}

var mg = [null];

function bg(t, e) {
  this._groups = t, this._parents = e;
}

function xg() {
  return new bg([[document.documentElement]], mg);
}

function wg(t) {
  return "string" == typeof t ? new bg([[document.querySelector(t)]], [document.documentElement]) : new bg([[t]], mg);
}

function Og() {
  for (var t, e = lg; t = e.sourceEvent;) {
    e = t;
  }

  return e;
}

function Eg(t) {
  var e = Og();
  return e.changedTouches && (e = e.changedTouches[0]), function (t, e) {
    var n = t.ownerSVGElement || t;

    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = e.clientX, r.y = e.clientY, [(r = r.matrixTransform(t.getScreenCTM().inverse())).x, r.y];
    }

    var i = t.getBoundingClientRect();
    return [e.clientX - i.left - t.clientLeft, e.clientY - i.top - t.clientTop];
  }(t, e);
}

bg.prototype = xg.prototype = {
  constructor: bg,
  select: function select(t) {
    "function" != typeof t && (t = bv(t));

    for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
      for (var o, a, s = e[i], u = s.length, c = r[i] = new Array(u), l = 0; l < u; ++l) {
        (o = s[l]) && (a = t.call(o, o.__data__, l, s)) && ("__data__" in o && (a.__data__ = o.__data__), c[l] = a);
      }
    }

    return new bg(r, this._parents);
  },
  selectAll: function selectAll(t) {
    "function" != typeof t && (t = wv(t));

    for (var e = this._groups, n = e.length, r = [], i = [], o = 0; o < n; ++o) {
      for (var a, s = e[o], u = s.length, c = 0; c < u; ++c) {
        (a = s[c]) && (r.push(t.call(a, a.__data__, c, s)), i.push(a));
      }
    }

    return new bg(r, i);
  },
  filter: function filter(t) {
    "function" != typeof t && (t = Ov(t));

    for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
      for (var o, a = e[i], s = a.length, u = r[i] = [], c = 0; c < s; ++c) {
        (o = a[c]) && t.call(o, o.__data__, c, a) && u.push(o);
      }
    }

    return new bg(r, this._parents);
  },
  data: function data(t, e) {
    if (!t) return p = new Array(this.size()), c = -1, this.each(function (t) {
      p[++c] = t;
    }), p;
    var n = e ? Mv : Sv,
        r = this._parents,
        i = this._groups;
    "function" != typeof t && (t = function (t) {
      return function () {
        return t;
      };
    }(t));

    for (var o = i.length, a = new Array(o), s = new Array(o), u = new Array(o), c = 0; c < o; ++c) {
      var l = r[c],
          f = i[c],
          h = f.length,
          p = t.call(l, l && l.__data__, c, r),
          d = p.length,
          v = s[c] = new Array(d),
          g = a[c] = new Array(d);
      n(l, f, v, g, u[c] = new Array(h), p, e);

      for (var y, _, m = 0, b = 0; m < d; ++m) {
        if (y = v[m]) {
          for (m >= b && (b = m + 1); !(_ = g[b]) && ++b < d;) {
            ;
          }

          y._next = _ || null;
        }
      }
    }

    return (a = new bg(a, r))._enter = s, a._exit = u, a;
  },
  enter: function enter() {
    return new bg(this._enter || this._groups.map(Ev), this._parents);
  },
  exit: function exit() {
    return new bg(this._exit || this._groups.map(Ev), this._parents);
  },
  join: function join(t, e, n) {
    var r = this.enter(),
        i = this,
        o = this.exit();
    return r = "function" == typeof t ? t(r) : r.append(t + ""), null != e && (i = e(i)), null == n ? o.remove() : n(o), r && i ? r.merge(i).order() : i;
  },
  merge: function merge(t) {
    for (var e = this._groups, n = t._groups, r = e.length, i = n.length, o = Math.min(r, i), a = new Array(r), s = 0; s < o; ++s) {
      for (var u, c = e[s], l = n[s], f = c.length, h = a[s] = new Array(f), p = 0; p < f; ++p) {
        (u = c[p] || l[p]) && (h[p] = u);
      }
    }

    for (; s < r; ++s) {
      a[s] = e[s];
    }

    return new bg(a, this._parents);
  },
  order: function order() {
    for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
      for (var r, i = t[e], o = i.length - 1, a = i[o]; --o >= 0;) {
        (r = i[o]) && (a && 4 ^ r.compareDocumentPosition(a) && a.parentNode.insertBefore(r, a), a = r);
      }
    }

    return this;
  },
  sort: function sort(t) {
    function e(e, n) {
      return e && n ? t(e.__data__, n.__data__) : !e - !n;
    }

    t || (t = Av);

    for (var n = this._groups, r = n.length, i = new Array(r), o = 0; o < r; ++o) {
      for (var a, s = n[o], u = s.length, c = i[o] = new Array(u), l = 0; l < u; ++l) {
        (a = s[l]) && (c[l] = a);
      }

      c.sort(e);
    }

    return new bg(i, this._parents).order();
  },
  call: function call() {
    var t = arguments[0];
    return arguments[0] = this, t.apply(null, arguments), this;
  },
  nodes: function nodes() {
    var t = new Array(this.size()),
        e = -1;
    return this.each(function () {
      t[++e] = this;
    }), t;
  },
  node: function node() {
    for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
      for (var r = t[e], i = 0, o = r.length; i < o; ++i) {
        var a = r[i];
        if (a) return a;
      }
    }

    return null;
  },
  size: function size() {
    var t = 0;
    return this.each(function () {
      ++t;
    }), t;
  },
  empty: function empty() {
    return !this.node();
  },
  each: function each(t) {
    for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
      for (var i, o = e[n], a = 0, s = o.length; a < s; ++a) {
        (i = o[a]) && t.call(i, i.__data__, a, o);
      }
    }

    return this;
  },
  attr: function attr(t, e) {
    var n = vv(t);

    if (arguments.length < 2) {
      var r = this.node();
      return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
    }

    return this.each((null == e ? n.local ? Lv : kv : "function" == typeof e ? n.local ? Pv : jv : n.local ? Rv : Cv)(n, e));
  },
  style: function style(t, e, n) {
    return arguments.length > 1 ? this.each((null == e ? Iv : "function" == typeof e ? Bv : Nv)(t, e, null == n ? "" : n)) : Fv(this.node(), t);
  },
  property: function property(t, e) {
    return arguments.length > 1 ? this.each((null == e ? zv : "function" == typeof e ? Gv : Vv)(t, e)) : this.node()[t];
  },
  classed: function classed(t, e) {
    var n = Uv(t + "");

    if (arguments.length < 2) {
      for (var r = Hv(this.node()), i = -1, o = n.length; ++i < o;) {
        if (!r.contains(n[i])) return !1;
      }

      return !0;
    }

    return this.each(("function" == typeof e ? Zv : e ? Xv : $v)(n, e));
  },
  text: function text(t) {
    return arguments.length ? this.each(null == t ? Kv : ("function" == typeof t ? Qv : Jv)(t)) : this.node().textContent;
  },
  html: function html(t) {
    return arguments.length ? this.each(null == t ? tg : ("function" == typeof t ? ng : eg)(t)) : this.node().innerHTML;
  },
  raise: function raise() {
    return this.each(rg);
  },
  lower: function lower() {
    return this.each(ig);
  },
  append: function append(t) {
    var e = "function" == typeof t ? t : _v(t);
    return this.select(function () {
      return this.appendChild(e.apply(this, arguments));
    });
  },
  insert: function insert(t, e) {
    var n = "function" == typeof t ? t : _v(t),
        r = null == e ? og : "function" == typeof e ? e : bv(e);
    return this.select(function () {
      return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
    });
  },
  remove: function remove() {
    return this.each(ag);
  },
  clone: function clone(t) {
    return this.select(t ? ug : sg);
  },
  datum: function datum(t) {
    return arguments.length ? this.property("__data__", t) : this.node().__data__;
  },
  on: function on(t, e, n) {
    var r,
        i,
        o = pg(t + ""),
        a = o.length;

    if (!(arguments.length < 2)) {
      for (s = e ? vg : dg, null == n && (n = !1), r = 0; r < a; ++r) {
        this.each(s(o[r], e, n));
      }

      return this;
    }

    var s = this.node().__on;

    if (s) for (var u, c = 0, l = s.length; c < l; ++c) {
      for (r = 0, u = s[c]; r < a; ++r) {
        if ((i = o[r]).type === u.type && i.name === u.name) return u.value;
      }
    }
  },
  dispatch: function dispatch(t, e) {
    return this.each(("function" == typeof e ? _g : yg)(t, e));
  }
};

var Tg = {
  prefix: "bx",
  selectorTabbable: "\n    a[href], area[href], input:not([disabled]):not([tabindex='-1']),\n    button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),\n    textarea:not([disabled]):not([tabindex='-1']),\n    iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]\n  "
},
    Sg = function () {
  if ("undefined" != typeof Map) return Map;

  function t(t, e) {
    var n = -1;
    return t.some(function (t, r) {
      return t[0] === e && (n = r, !0);
    }), n;
  }

  return function () {
    function e() {
      this.__entries__ = [];
    }

    var n = {
      size: {
        configurable: !0
      }
    };
    return n.size.get = function () {
      return this.__entries__.length;
    }, e.prototype.get = function (e) {
      var n = t(this.__entries__, e),
          r = this.__entries__[n];
      return r && r[1];
    }, e.prototype.set = function (e, n) {
      var r = t(this.__entries__, e);
      ~r ? this.__entries__[r][1] = n : this.__entries__.push([e, n]);
    }, e.prototype["delete"] = function (e) {
      var n = this.__entries__,
          r = t(n, e);
      ~r && n.splice(r, 1);
    }, e.prototype.has = function (e) {
      return !!~t(this.__entries__, e);
    }, e.prototype.clear = function () {
      this.__entries__.splice(0);
    }, e.prototype.forEach = function (t, e) {
      void 0 === e && (e = null);

      for (var n = 0, r = this.__entries__; n < r.length; n += 1) {
        var i = r[n];
        t.call(e, i[1], i[0]);
      }
    }, Object.defineProperties(e.prototype, n), e;
  }();
}(),
    Mg = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
    Ag = "undefined" != typeof global && global.Math === Math ? global : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
    kg = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(Ag) : function (t) {
  return setTimeout(function () {
    return t(Date.now());
  }, 1e3 / 60);
},
    Lg = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
    Cg = "undefined" != typeof MutationObserver,
    Rg = function Rg() {
  this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (t, e) {
    var n = !1,
        r = !1,
        i = 0;

    function o() {
      n && (n = !1, t()), r && s();
    }

    function a() {
      kg(o);
    }

    function s() {
      var t = Date.now();

      if (n) {
        if (t - i < 2) return;
        r = !0;
      } else n = !0, r = !1, setTimeout(a, e);

      i = t;
    }

    return s;
  }(this.refresh.bind(this), 20);
};

Rg.prototype.addObserver = function (t) {
  ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
}, Rg.prototype.removeObserver = function (t) {
  var e = this.observers_,
      n = e.indexOf(t);
  ~n && e.splice(n, 1), !e.length && this.connected_ && this.disconnect_();
}, Rg.prototype.refresh = function () {
  this.updateObservers_() && this.refresh();
}, Rg.prototype.updateObservers_ = function () {
  var t = this.observers_.filter(function (t) {
    return t.gatherActive(), t.hasActive();
  });
  return t.forEach(function (t) {
    return t.broadcastActive();
  }), t.length > 0;
}, Rg.prototype.connect_ = function () {
  Mg && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Cg ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
    attributes: !0,
    childList: !0,
    characterData: !0,
    subtree: !0
  })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
}, Rg.prototype.disconnect_ = function () {
  Mg && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
}, Rg.prototype.onTransitionEnd_ = function (t) {
  var e = t.propertyName;
  void 0 === e && (e = ""), Lg.some(function (t) {
    return !!~e.indexOf(t);
  }) && this.refresh();
}, Rg.getInstance = function () {
  return this.instance_ || (this.instance_ = new Rg()), this.instance_;
}, Rg.instance_ = null;

var jg = function jg(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n += 1) {
    var i = r[n];
    Object.defineProperty(t, i, {
      value: e[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }

  return t;
},
    Pg = function Pg(t) {
  return t && t.ownerDocument && t.ownerDocument.defaultView || Ag;
},
    Dg = Vg(0, 0, 0, 0);

function Ig(t) {
  return parseFloat(t) || 0;
}

function Ng(t) {
  for (var e = [], n = arguments.length - 1; n-- > 0;) {
    e[n] = arguments[n + 1];
  }

  return e.reduce(function (e, n) {
    return e + Ig(t["border-" + n + "-width"]);
  }, 0);
}

function Bg(t) {
  var e = t.clientWidth,
      n = t.clientHeight;
  if (!e && !n) return Dg;

  var r = Pg(t).getComputedStyle(t),
      i = function (t) {
    for (var e = {}, n = 0, r = ["top", "right", "bottom", "left"]; n < r.length; n += 1) {
      var i = r[n],
          o = t["padding-" + i];
      e[i] = Ig(o);
    }

    return e;
  }(r),
      o = i.left + i.right,
      a = i.top + i.bottom,
      s = Ig(r.width),
      u = Ig(r.height);

  if ("border-box" === r.boxSizing && (Math.round(s + o) !== e && (s -= Ng(r, "left", "right") + o), Math.round(u + a) !== n && (u -= Ng(r, "top", "bottom") + a)), !function (t) {
    return t === Pg(t).document.documentElement;
  }(t)) {
    var c = Math.round(s + o) - e,
        l = Math.round(u + a) - n;
    1 !== Math.abs(c) && (s -= c), 1 !== Math.abs(l) && (u -= l);
  }

  return Vg(i.left, i.top, s, u);
}

var Fg = "undefined" != typeof SVGGraphicsElement ? function (t) {
  return t instanceof Pg(t).SVGGraphicsElement;
} : function (t) {
  return t instanceof Pg(t).SVGElement && "function" == typeof t.getBBox;
};

function zg(t) {
  return Mg ? Fg(t) ? function (t) {
    var e = t.getBBox();
    return Vg(0, 0, e.width, e.height);
  }(t) : Bg(t) : Dg;
}

function Vg(t, e, n, r) {
  return {
    x: t,
    y: e,
    width: n,
    height: r
  };
}

var Gg = function Gg(t) {
  this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Vg(0, 0, 0, 0), this.target = t;
};

Gg.prototype.isActive = function () {
  var t = zg(this.target);
  return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
}, Gg.prototype.broadcastRect = function () {
  var t = this.contentRect_;
  return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
};

var Ug = function Ug(t, e) {
  var n = function (t) {
    var e = t.x,
        n = t.y,
        r = t.width,
        i = t.height,
        o = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object,
        a = Object.create(o.prototype);
    return jg(a, {
      x: e,
      y: n,
      width: r,
      height: i,
      top: n,
      right: e + r,
      bottom: i + n,
      left: e
    }), a;
  }(e);

  jg(this, {
    target: t,
    contentRect: n
  });
},
    Hg = function Hg(t, e, n) {
  if (this.activeObservations_ = [], this.observations_ = new Sg(), "function" != typeof t) throw new TypeError("The callback provided as parameter 1 is not a function.");
  this.callback_ = t, this.controller_ = e, this.callbackCtx_ = n;
};

Hg.prototype.observe = function (t) {
  if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

  if ("undefined" != typeof Element && Element instanceof Object) {
    if (!(t instanceof Pg(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
    var e = this.observations_;
    e.has(t) || (e.set(t, new Gg(t)), this.controller_.addObserver(this), this.controller_.refresh());
  }
}, Hg.prototype.unobserve = function (t) {
  if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

  if ("undefined" != typeof Element && Element instanceof Object) {
    if (!(t instanceof Pg(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
    var e = this.observations_;
    e.has(t) && (e["delete"](t), e.size || this.controller_.removeObserver(this));
  }
}, Hg.prototype.disconnect = function () {
  this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
}, Hg.prototype.gatherActive = function () {
  var t = this;
  this.clearActive(), this.observations_.forEach(function (e) {
    e.isActive() && t.activeObservations_.push(e);
  });
}, Hg.prototype.broadcastActive = function () {
  if (this.hasActive()) {
    var t = this.callbackCtx_,
        e = this.activeObservations_.map(function (t) {
      return new Ug(t.target, t.broadcastRect());
    });
    this.callback_.call(t, e, t), this.clearActive();
  }
}, Hg.prototype.clearActive = function () {
  this.activeObservations_.splice(0);
}, Hg.prototype.hasActive = function () {
  return this.activeObservations_.length > 0;
};

var Wg = "undefined" != typeof WeakMap ? new WeakMap() : new Sg(),
    qg = function qg(t) {
  if (!(this instanceof qg)) throw new TypeError("Cannot call a class as a function.");
  if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
  var e = Rg.getInstance(),
      n = new Hg(t, e, this);
  Wg.set(this, n);
};

["observe", "unobserve", "disconnect"].forEach(function (t) {
  qg.prototype[t] = function () {
    return (e = Wg.get(this))[t].apply(e, arguments);
    var e;
  };
});

var Yg = void 0 !== Ag.ResizeObserver ? Ag.ResizeObserver : qg,
    Xg = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return a(e, t), e.getSVGElementSize = function (t, e) {
    t.attr || (t = wg(t));
    var n,
        r,
        i,
        o,
        a = {
      width: t.attr("width"),
      height: t.attr("height")
    };

    try {
      r = {
        width: (n = t.node().getBBox()).width,
        height: n.height
      };
    } catch (t) {}

    try {
      o = {
        width: (i = t.node().getBoundingClientRect()).width,
        height: i.height
      };
    } catch (t) {}

    var s = {
      width: t.node().clientWidth,
      height: t.node().clientHeight
    },
        u = function u(t) {
      return !!(t && t.width && t.height && !isNaN(t.height) && !isNaN(t.width) && -1 === ("" + t.width + t.height).indexOf("%") && t.width > 0 && t.height > 0);
    };

    if (e) {
      if (e.useAttrs && u(a)) return a;
      if (e.useClientDimensions && u(s)) return s;
      if (e.useBBox && u(r)) return r;
      if (e.useBoundingRect && u(o)) return o;
    }

    try {
      var c = {
        width: Tl.getProperty(t.node(), "width", "baseVal", "value"),
        height: Tl.getProperty(t.node(), "height", "baseVal", "value")
      };
      if (u(c)) return c;
    } catch (t) {
      if (u(s)) return s;
      if (u(r)) return r;
      if (u(a)) return a;
    }

    return {
      width: 0,
      height: 0
    };
  }, e.appendOrSelect = function (t, e) {
    var n = e.split("."),
        r = n[0],
        i = t.select(e);
    return i.empty() ? t.append(r).attr("class", n.slice(1).join(" ")) : i;
  }, e.prototype.init = function () {
    this.styleHolderElement(), this.addSVGElement(), this.model.getOptions().resizable && this.addResizeListener();
  }, e.prototype.update = function () {
    this.styleHolderElement();
  }, e.prototype.styleHolderElement = function () {
    var t = this.getHolder();
    wg(this.getHolder()).classed(Tg.prefix + "--chart-holder", !0);
    var e = this.model.getOptions(),
        n = e.width,
        r = e.height;
    n !== this.width && (t.style.width = n, this.width = n), r !== this.height && (t.style.height = r, this.height = r);
  }, e.prototype.getHolder = function () {
    return this.model.get("holder");
  }, e.prototype.addSVGElement = function () {
    var t = Tl.getProperty(this.model.getOptions(), "style", "prefix"),
        e = wg(this.getHolder()).append("svg").classed(Tg.prefix + "--" + t + "--chart-svg", !0).attr("height", "100%").attr("width", "100%");
    this.svg = e.node();
  }, e.prototype.getMainSVG = function () {
    return this.svg;
  }, e.prototype.addResizeListener = function () {
    var t = this,
        e = this.getHolder();

    if (e) {
      var n = e.clientWidth,
          r = e.clientHeight,
          i = Tl.debounce(function (i, o) {
        e && (Math.abs(n - e.clientWidth) > 1 || Math.abs(r - e.clientHeight) > 1) && (n = e.clientWidth, r = e.clientHeight, t.services.events.dispatchEvent("chart-resize"));
      }, 12.5);
      new Yg(i).observe(e);
    }
  }, e;
}(hv),
    $g = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return a(e, t), e.prototype.init = function () {
    this.documentFragment = document.createDocumentFragment();
  }, e.prototype.addEventListener = function (t, e) {
    this.documentFragment.addEventListener(t, e);
  }, e.prototype.removeEventListener = function (t, e) {
    this.documentFragment.removeEventListener(t, e);
  }, e.prototype.dispatchEvent = function (t, e) {
    var n;
    e ? n = new CustomEvent(t, {
      detail: e
    }) : (n = document.createEvent("Event")).initEvent(t, !1, !0), this.documentFragment.dispatchEvent(n);
  }, e;
}(hv),
    Zg = {
  value: function value() {}
};

function Kg() {
  for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
    if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    r[t] = [];
  }

  return new Jg(r);
}

function Jg(t) {
  this._ = t;
}

function Qg(t, e) {
  return t.trim().split(/^|\s+/).map(function (t) {
    var n = "",
        r = t.indexOf(".");
    if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {
      type: t,
      name: n
    };
  });
}

function ty(t, e) {
  for (var n, r = 0, i = t.length; r < i; ++r) {
    if ((n = t[r]).name === e) return n.value;
  }
}

function ey(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r) {
    if (t[r].name === e) {
      t[r] = Zg, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  }

  return null != n && t.push({
    name: e,
    value: n
  }), t;
}

Jg.prototype = Kg.prototype = {
  constructor: Jg,
  on: function on(t, e) {
    var n,
        r = this._,
        i = Qg(t + "", r),
        o = -1,
        a = i.length;

    if (!(arguments.length < 2)) {
      if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

      for (; ++o < a;) {
        if (n = (t = i[o]).type) r[n] = ey(r[n], t.name, e);else if (null == e) for (n in r) {
          r[n] = ey(r[n], t.name, null);
        }
      }

      return this;
    }

    for (; ++o < a;) {
      if ((n = (t = i[o]).type) && (n = ty(r[n], t.name))) return n;
    }
  },
  copy: function copy() {
    var t = {},
        e = this._;

    for (var n in e) {
      t[n] = e[n].slice();
    }

    return new Jg(t);
  },
  call: function call(t, e) {
    if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), o = 0; o < n; ++o) {
      i[o] = arguments[o + 2];
    }
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

    for (o = 0, n = (r = this._[t]).length; o < n; ++o) {
      r[o].value.apply(e, i);
    }
  },
  apply: function apply(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

    for (var r = this._[t], i = 0, o = r.length; i < o; ++i) {
      r[i].value.apply(e, n);
    }
  }
};
var ny,
    ry,
    iy = 0,
    oy = 0,
    ay = 0,
    sy = 0,
    uy = 0,
    cy = 0,
    ly = "object" == typeof performance && performance.now ? performance : Date,
    fy = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
  setTimeout(t, 17);
};

function hy() {
  return uy || (fy(py), uy = ly.now() + cy);
}

function py() {
  uy = 0;
}

function dy() {
  this._call = this._time = this._next = null;
}

function vy(t, e, n) {
  var r = new dy();
  return r.restart(t, e, n), r;
}

function gy() {
  uy = (sy = ly.now()) + cy, iy = oy = 0;

  try {
    !function () {
      hy(), ++iy;

      for (var t, e = ny; e;) {
        (t = uy - e._time) >= 0 && e._call.call(null, t), e = e._next;
      }

      --iy;
    }();
  } finally {
    iy = 0, function () {
      var t,
          e,
          n = ny,
          r = 1 / 0;

      for (; n;) {
        n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : ny = e);
      }

      ry = t, _y(r);
    }(), uy = 0;
  }
}

function yy() {
  var t = ly.now(),
      e = t - sy;
  e > 1e3 && (cy -= e, sy = t);
}

function _y(t) {
  iy || (oy && (oy = clearTimeout(oy)), t - uy > 24 ? (t < 1 / 0 && (oy = setTimeout(gy, t - ly.now() - cy)), ay && (ay = clearInterval(ay))) : (ay || (sy = ly.now(), ay = setInterval(yy, 1e3)), iy = 1, fy(gy)));
}

function my(t, e, n) {
  var r = new dy();
  return e = null == e ? 0 : +e, r.restart(function (n) {
    r.stop(), t(n + e);
  }, e, n), r;
}

dy.prototype = vy.prototype = {
  constructor: dy,
  restart: function restart(t, e, n) {
    if ("function" != typeof t) throw new TypeError("callback is not a function");
    n = (null == n ? hy() : +n) + (null == e ? 0 : +e), this._next || ry === this || (ry ? ry._next = this : ny = this, ry = this), this._call = t, this._time = n, _y();
  },
  stop: function stop() {
    this._call && (this._call = null, this._time = 1 / 0, _y());
  }
};
var by = Kg("start", "end", "cancel", "interrupt"),
    xy = [];

function wy(t, e, n, r, i, o) {
  var a = t.__transition;

  if (a) {
    if (n in a) return;
  } else t.__transition = {};

  !function (t, e, n) {
    var r,
        i = t.__transition;

    function o(u) {
      var c, l, f, h;
      if (1 !== n.state) return s();

      for (c in i) {
        if ((h = i[c]).name === n.name) {
          if (3 === h.state) return my(o);
          4 === h.state ? (h.state = 6, h.timer.stop(), h.on.call("interrupt", t, t.__data__, h.index, h.group), delete i[c]) : +c < e && (h.state = 6, h.timer.stop(), h.on.call("cancel", t, t.__data__, h.index, h.group), delete i[c]);
        }
      }

      if (my(function () {
        3 === n.state && (n.state = 4, n.timer.restart(a, n.delay, n.time), a(u));
      }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
        for (n.state = 3, r = new Array(f = n.tween.length), c = 0, l = -1; c < f; ++c) {
          (h = n.tween[c].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = h);
        }

        r.length = l + 1;
      }
    }

    function a(e) {
      for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), o = -1, a = r.length; ++o < a;) {
        r[o].call(t, i);
      }

      5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
    }

    function s() {
      for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
        return;
      }

      delete t.__transition;
    }

    i[e] = n, n.timer = vy(function (t) {
      n.state = 1, n.timer.restart(o, n.delay, n.time), n.delay <= t && o(t - n.delay);
    }, 0, n.time);
  }(t, n, {
    name: e,
    index: r,
    group: i,
    on: by,
    tween: xy,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: 0
  });
}

function Oy(t, e) {
  var n = Ty(t, e);
  if (n.state > 0) throw new Error("too late; already scheduled");
  return n;
}

function Ey(t, e) {
  var n = Ty(t, e);
  if (n.state > 3) throw new Error("too late; already running");
  return n;
}

function Ty(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}

function Sy(t, e) {
  var n, r;
  return function () {
    var i = Ey(this, t),
        o = i.tween;
    if (o !== n) for (var a = 0, s = (r = n = o).length; a < s; ++a) {
      if (r[a].name === e) {
        (r = r.slice()).splice(a, 1);
        break;
      }
    }
    i.tween = r;
  };
}

function My(t, e, n) {
  var r, i;
  if ("function" != typeof n) throw new Error();
  return function () {
    var o = Ey(this, t),
        a = o.tween;

    if (a !== r) {
      i = (r = a).slice();

      for (var s = {
        name: e,
        value: n
      }, u = 0, c = i.length; u < c; ++u) {
        if (i[u].name === e) {
          i[u] = s;
          break;
        }
      }

      u === c && i.push(s);
    }

    o.tween = i;
  };
}

function Ay(t, e, n) {
  var r = t._id;
  return t.each(function () {
    var t = Ey(this, r);
    (t.value || (t.value = {}))[e] = n.apply(this, arguments);
  }), function (t) {
    return Ty(t, r).value[e];
  };
}

function ky(t, e) {
  var n;
  return ("number" == typeof e ? Mh : e instanceof sh ? Oh : (n = sh(e)) ? (e = n, Oh) : Ch)(t, e);
}

function Ly(t) {
  return function () {
    this.removeAttribute(t);
  };
}

function Cy(t) {
  return function () {
    this.removeAttributeNS(t.space, t.local);
  };
}

function Ry(t, e, n) {
  var r,
      i,
      o = n + "";
  return function () {
    var a = this.getAttribute(t);
    return a === o ? null : a === r ? i : i = e(r = a, n);
  };
}

function jy(t, e, n) {
  var r,
      i,
      o = n + "";
  return function () {
    var a = this.getAttributeNS(t.space, t.local);
    return a === o ? null : a === r ? i : i = e(r = a, n);
  };
}

function Py(t, e, n) {
  var r, i, o;
  return function () {
    var a,
        s,
        u = n(this);
    if (null != u) return (a = this.getAttribute(t)) === (s = u + "") ? null : a === r && s === i ? o : (i = s, o = e(r = a, u));
    this.removeAttribute(t);
  };
}

function Dy(t, e, n) {
  var r, i, o;
  return function () {
    var a,
        s,
        u = n(this);
    if (null != u) return (a = this.getAttributeNS(t.space, t.local)) === (s = u + "") ? null : a === r && s === i ? o : (i = s, o = e(r = a, u));
    this.removeAttributeNS(t.space, t.local);
  };
}

function Iy(t, e) {
  return function (n) {
    this.setAttribute(t, e.call(this, n));
  };
}

function Ny(t, e) {
  return function (n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}

function By(t, e) {
  var n, r;

  function i() {
    var i = e.apply(this, arguments);
    return i !== r && (n = (r = i) && Ny(t, i)), n;
  }

  return i._value = e, i;
}

function Fy(t, e) {
  var n, r;

  function i() {
    var i = e.apply(this, arguments);
    return i !== r && (n = (r = i) && Iy(t, i)), n;
  }

  return i._value = e, i;
}

function zy(t, e) {
  return function () {
    Oy(this, t).delay = +e.apply(this, arguments);
  };
}

function Vy(t, e) {
  return e = +e, function () {
    Oy(this, t).delay = e;
  };
}

function Gy(t, e) {
  return function () {
    Ey(this, t).duration = +e.apply(this, arguments);
  };
}

function Uy(t, e) {
  return e = +e, function () {
    Ey(this, t).duration = e;
  };
}

function Hy(t, e) {
  if ("function" != typeof e) throw new Error();
  return function () {
    Ey(this, t).ease = e;
  };
}

function Wy(t, e, n) {
  var r,
      i,
      o = function (t) {
    return (t + "").trim().split(/^|\s+/).every(function (t) {
      var e = t.indexOf(".");
      return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
    });
  }(e) ? Oy : Ey;
  return function () {
    var a = o(this, t),
        s = a.on;
    s !== r && (i = (r = s).copy()).on(e, n), a.on = i;
  };
}

var qy = xg.prototype.constructor;

function Yy(t) {
  return function () {
    this.style.removeProperty(t);
  };
}

function Xy(t, e, n) {
  return function (r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}

function $y(t, e, n) {
  var r, i;

  function o() {
    var o = e.apply(this, arguments);
    return o !== i && (r = (i = o) && Xy(t, o, n)), r;
  }

  return o._value = e, o;
}

function Zy(t) {
  return function (e) {
    this.textContent = t.call(this, e);
  };
}

function Ky(t) {
  var e, n;

  function r() {
    var r = t.apply(this, arguments);
    return r !== n && (e = (n = r) && Zy(r)), e;
  }

  return r._value = t, r;
}

var Jy = 0;

function Qy(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}

function t_(t) {
  return xg().transition(t);
}

function e_() {
  return ++Jy;
}

var n_ = xg.prototype;
Qy.prototype = t_.prototype = {
  constructor: Qy,
  select: function select(t) {
    var e = this._name,
        n = this._id;
    "function" != typeof t && (t = bv(t));

    for (var r = this._groups, i = r.length, o = new Array(i), a = 0; a < i; ++a) {
      for (var s, u, c = r[a], l = c.length, f = o[a] = new Array(l), h = 0; h < l; ++h) {
        (s = c[h]) && (u = t.call(s, s.__data__, h, c)) && ("__data__" in s && (u.__data__ = s.__data__), f[h] = u, wy(f[h], e, n, h, f, Ty(s, n)));
      }
    }

    return new Qy(o, this._parents, e, n);
  },
  selectAll: function selectAll(t) {
    var e = this._name,
        n = this._id;
    "function" != typeof t && (t = wv(t));

    for (var r = this._groups, i = r.length, o = [], a = [], s = 0; s < i; ++s) {
      for (var u, c = r[s], l = c.length, f = 0; f < l; ++f) {
        if (u = c[f]) {
          for (var h, p = t.call(u, u.__data__, f, c), d = Ty(u, n), v = 0, g = p.length; v < g; ++v) {
            (h = p[v]) && wy(h, e, n, v, p, d);
          }

          o.push(p), a.push(u);
        }
      }
    }

    return new Qy(o, a, e, n);
  },
  filter: function filter(t) {
    "function" != typeof t && (t = Ov(t));

    for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
      for (var o, a = e[i], s = a.length, u = r[i] = [], c = 0; c < s; ++c) {
        (o = a[c]) && t.call(o, o.__data__, c, a) && u.push(o);
      }
    }

    return new Qy(r, this._parents, this._name, this._id);
  },
  merge: function merge(t) {
    if (t._id !== this._id) throw new Error();

    for (var e = this._groups, n = t._groups, r = e.length, i = n.length, o = Math.min(r, i), a = new Array(r), s = 0; s < o; ++s) {
      for (var u, c = e[s], l = n[s], f = c.length, h = a[s] = new Array(f), p = 0; p < f; ++p) {
        (u = c[p] || l[p]) && (h[p] = u);
      }
    }

    for (; s < r; ++s) {
      a[s] = e[s];
    }

    return new Qy(a, this._parents, this._name, this._id);
  },
  selection: function selection() {
    return new qy(this._groups, this._parents);
  },
  transition: function transition() {
    for (var t = this._name, e = this._id, n = e_(), r = this._groups, i = r.length, o = 0; o < i; ++o) {
      for (var a, s = r[o], u = s.length, c = 0; c < u; ++c) {
        if (a = s[c]) {
          var l = Ty(a, e);
          wy(a, t, n, c, s, {
            time: l.time + l.delay + l.duration,
            delay: 0,
            duration: l.duration,
            ease: l.ease
          });
        }
      }
    }

    return new Qy(r, this._parents, t, n);
  },
  call: n_.call,
  nodes: n_.nodes,
  node: n_.node,
  size: n_.size,
  empty: n_.empty,
  each: n_.each,
  on: function on(t, e) {
    var n = this._id;
    return arguments.length < 2 ? Ty(this.node(), n).on.on(t) : this.each(Wy(n, t, e));
  },
  attr: function attr(t, e) {
    var n = vv(t),
        r = "transform" === n ? Uh : ky;
    return this.attrTween(t, "function" == typeof e ? (n.local ? Dy : Py)(n, r, Ay(this, "attr." + t, e)) : null == e ? (n.local ? Cy : Ly)(n) : (n.local ? jy : Ry)(n, r, e));
  },
  attrTween: function attrTween(t, e) {
    var n = "attr." + t;
    if (arguments.length < 2) return (n = this.tween(n)) && n._value;
    if (null == e) return this.tween(n, null);
    if ("function" != typeof e) throw new Error();
    var r = vv(t);
    return this.tween(n, (r.local ? By : Fy)(r, e));
  },
  style: function style(t, e, n) {
    var r = "transform" == (t += "") ? Gh : ky;
    return null == e ? this.styleTween(t, function (t, e) {
      var n, r, i;
      return function () {
        var o = Fv(this, t),
            a = (this.style.removeProperty(t), Fv(this, t));
        return o === a ? null : o === n && a === r ? i : i = e(n = o, r = a);
      };
    }(t, r)).on("end.style." + t, Yy(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
      var r, i, o;
      return function () {
        var a = Fv(this, t),
            s = n(this),
            u = s + "";
        return null == s && (this.style.removeProperty(t), u = s = Fv(this, t)), a === u ? null : a === r && u === i ? o : (i = u, o = e(r = a, s));
      };
    }(t, r, Ay(this, "style." + t, e))).each(function (t, e) {
      var n,
          r,
          i,
          o,
          a = "style." + e,
          s = "end." + a;
      return function () {
        var u = Ey(this, t),
            c = u.on,
            l = null == u.value[a] ? o || (o = Yy(e)) : void 0;
        c === n && i === l || (r = (n = c).copy()).on(s, i = l), u.on = r;
      };
    }(this._id, t)) : this.styleTween(t, function (t, e, n) {
      var r,
          i,
          o = n + "";
      return function () {
        var a = Fv(this, t);
        return a === o ? null : a === r ? i : i = e(r = a, n);
      };
    }(t, r, e), n).on("end.style." + t, null);
  },
  styleTween: function styleTween(t, e, n) {
    var r = "style." + (t += "");
    if (arguments.length < 2) return (r = this.tween(r)) && r._value;
    if (null == e) return this.tween(r, null);
    if ("function" != typeof e) throw new Error();
    return this.tween(r, $y(t, e, null == n ? "" : n));
  },
  text: function text(t) {
    return this.tween("text", "function" == typeof t ? function (t) {
      return function () {
        var e = t(this);
        this.textContent = null == e ? "" : e;
      };
    }(Ay(this, "text", t)) : function (t) {
      return function () {
        this.textContent = t;
      };
    }(null == t ? "" : t + ""));
  },
  textTween: function textTween(t) {
    var e = "text";
    if (arguments.length < 1) return (e = this.tween(e)) && e._value;
    if (null == t) return this.tween(e, null);
    if ("function" != typeof t) throw new Error();
    return this.tween(e, Ky(t));
  },
  remove: function remove() {
    return this.on("end.remove", function (t) {
      return function () {
        var e = this.parentNode;

        for (var n in this.__transition) {
          if (+n !== t) return;
        }

        e && e.removeChild(this);
      };
    }(this._id));
  },
  tween: function tween(t, e) {
    var n = this._id;

    if (t += "", arguments.length < 2) {
      for (var r, i = Ty(this.node(), n).tween, o = 0, a = i.length; o < a; ++o) {
        if ((r = i[o]).name === t) return r.value;
      }

      return null;
    }

    return this.each((null == e ? Sy : My)(n, t, e));
  },
  delay: function delay(t) {
    var e = this._id;
    return arguments.length ? this.each(("function" == typeof t ? zy : Vy)(e, t)) : Ty(this.node(), e).delay;
  },
  duration: function duration(t) {
    var e = this._id;
    return arguments.length ? this.each(("function" == typeof t ? Gy : Uy)(e, t)) : Ty(this.node(), e).duration;
  },
  ease: function ease(t) {
    var e = this._id;
    return arguments.length ? this.each(Hy(e, t)) : Ty(this.node(), e).ease;
  },
  end: function end() {
    var t,
        e,
        n = this,
        r = n._id,
        i = n.size();
    return new Promise(function (o, a) {
      var s = {
        value: a
      },
          u = {
        value: function value() {
          0 == --i && o();
        }
      };
      n.each(function () {
        var n = Ey(this, r),
            i = n.on;
        i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(u)), n.on = e;
      });
    });
  }
};
var r_ = {
  time: null,
  delay: 0,
  duration: 250,
  ease: function ease(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
  }
};

function i_(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]);) {
    if (!(t = t.parentNode)) return r_.time = hy(), r_;
  }

  return n;
}

xg.prototype.interrupt = function (t) {
  return this.each(function () {
    !function (t, e) {
      var n,
          r,
          i,
          o = t.__transition,
          a = !0;

      if (o) {
        for (i in e = null == e ? null : e + "", o) {
          (n = o[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete o[i]) : a = !1;
        }

        a && delete t.__transition;
      }
    }(this, t);
  });
}, xg.prototype.transition = function (t) {
  var e, n;
  t instanceof Qy ? (e = t._id, t = t._name) : (e = e_(), (n = r_).time = hy(), t = null == t ? null : t + "");

  for (var r = this._groups, i = r.length, o = 0; o < i; ++o) {
    for (var a, s = r[o], u = s.length, c = 0; c < u; ++c) {
      (a = s[c]) && wy(a, t, e, c, s, n || i_(a, e));
    }
  }

  return new Qy(r, this._parents, t, e);
};

var o_ = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.pendingTransitions = {}, e;
  }

  return a(e, t), e.prototype.init = function () {
    var t = this;
    this.services.events.addEventListener("model-update", function () {
      t.pendingTransitions = {};
    });
  }, e.prototype.getTransition = function (t, e) {
    var n = this;
    if (!1 === this.model.getOptions().animations || !1 === e) return this.getInstantTransition(t);
    var r = t_(t).duration(Tl.getProperty($l, t, "duration") || $l["default"].duration);
    return this.pendingTransitions[r._id] = r, r.on("end interrupt cancel", function () {
      delete n.pendingTransitions[r._id];
    }), r;
  }, e.prototype.getInstantTransition = function (t) {
    var e = this,
        n = t_(t).duration(0);
    return this.pendingTransitions[n._id] = n, n.on("end interrupt cancel", function () {
      delete e.pendingTransitions[n._id];
    }), n;
  }, e.prototype.getPendingTransitions = function () {
    return this.pendingTransitions;
  }, e;
}(hv);

function a_(t) {
  if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || "object" == typeof t && "[object Date]" === e ? new Date(t.getTime()) : "number" == typeof t || "[object Number]" === e ? new Date(t) : ("string" != typeof t && "[object String]" !== e || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}

function s_(t) {
  if (null === t || !0 === t || !1 === t) return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}

function u_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = a_(t),
      r = s_(e);
  return n.setDate(n.getDate() + r), n;
}

function c_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = a_(t).getTime(),
      r = s_(e);
  return new Date(n + r);
}

function l_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return c_(t, 36e5 * n);
}

function f_(t) {
  var e = new Date(t.getTime()),
      n = Math.ceil(e.getTimezoneOffset());
  return e.setSeconds(0, 0), 6e4 * n + e.getTime() % 6e4;
}

function h_(t) {
  if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
  var e = a_(t);
  return e.setHours(0, 0, 0, 0), e;
}

function p_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = h_(t),
      r = h_(e),
      i = n.getTime() - f_(n),
      o = r.getTime() - f_(r);
  return Math.round((i - o) / 864e5);
}

function d_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return c_(t, 6e4 * n);
}

function v_(t) {
  if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
  var e = a_(t),
      n = e.getFullYear(),
      r = e.getMonth(),
      i = new Date(0);
  return i.setFullYear(n, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}

function g_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = a_(t),
      r = s_(e),
      i = n.getMonth() + r,
      o = new Date(0);
  o.setFullYear(n.getFullYear(), i, 1), o.setHours(0, 0, 0, 0);
  var a = v_(o);
  return n.setMonth(i, Math.min(a, n.getDate())), n;
}

function y_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return g_(t, 12 * n);
}

function __(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = a_(t),
      r = a_(e),
      i = n.getTime() - r.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}

function m_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = a_(t),
      r = a_(e),
      i = n.getFullYear() - r.getFullYear(),
      o = n.getMonth() - r.getMonth();
  return 12 * i + o;
}

function b_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = a_(t),
      r = a_(e);
  return n.getFullYear() - r.getFullYear();
}

function x_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = a_(t),
      r = a_(e);
  return n.getTime() - r.getTime();
}

function w_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return u_(t, -n);
}

function O_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return l_(t, -n);
}

function E_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return d_(t, -n);
}

function T_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return g_(t, -n);
}

function S_(t, e) {
  if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = s_(e);
  return y_(t, -n);
}

var M_ = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.scaleTypes = {
      top: null,
      right: null,
      bottom: null,
      left: null
    }, e.scales = {
      top: null,
      right: null,
      bottom: null,
      left: null
    }, e;
  }

  return a(e, t), e.prototype.getDomainAxisPosition = function () {
    return this.domainAxisPosition;
  }, e.prototype.getRangeAxisPosition = function () {
    return this.rangeAxisPosition;
  }, e.prototype.update = function (t) {
    var e = this;
    this.determineOrientation(), Object.keys(u).map(function (t) {
      return u[t];
    }).forEach(function (t) {
      e.scales[t] = e.createScale(t);
    });
  }, e.prototype.determineOrientation = function () {
    var t = this,
        e = this.model.getOptions();
    [u.LEFT, u.BOTTOM, u.RIGHT, u.TOP].forEach(function (n) {
      var r = Tl.getProperty(e, "axes", n);

      if (r) {
        var i = r.scaleType || f.LINEAR;
        t.scaleTypes[n] = i, i === f.LINEAR ? t.rangeAxisPosition = n : t.domainAxisPosition = n;
      }
    }), this.rangeAxisPosition === u.LEFT && this.domainAxisPosition === u.BOTTOM ? this.orientation = c.VERTICAL : this.orientation = c.HORIZONTAL;
  }, e.prototype.getOrientation = function () {
    return this.orientation;
  }, e.prototype.getScaleByPosition = function (t) {
    return this.scales[t];
  }, e.prototype.getScaleTypeByPosition = function (t) {
    return this.scaleTypes[t];
  }, e.prototype.getDomainScale = function () {
    return this.scales[this.domainAxisPosition];
  }, e.prototype.getRangeScale = function () {
    return this.scales[this.rangeAxisPosition];
  }, e.prototype.getMainXAxisPosition = function () {
    var t = [u.BOTTOM, u.TOP];
    return [this.domainAxisPosition, this.rangeAxisPosition].find(function (e) {
      return t.indexOf(e) > -1;
    });
  }, e.prototype.getMainYAxisPosition = function () {
    var t = [u.LEFT, u.RIGHT];
    return [this.domainAxisPosition, this.rangeAxisPosition].find(function (e) {
      return t.indexOf(e) > -1;
    });
  }, e.prototype.getMainXScale = function () {
    return this.scales[this.getMainXAxisPosition()];
  }, e.prototype.getMainYScale = function () {
    return this.scales[this.getMainYAxisPosition()];
  }, e.prototype.getValueFromScale = function (t, e, n) {
    var r = isNaN(e) ? e.value : e,
        i = this.scaleTypes[t],
        o = this.scales[t];
    return i === f.LABELS ? o(this.model.getDisplayData().labels[n]) + o.step() / 2 : i === f.TIME ? o(new Date(e.date || e.label)) : o(r);
  }, e.prototype.getDomainValue = function (t, e) {
    return this.getValueFromScale(this.domainAxisPosition, t, e);
  }, e.prototype.getRangeValue = function (t, e) {
    return this.getValueFromScale(this.rangeAxisPosition, t, e);
  }, e.prototype.getXValue = function (t, e) {
    var n = Object.assign(t, {
      pos: "bottom"
    });
    return this.getValueFromScale(n, e);
  }, e.prototype.getYValue = function (t, e) {
    var n = Object.assign(t, {
      pos: "left"
    });
    return this.getValueFromScale(n, e);
  }, e.prototype.getDataFromDomain = function (t) {
    var e = this.model.getDisplayData(),
        n = [];

    switch (this.scaleTypes[this.domainAxisPosition]) {
      case f.LABELS:
        var r = e.labels.indexOf(t);
        e.datasets.forEach(function (t) {
          n.push({
            datasetLabel: t.label,
            value: t.data[r]
          });
        });
        break;

      case f.TIME:
        var i = Object.keys(e.datasets[0].data[0]).filter(function (t) {
          return "value" !== t;
        })[0];
        e.datasets.forEach(function (e) {
          var r = e.label;
          e.data.filter(function (e) {
            var n = new Date(e[i]),
                r = new Date(t);
            return n.getTime() === r.getTime();
          }).forEach(function (t) {
            n.push(Object.assign({
              datasetLabel: r,
              value: t.value
            }, t));
          });
        });
    }

    return n;
  }, e.prototype.getScaleDomain = function (t) {
    var e,
        n = this.model.getOptions(),
        r = Tl.getProperty(n, "axes", t),
        i = this.model.getDisplayData(),
        o = i.datasets,
        a = i.labels;
    if (r && r.scaleType === f.LABELS) return a || this.model.getDisplayData().datasets[0].data.map(function (t, e) {
      return e + 1;
    });
    if (r.stacked) e = Sf(a.reduce(function (t, e, n) {
      var r = o.map(function (t) {
        return isNaN(t.data[n]) ? t.data[n].value : t.data[n];
      }),
          i = r.reduce(function (t, e) {
        return t + e;
      }, 0);
      return t.concat(i, function (t, e) {
        var n,
            r,
            i = t.length,
            o = -1;

        if (null == e) {
          for (; ++o < i;) {
            if (null != (n = t[o]) && n >= n) for (r = n; ++o < i;) {
              null != (n = t[o]) && r > n && (r = n);
            }
          }
        } else for (; ++o < i;) {
          if (null != (n = e(t[o], o, t)) && n >= n) for (r = n; ++o < i;) {
            null != (n = e(t[o], o, t)) && r > n && (r = n);
          }
        }

        return r;
      }(r));
    }, []).concat(0));else {
      var s = o.reduce(function (t, e) {
        return e.data.forEach(function (e) {
          t = r.scaleType === f.TIME ? t.concat(e.date) : t.concat(isNaN(e) ? e.value : e);
        }), t;
      }, []);
      r.scaleType !== f.TIME && (s = s.concat(0)), e = Sf(s);
    }

    if (r.scaleType === f.TIME) {
      var u = Tl.getProperty(n, "timeScale", "addSpaceOnEdges");

      if (u) {
        var c = new Date(e[0]),
            l = new Date(e[1]);
        return function (t, e) {
          if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");

          var n = a_(t),
              r = a_(e),
              i = __(n, r),
              o = Math.abs(b_(n, r));

          n.setFullYear(n.getFullYear() - i * o);
          var a = __(n, r) === -i,
              s = i * (o - a);
          return 0 === s ? 0 : s;
        }(l, c) > 1 ? [S_(c, u), y_(l, u)] : function (t, e) {
          if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");

          var n = a_(t),
              r = a_(e),
              i = __(n, r),
              o = Math.abs(m_(n, r));

          n.setMonth(n.getMonth() - i * o);
          var a = __(n, r) === -i,
              s = i * (o - a);
          return 0 === s ? 0 : s;
        }(l, c) > 1 ? [T_(c, u), g_(l, u)] : function (t, e) {
          if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");

          var n = a_(t),
              r = a_(e),
              i = __(n, r),
              o = Math.abs(p_(n, r));

          n.setDate(n.getDate() - i * o);
          var a = __(n, r) === -i,
              s = i * (o - a);
          return 0 === s ? 0 : s;
        }(l, c) > 1 ? [w_(c, u), u_(l, u)] : function (t, e) {
          if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
          var n = x_(t, e) / 36e5;
          return n > 0 ? Math.floor(n) : Math.ceil(n);
        }(l, c) > 1 ? [O_(c, u), l_(l, u)] : function (t, e) {
          if (arguments.length < 2) throw new TypeError("2 arguments required, but only " + arguments.length + " present");
          var n = x_(t, e) / 6e4;
          return n > 0 ? Math.floor(n) : Math.ceil(n);
        }(l, c) > 1 ? [E_(c, u), d_(l, u)] : [c, l];
      }

      return [new Date(e[0]), new Date(e[1])];
    }

    return e[1] = 1.1 * e[1], e[0] < 0 && (e[0] = 1.1 * e[0]), e;
  }, e.prototype.createScale = function (t) {
    var e = Tl.getProperty(this.model.getOptions(), "axes", t);
    if (!e) return null;
    var n,
        r = Tl.getProperty(e, "scaleType") || f.LINEAR;
    return this.scaleTypes[t] = r, (n = r === f.TIME ? function () {
      return Pf.apply(lv(Bp, Np, Pp, Rp, Cp, Lp, kp, Ap, $p).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
    }() : r === f.LOG ? function t() {
      var e = Ep(Jh()).domain([1, 10]);
      return e.copy = function () {
        return Kh(e, t()).base(e.base());
      }, Pf.apply(e, arguments), e;
    }().base(e.base || 10) : r === f.LABELS ? Hf() : function t() {
      var e = Qh(qh, qh);
      return e.copy = function () {
        return Kh(e, t());
      }, Pf.apply(e, arguments), gp(e);
    }()).domain(this.getScaleDomain(t)), n;
  }, e;
}(hv),
    A_ = Math.PI,
    k_ = 2 * A_,
    L_ = k_ - 1e-6;

function C_() {
  this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
}

function R_() {
  return new C_();
}

function j_(t) {
  return function () {
    return t;
  };
}

C_.prototype = R_.prototype = {
  constructor: C_,
  moveTo: function moveTo(t, e) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
  },
  closePath: function closePath() {
    null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function lineTo(t, e) {
    this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
  },
  quadraticCurveTo: function quadraticCurveTo(t, e, n, r) {
    this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function bezierCurveTo(t, e, n, r, i, o) {
    this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +o);
  },
  arcTo: function arcTo(t, e, n, r, i) {
    t = +t, e = +e, n = +n, r = +r, i = +i;
    var o = this._x1,
        a = this._y1,
        s = n - t,
        u = r - e,
        c = o - t,
        l = a - e,
        f = c * c + l * l;
    if (i < 0) throw new Error("negative radius: " + i);
    if (null === this._x1) this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);else if (f > 1e-6) {
      if (Math.abs(l * s - u * c) > 1e-6 && i) {
        var h = n - o,
            p = r - a,
            d = s * s + u * u,
            v = h * h + p * p,
            g = Math.sqrt(d),
            y = Math.sqrt(f),
            _ = i * Math.tan((A_ - Math.acos((d + f - v) / (2 * g * y))) / 2),
            m = _ / y,
            b = _ / g;

        Math.abs(m - 1) > 1e-6 && (this._ += "L" + (t + m * c) + "," + (e + m * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * h > c * p) + "," + (this._x1 = t + b * s) + "," + (this._y1 = e + b * u);
      } else this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
    } else ;
  },
  arc: function arc(t, e, n, r, i, o) {
    t = +t, e = +e, o = !!o;
    var a = (n = +n) * Math.cos(r),
        s = n * Math.sin(r),
        u = t + a,
        c = e + s,
        l = 1 ^ o,
        f = o ? r - i : i - r;
    if (n < 0) throw new Error("negative radius: " + n);
    null === this._x1 ? this._ += "M" + u + "," + c : (Math.abs(this._x1 - u) > 1e-6 || Math.abs(this._y1 - c) > 1e-6) && (this._ += "L" + u + "," + c), n && (f < 0 && (f = f % k_ + k_), f > L_ ? this._ += "A" + n + "," + n + ",0,1," + l + "," + (t - a) + "," + (e - s) + "A" + n + "," + n + ",0,1," + l + "," + (this._x1 = u) + "," + (this._y1 = c) : f > 1e-6 && (this._ += "A" + n + "," + n + ",0," + +(f >= A_) + "," + l + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
  },
  rect: function rect(t, e, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function toString() {
    return this._;
  }
};
var P_ = Math.abs,
    D_ = Math.atan2,
    I_ = Math.cos,
    N_ = Math.max,
    B_ = Math.min,
    F_ = Math.sin,
    z_ = Math.sqrt,
    V_ = Math.PI,
    G_ = V_ / 2,
    U_ = 2 * V_;

function H_(t) {
  return t > 1 ? 0 : t < -1 ? V_ : Math.acos(t);
}

function W_(t) {
  return t >= 1 ? G_ : t <= -1 ? -G_ : Math.asin(t);
}

function q_(t) {
  return t.innerRadius;
}

function Y_(t) {
  return t.outerRadius;
}

function X_(t) {
  return t.startAngle;
}

function $_(t) {
  return t.endAngle;
}

function Z_(t) {
  return t && t.padAngle;
}

function K_(t, e, n, r, i, o, a, s) {
  var u = n - t,
      c = r - e,
      l = a - i,
      f = s - o,
      h = f * u - l * c;
  if (!(h * h < 1e-12)) return [t + (h = (l * (e - o) - f * (t - i)) / h) * u, e + h * c];
}

function J_(t, e, n, r, i, o, a) {
  var s = t - n,
      u = e - r,
      c = (a ? o : -o) / z_(s * s + u * u),
      l = c * u,
      f = -c * s,
      h = t + l,
      p = e + f,
      d = n + l,
      v = r + f,
      g = (h + d) / 2,
      y = (p + v) / 2,
      _ = d - h,
      m = v - p,
      b = _ * _ + m * m,
      x = i - o,
      w = h * v - d * p,
      O = (m < 0 ? -1 : 1) * z_(N_(0, x * x * b - w * w)),
      E = (w * m - _ * O) / b,
      T = (-w * _ - m * O) / b,
      S = (w * m + _ * O) / b,
      M = (-w * _ + m * O) / b,
      A = E - g,
      k = T - y,
      L = S - g,
      C = M - y;

  return A * A + k * k > L * L + C * C && (E = S, T = M), {
    cx: E,
    cy: T,
    x01: -l,
    y01: -f,
    x11: E * (i / x - 1),
    y11: T * (i / x - 1)
  };
}

function Q_() {
  var t = q_,
      e = Y_,
      n = j_(0),
      r = null,
      i = X_,
      o = $_,
      a = Z_,
      s = null;

  function u() {
    var u,
        c,
        l = +t.apply(this, arguments),
        f = +e.apply(this, arguments),
        h = i.apply(this, arguments) - G_,
        p = o.apply(this, arguments) - G_,
        d = P_(p - h),
        v = p > h;
    if (s || (s = u = R_()), f < l && (c = f, f = l, l = c), f > 1e-12) {
      if (d > U_ - 1e-12) s.moveTo(f * I_(h), f * F_(h)), s.arc(0, 0, f, h, p, !v), l > 1e-12 && (s.moveTo(l * I_(p), l * F_(p)), s.arc(0, 0, l, p, h, v));else {
        var g,
            y,
            _ = h,
            m = p,
            b = h,
            x = p,
            w = d,
            O = d,
            E = a.apply(this, arguments) / 2,
            T = E > 1e-12 && (r ? +r.apply(this, arguments) : z_(l * l + f * f)),
            S = B_(P_(f - l) / 2, +n.apply(this, arguments)),
            M = S,
            A = S;

        if (T > 1e-12) {
          var k = W_(T / l * F_(E)),
              L = W_(T / f * F_(E));
          (w -= 2 * k) > 1e-12 ? (b += k *= v ? 1 : -1, x -= k) : (w = 0, b = x = (h + p) / 2), (O -= 2 * L) > 1e-12 ? (_ += L *= v ? 1 : -1, m -= L) : (O = 0, _ = m = (h + p) / 2);
        }

        var C = f * I_(_),
            R = f * F_(_),
            j = l * I_(x),
            P = l * F_(x);

        if (S > 1e-12) {
          var D,
              I = f * I_(m),
              N = f * F_(m),
              B = l * I_(b),
              F = l * F_(b);

          if (d < V_ && (D = K_(C, R, B, F, I, N, j, P))) {
            var z = C - D[0],
                V = R - D[1],
                G = I - D[0],
                U = N - D[1],
                H = 1 / F_(H_((z * G + V * U) / (z_(z * z + V * V) * z_(G * G + U * U))) / 2),
                W = z_(D[0] * D[0] + D[1] * D[1]);
            M = B_(S, (l - W) / (H - 1)), A = B_(S, (f - W) / (H + 1));
          }
        }

        O > 1e-12 ? A > 1e-12 ? (g = J_(B, F, C, R, f, A, v), y = J_(I, N, j, P, f, A, v), s.moveTo(g.cx + g.x01, g.cy + g.y01), A < S ? s.arc(g.cx, g.cy, A, D_(g.y01, g.x01), D_(y.y01, y.x01), !v) : (s.arc(g.cx, g.cy, A, D_(g.y01, g.x01), D_(g.y11, g.x11), !v), s.arc(0, 0, f, D_(g.cy + g.y11, g.cx + g.x11), D_(y.cy + y.y11, y.cx + y.x11), !v), s.arc(y.cx, y.cy, A, D_(y.y11, y.x11), D_(y.y01, y.x01), !v))) : (s.moveTo(C, R), s.arc(0, 0, f, _, m, !v)) : s.moveTo(C, R), l > 1e-12 && w > 1e-12 ? M > 1e-12 ? (g = J_(j, P, I, N, l, -M, v), y = J_(C, R, B, F, l, -M, v), s.lineTo(g.cx + g.x01, g.cy + g.y01), M < S ? s.arc(g.cx, g.cy, M, D_(g.y01, g.x01), D_(y.y01, y.x01), !v) : (s.arc(g.cx, g.cy, M, D_(g.y01, g.x01), D_(g.y11, g.x11), !v), s.arc(0, 0, l, D_(g.cy + g.y11, g.cx + g.x11), D_(y.cy + y.y11, y.cx + y.x11), v), s.arc(y.cx, y.cy, M, D_(y.y11, y.x11), D_(y.y01, y.x01), !v))) : s.arc(0, 0, l, x, b, v) : s.lineTo(j, P);
      }
    } else s.moveTo(0, 0);
    if (s.closePath(), u) return s = null, u + "" || null;
  }

  return u.centroid = function () {
    var n = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2,
        r = (+i.apply(this, arguments) + +o.apply(this, arguments)) / 2 - V_ / 2;
    return [I_(r) * n, F_(r) * n];
  }, u.innerRadius = function (e) {
    return arguments.length ? (t = "function" == typeof e ? e : j_(+e), u) : t;
  }, u.outerRadius = function (t) {
    return arguments.length ? (e = "function" == typeof t ? t : j_(+t), u) : e;
  }, u.cornerRadius = function (t) {
    return arguments.length ? (n = "function" == typeof t ? t : j_(+t), u) : n;
  }, u.padRadius = function (t) {
    return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : j_(+t), u) : r;
  }, u.startAngle = function (t) {
    return arguments.length ? (i = "function" == typeof t ? t : j_(+t), u) : i;
  }, u.endAngle = function (t) {
    return arguments.length ? (o = "function" == typeof t ? t : j_(+t), u) : o;
  }, u.padAngle = function (t) {
    return arguments.length ? (a = "function" == typeof t ? t : j_(+t), u) : a;
  }, u.context = function (t) {
    return arguments.length ? (s = null == t ? null : t, u) : s;
  }, u;
}

function tm(t) {
  this._context = t;
}

function em(t) {
  return new tm(t);
}

function nm(t) {
  return t[0];
}

function rm(t) {
  return t[1];
}

function im(t, e) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}

function om(t) {
  return t;
}

tm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;

      case 1:
        this._point = 2;

      default:
        this._context.lineTo(t, e);

    }
  }
};
var am = Array.prototype.slice;

function sm() {}

function um(t, e, n) {
  t._context.bezierCurveTo((2 * t._x0 + t._x1) / 3, (2 * t._y0 + t._y1) / 3, (t._x0 + 2 * t._x1) / 3, (t._y0 + 2 * t._y1) / 3, (t._x0 + 4 * t._x1 + e) / 6, (t._y0 + 4 * t._y1 + n) / 6);
}

function cm(t) {
  this._context = t;
}

function lm(t) {
  return new cm(t);
}

function fm(t) {
  this._context = t;
}

function hm(t) {
  return new fm(t);
}

function pm(t) {
  this._context = t;
}

function dm(t) {
  return new pm(t);
}

function vm(t, e) {
  this._basis = new cm(t), this._beta = e;
}

cm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 3:
        um(this, this._x1, this._y1);

      case 2:
        this._context.lineTo(this._x1, this._y1);

    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

      default:
        um(this, t, e);
    }

    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
}, fm.prototype = {
  areaStart: sm,
  areaEnd: sm,
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;

      case 2:
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;

      case 3:
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
    }
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = t, this._y2 = e;
        break;

      case 1:
        this._point = 2, this._x3 = t, this._y3 = e;
        break;

      case 2:
        this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;

      default:
        um(this, t, e);
    }

    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
}, pm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + t) / 6,
            r = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;

      case 3:
        this._point = 4;

      default:
        um(this, t, e);
    }

    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
}, vm.prototype = {
  lineStart: function lineStart() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function lineEnd() {
    var t = this._x,
        e = this._y,
        n = t.length - 1;
    if (n > 0) for (var r, i = t[0], o = e[0], a = t[n] - i, s = e[n] - o, u = -1; ++u <= n;) {
      r = u / n, this._basis.point(this._beta * t[u] + (1 - this._beta) * (i + r * a), this._beta * e[u] + (1 - this._beta) * (o + r * s));
    }
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function point(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};

var gm = function t(e) {
  function n(t) {
    return 1 === e ? new cm(t) : new vm(t, e);
  }

  return n.beta = function (e) {
    return t(+e);
  }, n;
}(.85);

function ym(t, e, n) {
  t._context.bezierCurveTo(t._x1 + t._k * (t._x2 - t._x0), t._y1 + t._k * (t._y2 - t._y0), t._x2 + t._k * (t._x1 - e), t._y2 + t._k * (t._y1 - n), t._x2, t._y2);
}

function _m(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}

_m.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);

        break;

      case 3:
        ym(this, this._x1, this._y1);
    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;

      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;

      case 2:
        this._point = 3;

      default:
        ym(this, t, e);
    }

    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};

var mm = function t(e) {
  function n(t) {
    return new _m(t, e);
  }

  return n.tension = function (e) {
    return t(+e);
  }, n;
}(0);

function bm(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}

bm.prototype = {
  areaStart: sm,
  areaEnd: sm,
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;

      case 2:
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;

      case 3:
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
    }
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;

      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;

      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;

      default:
        ym(this, t, e);
    }

    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};

var xm = function t(e) {
  function n(t) {
    return new bm(t, e);
  }

  return n.tension = function (e) {
    return t(+e);
  }, n;
}(0);

function wm(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}

wm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;

      case 3:
        this._point = 4;

      default:
        ym(this, t, e);
    }

    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};

var Om = function t(e) {
  function n(t) {
    return new wm(t, e);
  }

  return n.tension = function (e) {
    return t(+e);
  }, n;
}(0);

function Em(t, e, n) {
  var r = t._x1,
      i = t._y1,
      o = t._x2,
      a = t._y2;

  if (t._l01_a > 1e-12) {
    var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a,
        u = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / u, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / u;
  }

  if (t._l23_a > 1e-12) {
    var c = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a,
        l = 3 * t._l23_a * (t._l23_a + t._l12_a);
    o = (o * c + t._x1 * t._l23_2a - e * t._l12_2a) / l, a = (a * c + t._y1 * t._l23_2a - n * t._l12_2a) / l;
  }

  t._context.bezierCurveTo(r, i, o, a, t._x2, t._y2);
}

function Tm(t, e) {
  this._context = t, this._alpha = e;
}

Tm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);

        break;

      case 3:
        this.point(this._x2, this._y2);
    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t,
          r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;

      default:
        Em(this, t, e);
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};

var Sm = function t(e) {
  function n(t) {
    return e ? new Tm(t, e) : new _m(t, 0);
  }

  return n.alpha = function (e) {
    return t(+e);
  }, n;
}(.5);

function Mm(t, e) {
  this._context = t, this._alpha = e;
}

Mm.prototype = {
  areaStart: sm,
  areaEnd: sm,
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;

      case 2:
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;

      case 3:
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
    }
  },
  point: function point(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t,
          r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;

      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;

      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;

      default:
        Em(this, t, e);
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};

var Am = function t(e) {
  function n(t) {
    return e ? new Mm(t, e) : new bm(t, 0);
  }

  return n.alpha = function (e) {
    return t(+e);
  }, n;
}(.5);

function km(t, e) {
  this._context = t, this._alpha = e;
}

km.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t,
          r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1;
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;

      case 3:
        this._point = 4;

      default:
        Em(this, t, e);
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};

var Lm = function t(e) {
  function n(t) {
    return e ? new km(t, e) : new wm(t, 0);
  }

  return n.alpha = function (e) {
    return t(+e);
  }, n;
}(.5);

function Cm(t) {
  this._context = t;
}

function Rm(t) {
  return new Cm(t);
}

function jm(t) {
  return t < 0 ? -1 : 1;
}

function Pm(t, e, n) {
  var r = t._x1 - t._x0,
      i = e - t._x1,
      o = (t._y1 - t._y0) / (r || i < 0 && -0),
      a = (n - t._y1) / (i || r < 0 && -0),
      s = (o * i + a * r) / (r + i);
  return (jm(o) + jm(a)) * Math.min(Math.abs(o), Math.abs(a), .5 * Math.abs(s)) || 0;
}

function Dm(t, e) {
  var n = t._x1 - t._x0;
  return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
}

function Im(t, e, n) {
  var r = t._x0,
      i = t._y0,
      o = t._x1,
      a = t._y1,
      s = (o - r) / 3;

  t._context.bezierCurveTo(r + s, i + s * e, o - s, a - s * n, o, a);
}

function Nm(t) {
  this._context = t;
}

function Bm(t) {
  this._context = new Fm(t);
}

function Fm(t) {
  this._context = t;
}

function zm(t) {
  return new Nm(t);
}

function Vm(t) {
  return new Bm(t);
}

function Gm(t) {
  this._context = t;
}

function Um(t) {
  var e,
      n,
      r = t.length - 1,
      i = new Array(r),
      o = new Array(r),
      a = new Array(r);

  for (i[0] = 0, o[0] = 2, a[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) {
    i[e] = 1, o[e] = 4, a[e] = 4 * t[e] + 2 * t[e + 1];
  }

  for (i[r - 1] = 2, o[r - 1] = 7, a[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) {
    n = i[e] / o[e - 1], o[e] -= n, a[e] -= n * a[e - 1];
  }

  for (i[r - 1] = a[r - 1] / o[r - 1], e = r - 2; e >= 0; --e) {
    i[e] = (a[e] - i[e + 1]) / o[e];
  }

  for (o[r - 1] = (t[r] + i[r - 1]) / 2, e = 0; e < r - 1; ++e) {
    o[e] = 2 * t[e + 1] - i[e + 1];
  }

  return [i, o];
}

function Hm(t) {
  return new Gm(t);
}

function Wm(t, e) {
  this._context = t, this._t = e;
}

function qm(t) {
  return new Wm(t, .5);
}

function Ym(t) {
  return new Wm(t, 0);
}

function Xm(t) {
  return new Wm(t, 1);
}

function $m(t, e) {
  if ((i = t.length) > 1) for (var n, r, i, o = 1, a = t[e[0]], s = a.length; o < i; ++o) {
    for (r = a, a = t[e[o]], n = 0; n < s; ++n) {
      a[n][1] += a[n][0] = isNaN(r[n][1]) ? r[n][0] : r[n][1];
    }
  }
}

function Zm(t) {
  for (var e = t.length, n = new Array(e); --e >= 0;) {
    n[e] = e;
  }

  return n;
}

function Km(t, e) {
  return t[e];
}

Cm.prototype = {
  areaStart: sm,
  areaEnd: sm,
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    this._point && this._context.closePath();
  },
  point: function point(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
}, Nm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);

        break;

      case 3:
        Im(this, this._t0, Dm(this, this._t0));
    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(t, e) {
    var n = NaN;

    if (e = +e, (t = +t) !== this._x1 || e !== this._y1) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3, Im(this, Dm(this, n = Pm(this, t, e)), n);
          break;

        default:
          Im(this, this._t0, n = Pm(this, t, e));
      }

      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
    }
  }
}, (Bm.prototype = Object.create(Nm.prototype)).point = function (t, e) {
  Nm.prototype.point.call(this, e, t);
}, Fm.prototype = {
  moveTo: function moveTo(t, e) {
    this._context.moveTo(e, t);
  },
  closePath: function closePath() {
    this._context.closePath();
  },
  lineTo: function lineTo(t, e) {
    this._context.lineTo(e, t);
  },
  bezierCurveTo: function bezierCurveTo(t, e, n, r, i, o) {
    this._context.bezierCurveTo(e, t, r, n, o, i);
  }
}, Gm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x = [], this._y = [];
  },
  lineEnd: function lineEnd() {
    var t = this._x,
        e = this._y,
        n = t.length;
    if (n) if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), 2 === n) this._context.lineTo(t[1], e[1]);else for (var r = Um(t), i = Um(e), o = 0, a = 1; a < n; ++o, ++a) {
      this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], t[a], e[a]);
    }
    (this._line || 0 !== this._line && 1 === n) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function point(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
}, Wm.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function point(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;

      case 1:
        this._point = 2;

      default:
        if (this._t <= 0) this._context.lineTo(this._x, e), this._context.lineTo(t, e);else {
          var n = this._x * (1 - this._t) + t * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, e);
        }
    }

    this._x = t, this._y = e;
  }
};

var Jm,
    Qm,
    tb = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.curveTypes = {
      curveLinear: em,
      curveLinearClosed: Rm,
      curveBasis: lm,
      curveBasisClosed: hm,
      curveBasisOpen: dm,
      curveBundle: gm,
      curveCardinal: mm,
      curveCardinalClosed: xm,
      curveCardinalOpen: Om,
      curveCatmullRom: Sm,
      curveCatmullRomClosed: Am,
      curveCatmullRomOpen: Lm,
      curveMonotoneX: zm,
      curveMonotoneY: Vm,
      curveNatural: Hm,
      curveStep: qm,
      curveStepAfter: Xm,
      curveStepBefore: Ym
    }, e;
  }

  return a(e, t), e.prototype.getD3Curve = function () {
    var t = "curveLinear",
        e = this.model.getOptions().curve;

    if (e && (t = "string" == typeof e ? e : e.name), this.curveTypes[t]) {
      var n = this.curveTypes[t];
      return e && Object.keys(e).forEach(function (t) {
        n[t] && (n = n[t](e[t]));
      }), n;
    }

    return console.warn("The curve type '" + t + "' is invalid, using 'curveLinear' instead"), this.curveTypes.curveLinear;
  }, e;
}(hv),
    eb = function () {
  function t(t, e, n) {
    this.configs = {}, this.model = t, this.services = e, n && (this.configs = n), this.parent || this.setParent(wg(this.services.domUtils.getMainSVG()));
  }

  return t.prototype.init = function () {}, t.prototype.render = function (t) {
    console.error("render() method is not implemented");
  }, t.prototype.destroy = function () {}, t.prototype.setModel = function (t) {
    this.model = t;
  }, t.prototype.setServices = function (t) {
    this.services = t;
  }, t.prototype.setParent = function (t) {
    var e = this.parent;

    if (this.parent = t, (!e || e.node() !== t.node()) && this.type) {
      var n = Tl.getProperty(this.model.getOptions(), "style", "prefix");
      this.parent.classed(Tg.prefix + "--" + n + "--" + this.type, !0), e && e.classed(Tg.prefix + "--" + n + "--" + this.type, !1);
    }
  }, t.prototype.getParent = function () {
    return this.parent;
  }, t.prototype.getContainerSVG = function () {
    if (this.type) {
      var t = Tl.getProperty(this.model.getOptions(), "style", "prefix");
      return Xg.appendOrSelect(this.parent, "g." + Tg.prefix + "--" + t + "--" + this.type);
    }

    return this.parent;
  }, t;
}(),
    nb = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.type = "legend", t;
  }

  return a(n, e), n.prototype.render = function () {
    var e = this,
        n = this.getContainerSVG().attr("role", t.GRAPHICS_DOCUMENT),
        r = this.model.getOptions(),
        i = n.selectAll("g.legend-item").data(this.getLegendItemArray()),
        o = i.enter().append("g").classed("legend-item", !0),
        a = r.legend.checkbox.radius;
    o.append("rect").classed("checkbox", !0).merge(i.select("rect.checkbox")).attr("width", 2 * a).attr("height", 2 * a).attr("rx", 1).attr("ry", 1).style("fill", function (t) {
      return t.value === r.legend.items.status.ACTIVE ? e.model.getStrokeColor(t.key) : null;
    }).classed("active", function (t, e) {
      return t.value === r.legend.items.status.ACTIVE;
    }), o.append("text").merge(i.select("text")).text(function (t) {
      return t.key;
    }).attr("alignment-baseline", "middle"), this.breakItemsIntoLines(o), i.exit().on("mouseover", null).on("click", null).on("mouseout", null).remove();
    var s = Tl.getProperty(this.model.getOptions(), "legend", "clickable");
    n.classed("clickable", s), s && o.size() > 0 && this.addEventListeners();
  }, n.prototype.breakItemsIntoLines = function (t) {
    var e,
        n = this,
        r = this.getContainerSVG(),
        i = this.model.getOptions(),
        o = i.legend.checkbox.radius,
        a = i.legend.items.horizontalSpace,
        s = i.legend.items.verticalSpace,
        u = i.legend.items.textYOffset,
        c = 2 * o + i.legend.checkbox.spaceAfter,
        l = i.legend.items.status.DISABLED,
        f = this.model.get("dataLabels"),
        h = Object.keys(f).some(function (t) {
      return f[t] === l;
    }),
        p = Tl.getProperty(i, "legend", "orientation"),
        d = 0,
        g = 0,
        y = 0;
    t.merge(r.selectAll("g.legend-item")).each(function (t, i) {
      var l = wg(this),
          f = wg(r.selectAll("g.legend-item").nodes()[i - 1]);
      if (0 === y || f.empty() || p === v.VERTICAL) p === v.VERTICAL && 0 !== i && g++;else {
        var _ = Xg.getSVGElementSize(n.parent, {
          useAttr: !0
        }),
            m = Xg.getSVGElementSize(wg(this).select("text"), {
          useBBox: !0
        }),
            b = Xg.getSVGElementSize(f.select("text"), {
          useBBox: !0
        });

        (d = d + b.width + c + a) + c + m.width > _.width && (g++, d = 0, y = 0);
      }
      l.select("rect.checkbox").attr("x", d).attr("y", 0 + g * s);
      var x = u + g * s;
      l.select("text").attr("x", d + c).attr("y", 0 + x), e = x, h && l.select("g.check").empty() ? (l.append("g").classed("check", !0).html('\n\t\t\t\t\t\t\t<svg focusable="false" preserveAspectRatio="xMidYMid meet"\n\t\t\t\t\t\t\t\txmlns="http://www.w3.org/2000/svg" width="32" height="32"\n\t\t\t\t\t\t\t\tviewBox="0 0 32 32" aria-hidden="true"\n\t\t\t\t\t\t\t\tstyle="will-change: transform;">\n\t\t\t\t\t\t\t\t<path d="M13 21.2l-7.1-7.1-1.4 1.4 7.1 7.1L13 24 27.1 9.9l-1.4-1.5z"></path>\n\t\t\t\t\t\t\t\t<title>Checkmark</title>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t'), l.select("g.check svg").attr("width", 2 * o - 1).attr("height", 2 * o - 1).attr("x", parseFloat(l.select("rect.checkbox").attr("x")) + .5).attr("y", parseFloat(l.select("rect.checkbox").attr("y")) + .5)) : h || l.select("g.check").empty() || l.select("g.check").remove(), y++;
    }), Xg.appendOrSelect(r, "rect.spacer").attr("x", 0).attr("y", e).attr("width", 16).attr("height", 16).attr("fill", "none");
  }, n.prototype.getLegendItemArray = function () {
    var t = this.model.get("dataLabels");
    return Object.keys(t).map(function (e) {
      return {
        key: e,
        value: t[e]
      };
    });
  }, n.prototype.addEventListeners = function () {
    var t = this,
        e = this.getContainerSVG(),
        n = this.model.getOptions();
    e.selectAll("g.legend-item").on("mouseover", function () {
      t.services.events.dispatchEvent("legend-item-onhover", {
        hoveredElement: wg(this)
      });
      var e = n.legend.checkbox.radius,
          r = wg(this);
      r.append("rect").classed("hover-stroke", !0).attr("x", parseFloat(r.select("rect.checkbox").attr("x")) - 2).attr("y", parseFloat(r.select("rect.checkbox").attr("y")) - 2).attr("width", 2 * e + 4).attr("height", 2 * e + 4).attr("rx", 3).attr("ry", 3).lower();
    }).on("click", function () {
      t.services.events.dispatchEvent("legend-item-onclick", {
        clickedElement: wg(this)
      });
      var e = wg(this).datum();
      t.model.toggleDataLabel(e.key);
    }).on("mouseout", function () {
      var e = wg(this);
      e.select("rect.hover-stroke").remove(), t.services.events.dispatchEvent("legend-item-onmouseout", {
        hoveredElement: e
      });
    });
  }, n;
}(eb),
    rb = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.type = "title", e;
  }

  return a(e, t), e.prototype.truncateTitle = function () {
    var t = Xg.getSVGElementSize(this.services.domUtils.getMainSVG(), {
      useAttr: !0
    }).width,
        e = Xg.appendOrSelect(this.parent, "text.title");

    if (!(t <= 0) && e.node().getComputedTextLength() > t) {
      e.append("tspan").text("...");
      var n = Xg.appendOrSelect(e, "tspan").node().getComputedTextLength(),
          r = Math.floor(t - n),
          i = this.model.getOptions().title,
          o = this.getSubstringIndex(e.node(), 0, i.length - 1, r);
      e.text(i.substring(0, o - 1)).append("tspan").text("...");
      var a = this;
      e.on("mouseenter", function () {
        a.services.events.dispatchEvent("show-tooltip", {
          hoveredElement: e,
          type: p.TITLE
        });
      }).on("mouseout", function () {
        a.services.events.dispatchEvent("hide-tooltip", {
          hoveredElement: e
        });
      });
    }
  }, e.prototype.render = function () {
    var t = this.getContainerSVG();
    Xg.appendOrSelect(t, "text.title").attr("x", 0).attr("y", 20).text(this.model.getOptions().title), this.truncateTitle();
  }, e.prototype.getSubstringIndex = function (t, e, n, r) {
    var i = Math.floor((n + e) / 2);
    return t.getSubStringLength(0, i) > r ? this.getSubstringIndex(t, e, i, r) : t.getSubStringLength(0, i) < r ? t.getSubStringLength(0, i + 1) > r ? i : this.getSubstringIndex(t, i, n, r) : i;
  }, e;
}(eb);

!function (t) {
  t.LEFT = "left", t.RIGHT = "right", t.TOP = "top", t.BOTTOM = "bottom";
}(Qm || (Qm = {}));

var ib = ((Jm = {})[Qm.LEFT] = function (t, e, n) {
  return {
    top: t.top - Math.round(e.offsetHeight / 2) + Math.round(n.height / 2),
    left: Math.round(t.left - e.offsetWidth)
  };
}, Jm[Qm.RIGHT] = function (t, e, n) {
  return {
    top: t.top - Math.round(e.offsetHeight / 2) + Math.round(n.height / 2),
    left: Math.round(t.left + n.width)
  };
}, Jm[Qm.TOP] = function (t, e, n) {
  return {
    top: Math.round(t.top - e.offsetHeight),
    left: t.left - Math.round(e.offsetWidth / 2) + Math.round(n.width / 2)
  };
}, Jm[Qm.BOTTOM] = function (t, e, n) {
  return {
    top: Math.round(t.top + n.height),
    left: t.left - Math.round(e.offsetWidth / 2) + Math.round(n.width / 2)
  };
}, Jm),
    ob = "undefined" != typeof window ? window : {
  innerHeight: 0,
  scrollY: 0,
  innerWidth: 0,
  scrollX: 0
},
    ab = function () {
  function t(t) {
    void 0 === t && (t = {}), this.positions = ib, this.positions = Object.assign({}, ib, t);
  }

  return t.prototype.getRelativeOffset = function (t) {
    for (var e = {
      left: t.offsetLeft,
      top: t.offsetTop
    }; t.offsetParent && "static" === getComputedStyle(t.offsetParent).position;) {
      e.left += t.offsetLeft, e.top += t.offsetTop, t = t.offsetParent;
    }

    return e;
  }, t.prototype.getAbsoluteOffset = function (t) {
    for (var e = t, n = {
      top: 0,
      left: 0
    }; e.offsetParent;) {
      var r = getComputedStyle(e.offsetParent);
      "static" === r.position && r.marginLeft && r.marginTop && (parseInt(r.marginTop, 10) && (n.top += parseInt(r.marginTop, 10)), parseInt(r.marginLeft, 10) && (n.left += parseInt(r.marginLeft, 10))), e = e.offsetParent;
    }

    var i = t.getBoundingClientRect(),
        o = document.body.getBoundingClientRect();
    return {
      top: i.top - o.top + n.top,
      left: i.left - o.left + n.left
    };
  }, t.prototype.findRelative = function (t, e, n) {
    var r = this.getRelativeOffset(t),
        i = t.getBoundingClientRect();
    return this.calculatePosition(r, i, e, n);
  }, t.prototype.findAbsolute = function (t, e, n) {
    var r = this.getAbsoluteOffset(t),
        i = t.getBoundingClientRect();
    return this.calculatePosition(r, i, e, n);
  }, t.prototype.findPosition = function (t, e, n, r) {
    void 0 === r && (r = this.getAbsoluteOffset);
    var i = r(t),
        o = t.getBoundingClientRect();
    return this.calculatePosition(i, o, e, n);
  }, t.prototype.findPositionAt = function (t, e, n) {
    return this.calculatePosition(t, {
      height: 0,
      width: 0
    }, e, n);
  }, t.prototype.getPlacementBox = function (t, e) {
    var n = t.offsetHeight + e.top,
        r = t.offsetWidth + e.left;
    return {
      top: e.top,
      bottom: n,
      left: e.left,
      right: r
    };
  }, t.prototype.addOffset = function (t, e, n) {
    return void 0 === e && (e = 0), void 0 === n && (n = 0), Object.assign({}, t, {
      top: t.top + e,
      left: t.left + n
    });
  }, t.prototype.setElement = function (t, e) {
    t.style.top = e.top + "px", t.style.left = e.left + "px";
  }, t.prototype.findBestPlacement = function (t, e, n, r, i) {
    var o = this;
    void 0 === r && (r = this.defaultContainerFunction), void 0 === i && (i = this.findPosition);
    var a = n.map(function (n) {
      var a = i(t, e, n),
          s = o.getPlacementBox(e, a),
          u = s.bottom - r().height,
          c = s.right - r().width;
      u = u < 0 ? e.offsetHeight : u, c = c < 0 ? e.offsetWidth : c;
      var l = e.offsetHeight * e.offsetWidth,
          f = l - u * c;
      return {
        placement: n,
        weight: (f = 0 === f ? l : f) / l
      };
    });
    return a.sort(function (t, e) {
      return e.weight - t.weight;
    }), a[0].placement;
  }, t.prototype.findBestPlacementAt = function (t, e, n, r) {
    var i = this;
    void 0 === r && (r = this.defaultContainerFunction);
    return this.findBestPlacement(null, e, n, r, function (e, n, r) {
      return i.findPositionAt(t, n, r);
    });
  }, t.prototype.defaultContainerFunction = function () {
    return {
      width: ob.innerHeight - ob.scrollY,
      height: ob.innerWidth - ob.scrollX
    };
  }, t.prototype.calculatePosition = function (t, e, n, r) {
    return this.positions[r] ? this.positions[r](t, n, e) : (console.error("No function found for placement, defaulting to 0,0"), {
      left: 0,
      top: 0
    });
  }, t;
}(),
    sb = (new ab(), function (t) {
  function e(e, n, r) {
    var i = t.call(this, e, n, r) || this;
    return i.type = "tooltip", i.positionService = new ab(), i.init(), i;
  }

  return a(e, t), e.prototype.init = function () {
    var t = this,
        e = wg(this.services.domUtils.getHolder()),
        n = Tl.getProperty(this.model.getOptions(), "style", "prefix");
    this.tooltip = Xg.appendOrSelect(e, "div." + Tg.prefix + "--" + n + "--tooltip");
    var r = Xg.appendOrSelect(this.tooltip, "div.content-box");
    this.tooltip.style("max-width", null), this.services.events.addEventListener("show-tooltip", function (i) {
      if (i.detail.type === p.DATAPOINT && Tl.getProperty(t.model.getOptions(), "tooltip", "datapoint", "enabled") || i.detail.type === p.GRIDLINE && Tl.getProperty(t.model.getOptions(), "tooltip", "gridline", "enabled")) {
        var o = wg(lg.target).datum(),
            a = void 0;
        i.detail.multidata ? (o = i.detail.multidata, a = t.getMultilineTooltipHTML(o)) : a = t.getTooltipHTML(o, p.DATAPOINT), Tl.getProperty(t.model.getOptions(), "tooltip", "customHTML") ? r.html(t.model.getOptions().tooltip.customHTML(o, a)) : r.html(a), t.positionTooltip();
      } else if (i.detail.type === p.TITLE) {
        var s = Xg.appendOrSelect(e, "svg." + Tg.prefix + "--" + n + "--chart-svg"),
            u = Xg.getSVGElementSize(s).width * Tl.getProperty(t.model.getOptions(), "tooltip", "title", "width");
        t.tooltip.style("max-width", u), r.html(t.getTooltipHTML(i.detail.hoveredElement, p.TITLE));
        var c = t.getTooltipPosition(i.detail.hoveredElement.node());
        t.positionTooltip(c);
      }

      t.tooltip.classed("hidden", !1);
    }), this.services.events.addEventListener("hide-tooltip", function () {
      t.tooltip.classed("hidden", !0);
    });
  }, e.prototype.getTooltipHTML = function (t, e) {
    if (e === p.TITLE) return '<div class="title-tooltip"><text>' + this.model.getOptions().title + "</text></div>";
    var n = Tl.getProperty(t, "data") ? t.data : t,
        r = Tl.getProperty(this.model.getOptions(), "tooltip", "valueFormatter") ? this.model.getOptions().tooltip.valueFormatter(n.value) : n.value.toLocaleString("en");
    return '<div class="datapoint-tooltip">\n\t\t\t\t\t<p class="label">' + (n.datasetLabel ? n.datasetLabel : n.label) + '</p>\n\t\t\t\t\t<p class="value">' + r + "</p>\n\t\t\t\t</div>";
  }, e.prototype.getMultilineTooltipHTML = function (t) {
    var e = this,
        n = t;
    n.sort(function (t, e) {
      return e.value - t.value;
    });
    var r = this.services.cartesianScales.getDomainScale().scaleType;
    return "<ul class='multi-tooltip'>" + n.map(function (t) {
      var n = t.value;
      n instanceof Object && (n = r === f.TIME ? t.value.date : t.value.value);
      var i = Tl.getProperty(e.model.getOptions(), "tooltip", "valueFormatter") ? e.model.getOptions().tooltip.valueFormatter(n) : n.toLocaleString("en");
      return '\n\t\t\t\t<li>\n\t\t\t\t\t<div class="datapoint-tooltip">\n\t\t\t\t\t\t<a style="background-color:' + e.model.getStrokeColor(t.datasetLabel, t.label) + '" class="tooltip-color"></a>\n\t\t\t\t\t\t<p class="label">' + t.datasetLabel + '</p>\n\t\t\t\t\t\t<p class="value">' + i + "</p>\n\t\t\t\t\t</div>\n\t\t\t\t</li>";
    }).join("") + "</ul>";
  }, e.prototype.render = function () {
    this.tooltip.classed("hidden", !0);
  }, e.prototype.getTooltipPosition = function (t) {
    var e = wg(this.services.domUtils.getHolder()).node().getBoundingClientRect(),
        n = t.getBoundingClientRect(),
        r = this.model.getOptions().tooltip.title.verticalOffset,
        i = {
      left: n.left - e.left + n.width / 2,
      top: n.top - e.top - r
    };
    return {
      placement: h.BOTTOM,
      position: i
    };
  }, e.prototype.positionTooltip = function (t) {
    var e,
        n = this.services.domUtils.getHolder(),
        r = this.tooltip.node(),
        i = Eg(n);

    if (t) {
      var o = t.placement === h.TOP ? Qm.TOP : Qm.BOTTOM;
      e = this.positionService.findPositionAt(t.position, r, o);
    } else {
      var a = this.positionService.findBestPlacementAt({
        left: i[0],
        top: i[1]
      }, r, [Qm.RIGHT, Qm.LEFT, Qm.TOP, Qm.BOTTOM], function () {
        return {
          width: n.offsetWidth,
          height: n.offsetHeight
        };
      }),
          s = this.model.getOptions().tooltip.datapoint.horizontalOffset;
      a === Qm.LEFT && (s *= -1), e = this.positionService.findPositionAt({
        left: i[0] + s,
        top: i[1]
      }, r, a);
    }

    this.positionService.setElement(r, e);
  }, e;
}(eb)),
    ub = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return a(e, t), e.prototype.init = function () {
    var e = this,
        n = wg(this.services.domUtils.getHolder()),
        r = Tl.getProperty(this.model.getOptions(), "style", "prefix");
    this.tooltip = Xg.appendOrSelect(n, "div." + Tg.prefix + "--" + r + "--tooltip");
    var i = Xg.appendOrSelect(this.tooltip, "div.content-box");
    this.tooltip.style("max-width", null), this.services.events.addEventListener("show-tooltip", function (o) {
      if (o.detail.type === p.DATAPOINT && Tl.getProperty(e.model.getOptions(), "tooltip", "datapoint", "enabled") || o.detail.type === p.GRIDLINE && Tl.getProperty(e.model.getOptions(), "tooltip", "gridline", "enabled")) {
        var a = o.detail.hoveredElement.node(),
            s = void 0;
        s = o.detail.multidata ? e.getMultilineTooltipHTML(o.detail.multidata) : e.getTooltipHTML(o.detail.hoveredElement.datum()), Tl.getProperty(e.model.getOptions(), "tooltip", "customHTML") ? i.html(e.model.getOptions().tooltip.customHTML(a, s)) : i.html(s);
        var u = e.getTooltipPosition(a);
        e.positionTooltip(o.detail.multidata ? void 0 : u);
      } else if (o.detail.type === p.TITLE) {
        var c = Xg.appendOrSelect(n, "svg." + Tg.prefix + "--" + r + "--chart-svg"),
            l = Xg.getSVGElementSize(c).width * Tl.getProperty(e.model.getOptions(), "tooltip", "title", "width");
        e.tooltip.style("max-width", l), i.html(t.prototype.getTooltipHTML.call(e, o.detail.hoveredElement, p.TITLE));
        u = t.prototype.getTooltipPosition.call(e, o.detail.hoveredElement.node());
        e.positionTooltip(u);
      }

      e.tooltip.classed("hidden", !1);
    }), this.services.events.addEventListener("hide-tooltip", function () {
      e.tooltip.classed("hidden", !0);
    });
  }, e.prototype.getTooltipPosition = function (t) {
    var e = wg(t).datum(),
        n = wg(this.services.domUtils.getHolder()).node().getBoundingClientRect(),
        r = t.getBoundingClientRect(),
        i = this.model.getOptions().tooltip.datapoint.verticalOffset;

    if (e.value <= 0) {
      var o = {
        left: r.left - n.left + r.width / 2,
        top: r.bottom - n.top + i
      };
      return {
        placement: h.BOTTOM,
        position: o
      };
    }

    o = {
      left: r.left - n.left + r.width / 2,
      top: r.top - n.top - i
    };
    return {
      placement: h.TOP,
      position: o
    };
  }, e.prototype.getTooltipHTML = function (t) {
    return '<div class="datapoint-tooltip"><p class="value">' + (Tl.getProperty(this.model.getOptions(), "tooltip", "valueFormatter") ? this.model.getOptions().tooltip.valueFormatter(t.value) : t.value.toLocaleString("en")) + "</p></div>";
  }, e.prototype.getMultilineTooltipHTML = function (t) {
    var e = this,
        n = t;
    n.reverse(), this.services.cartesianScales.getOrientation() === c.VERTICAL && n.reverse();
    var r = n.reduce(function (t, e) {
      return t + e.value;
    }, 0);
    return r = Tl.getProperty(this.model.getOptions(), "tooltip", "valueFormatter") ? this.model.getOptions().tooltip.valueFormatter(r) : r.toLocaleString("en"), "<ul class='multi-tooltip'>" + n.map(function (t) {
      var n = Tl.getProperty(e.model.getOptions(), "tooltip", "valueFormatter") ? e.model.getOptions().tooltip.valueFormatter(t.value) : t.value.toLocaleString("en");
      return '\n\t\t\t\t<li>\n\t\t\t\t\t<div class="datapoint-tooltip">\n\t\t\t\t\t\t<a style="background-color:' + e.model.getStrokeColor(t.datasetLabel, t.label, t.value) + '" class="tooltip-color"></a>\n\t\t\t\t\t\t<p class="label">' + t.datasetLabel + '</p>\n\t\t\t\t\t\t<p class="value">' + n + "</p>\n\t\t\t\t\t</div>\n\t\t\t\t</li>";
    }).join("") + "<li>\n\t\t\t\t\t<div class='total-val'>\n\t\t\t\t\t\t<p class='label'>Total</p>\n\t\t\t\t\t\t<p class='value'>" + r + "</p>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\t\t\t</ul>";
  }, e;
}(sb),
    cb = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return a(e, t), e.prototype.getTooltipHTML = function (e, n) {
    if (n === p.TITLE) return t.prototype.getTooltipHTML.call(this, e, n);
    var r = Tl.getProperty(this.model.getOptions(), "tooltip", "valueFormatter") ? this.model.getOptions().tooltip.valueFormatter(e.value) : e.value.toLocaleString("en");
    return '\n\t\t\t<div class="datapoint-tooltip">\n\t\t\t\t<a style="background-color:' + this.model.getStrokeColor(e.datasetLabel, e.label, e.value) + '" class="tooltip-color"></a>\n\t\t\t\t<p class="label">' + e.datasetLabel + '</p>\n\t\t\t\t<p class="value">' + r + "</p>\n\t\t\t</div>";
  }, e;
}(sb),
    lb = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return a(e, t), e.prototype.getBarWidth = function () {
    var t = this.model.getOptions(),
        e = this.services.cartesianScales.getMainXScale();
    return e.step ? Math.min(t.bars.maxWidth, e.step() / 2) : Math.min(t.bars.maxWidth, 5 / e.ticks().length * t.bars.maxWidth);
  }, e;
}(eb),
    fb = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.type = "simple-bar", t.handleLegendOnHover = function (e) {
      var n = e.detail.hoveredElement;
      t.parent.selectAll("path.bar").transition(t.services.transitions.getTransition("legend-hover-simple-bar")).attr("opacity", function (t) {
        return t.label !== n.datum().key ? .3 : 1;
      });
    }, t.handleLegendMouseOut = function (e) {
      t.parent.selectAll("path.bar").transition(t.services.transitions.getTransition("legend-mouseout-simple-bar")).attr("opacity", 1);
    }, t;
  }

  return a(n, e), n.prototype.init = function () {
    var t = this.services.events;
    t.addEventListener("legend-item-onhover", this.handleLegendOnHover), t.addEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n.prototype.render = function (e) {
    var n = this,
        r = this.getContainerSVG().selectAll("g.bars").data(this.model.getDisplayData().datasets, function (t) {
      return t.label;
    });
    r.exit().attr("opacity", 0).remove();
    var i = r.enter().append("g").classed("bars", !0).attr("role", t.GROUP).merge(r).selectAll("path.bar").data(function (t, e) {
      return n.addLabelsToDataPoints(t, e);
    }, function (t) {
      return t.label;
    });
    i.exit().attr("opacity", 0).remove(), i.enter().append("path").attr("opacity", 0).merge(i).classed("bar", !0).attr("width", this.getBarWidth.bind(this)).transition(this.services.transitions.getTransition("bar-update-enter", e)).attr("fill", function (t) {
      return n.model.getFillScale()(t.label);
    }).attr("d", function (t, e) {
      var r = n.getBarWidth(),
          i = n.services.cartesianScales.getDomainValue(t, e) - r / 2,
          o = i + r,
          a = n.services.cartesianScales.getRangeValue(0),
          s = n.services.cartesianScales.getRangeValue(t, e);
      return Tl.generateSVGPathString({
        x0: i,
        x1: o,
        y0: a,
        y1: s
      }, n.services.cartesianScales.getOrientation());
    }).attr("opacity", 1).attr("role", t.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", function (t) {
      return t.value;
    }), this.addEventListeners();
  }, n.prototype.addLabelsToDataPoints = function (t, e) {
    var n = this.model.getDisplayData().labels;
    return t.data.map(function (e, r) {
      return {
        date: e.date,
        label: n[r],
        datasetLabel: t.label,
        value: isNaN(e) ? e.value : e
      };
    });
  }, n.prototype.addEventListeners = function () {
    var t = this;
    this.parent.selectAll("path.bar").on("mouseover", function (e) {
      var n = wg(this);
      n.classed("hovered", !0), n.transition(t.services.transitions.getTransition("graph_element_mouseover_fill_update")).attr("fill", sh(n.attr("fill")).darker(.7).toString()), t.services.events.dispatchEvent(m.Bar.BAR_MOUSEOVER, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("show-tooltip", {
        hoveredElement: n,
        type: p.DATAPOINT
      });
    }).on("mousemove", function (e) {
      t.services.events.dispatchEvent(m.Bar.BAR_MOUSEMOVE, {
        element: wg(this),
        datum: e
      });
    }).on("click", function (e) {
      t.services.events.dispatchEvent(m.Bar.BAR_CLICK, {
        element: wg(this),
        datum: e
      });
    }).on("mouseout", function (e) {
      var n = wg(this);
      n.classed("hovered", !1), n.transition(t.services.transitions.getTransition("graph_element_mouseout_fill_update")).attr("fill", function (e) {
        return t.model.getFillScale()(e.label);
      }), t.services.events.dispatchEvent(m.Bar.BAR_MOUSEOUT, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("hide-tooltip", {
        hoveredElement: n
      });
    });
  }, n.prototype.destroy = function () {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    var t = this.services.events;
    t.removeEventListener("legend-item-onhover", this.handleLegendOnHover), t.removeEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n;
}(lb),
    hb = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.type = "grouped-bar", t.handleLegendOnHover = function (e) {
      var n = e.detail.hoveredElement;
      t.parent.selectAll("path.bar").transition(t.services.transitions.getTransition("legend-hover-bar")).attr("opacity", function (t) {
        return t.datasetLabel !== n.datum().key ? .3 : 1;
      });
    }, t.handleLegendMouseOut = function (e) {
      t.parent.selectAll("path.bar").transition(t.services.transitions.getTransition("legend-mouseout-bar")).attr("opacity", 1);
    }, t;
  }

  return a(n, e), n.prototype.init = function () {
    var t = this.services.events;
    t.addEventListener("legend-item-onhover", this.handleLegendOnHover), t.addEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n.prototype.getGroupWidth = function () {
    var t = this.model.getDisplayData().datasets;
    return t.length * this.getBarWidth() + 5 * (t.length - 1);
  }, n.prototype.setGroupScale = function () {
    var t = this.model.getDisplayData().datasets;
    this.groupScale = Hf().domain(t.map(function (t) {
      return t.label;
    })).rangeRound([0, this.getGroupWidth()]);
  }, n.prototype.getBarWidth = function () {
    var t = this.model.getDisplayData().datasets,
        n = this.services.cartesianScales.getDomainScale();
    return Math.min(n.step() / 2 / t.length, e.prototype.getBarWidth.call(this));
  }, n.prototype.render = function (e) {
    var n = this,
        r = this.model.getDisplayData();
    this.setGroupScale();
    var i = this.getContainerSVG().selectAll("g.bars").data(r.labels);
    i.exit().attr("opacity", 0).remove();
    var o = i.enter().append("g").classed("bars", !0).attr("role", t.GROUP).attr("aria-labelledby", function (t) {
      return t;
    }).merge(i).attr("transform", function (t, e) {
      var r = n.services.cartesianScales.getDomainValue(t, e) - n.getGroupWidth() / 2 + n.getBarWidth();
      return n.services.cartesianScales.getOrientation() === c.VERTICAL ? "translate(" + r + ", 0)" : "translate(0, " + r + ")";
    }).selectAll("path.bar").data(function (t, e) {
      return n.addLabelsToDataPoints(t, e);
    });
    o.exit().attr("opacity", 0).remove(), o.enter().append("path").attr("opacity", 0).merge(o).classed("bar", !0).transition(this.services.transitions.getTransition("bar-update-enter", e)).attr("fill", function (t) {
      return n.model.getFillScale()[t.datasetLabel](t.label);
    }).attr("d", function (t) {
      var e = n.groupScale(t.datasetLabel),
          r = n.getBarWidth(),
          i = e - r / 2,
          o = e + r / 2,
          a = n.services.cartesianScales.getRangeValue(0),
          s = n.services.cartesianScales.getRangeValue(t.value);
      return Tl.generateSVGPathString({
        x0: i,
        x1: o,
        y0: a,
        y1: s
      }, n.services.cartesianScales.getOrientation());
    }).attr("opacity", 1).attr("role", t.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", function (t) {
      return t.value;
    }), this.addEventListeners();
  }, n.prototype.addLabelsToDataPoints = function (t, e) {
    return this.model.getDisplayData().datasets.map(function (n) {
      return {
        label: t,
        datasetLabel: n.label,
        value: n.data[e].value ? n.data[e].value : n.data[e]
      };
    });
  }, n.prototype.addEventListeners = function () {
    var t = this;
    this.parent.selectAll("path.bar").on("mouseover", function (e) {
      var n = wg(this);
      n.transition(t.services.transitions.getTransition("graph_element_mouseover_fill_update")).attr("fill", sh(n.attr("fill")).darker(.7).toString()), t.services.events.dispatchEvent(m.Bar.BAR_MOUSEOVER, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("show-tooltip", {
        hoveredElement: n,
        type: p.DATAPOINT
      });
    }).on("mousemove", function (e) {
      t.services.events.dispatchEvent(m.Bar.BAR_MOUSEMOVE, {
        element: wg(this),
        datum: e
      });
    }).on("click", function (e) {
      t.services.events.dispatchEvent(m.Bar.BAR_CLICK, {
        element: wg(this),
        datum: e
      });
    }).on("mouseout", function (e) {
      var n = wg(this);
      n.classed("hovered", !1), n.transition(t.services.transitions.getTransition("graph_element_mouseout_fill_update")).attr("fill", function (e) {
        return t.model.getFillScale()[e.datasetLabel](e.label);
      }), t.services.events.dispatchEvent(m.Bar.BAR_MOUSEOUT, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("hide-tooltip", {
        hoveredElement: n
      });
    });
  }, n.prototype.destroy = function () {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    var t = this.services.events;
    t.removeEventListener("legend-item-onhover", this.handleLegendOnHover), t.removeEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n;
}(lb),
    pb = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.type = "stacked-bar", t.handleLegendOnHover = function (e) {
      var n = e.detail.hoveredElement;
      t.parent.selectAll("path.bar").transition(t.services.transitions.getTransition("legend-hover-bar")).attr("opacity", function (t) {
        return t.datasetLabel !== n.datum().key ? .3 : 1;
      });
    }, t.handleLegendMouseOut = function (e) {
      t.parent.selectAll("path.bar").transition(t.services.transitions.getTransition("legend-mouseout-bar")).attr("opacity", 1);
    }, t;
  }

  return a(n, e), n.prototype.init = function () {
    var t = this.services.events;
    t.addEventListener("legend-item-onhover", this.handleLegendOnHover), t.addEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n.prototype.getStackData = function () {
    var t,
        e = this.model.getDisplayData(),
        n = this.services.cartesianScales.getDomainAxisPosition();

    if (this.services.cartesianScales.getScaleTypeByPosition(n) === f.TIME) {
      var r = [];
      e.datasets.forEach(function (t) {
        r = r.concat(t.data.map(function (t) {
          return Number(t.date);
        }));
      }), t = (r = Tl.removeArrayDuplicates(r).sort()).map(function (t, n) {
        var r = {};
        return e.datasets.forEach(function (e) {
          var n = e.data.find(function (e) {
            return Number(e.date) === Number(t);
          });
          r[e.label] = n ? n.value : 0;
        }), r.label = t, r;
      });
    } else t = e.labels.map(function (t, n) {
      var r = {};
      return e.datasets.forEach(function (t) {
        r[t.label] = isNaN(t.data[n]) ? t.data[n].value : t.data[n];
      }), r.label = t, r;
    });

    return t;
  }, n.prototype.render = function (e) {
    var n = this,
        r = this.model.getOptions(),
        i = this.getContainerSVG(),
        o = this.model.getDisplayData(),
        a = this.getStackData(),
        s = o.datasets.map(function (t) {
      return t.label;
    }),
        u = i.selectAll("g.bars").data(function () {
      var t = j_([]),
          e = Zm,
          n = $m,
          r = Km;

      function i(i) {
        var o,
            a,
            s = t.apply(this, arguments),
            u = i.length,
            c = s.length,
            l = new Array(c);

        for (o = 0; o < c; ++o) {
          for (var f, h = s[o], p = l[o] = new Array(u), d = 0; d < u; ++d) {
            p[d] = f = [0, +r(i[d], h, d, i)], f.data = i[d];
          }

          p.key = h;
        }

        for (o = 0, a = e(l); o < c; ++o) {
          l[a[o]].index = o;
        }

        return n(l, a), l;
      }

      return i.keys = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : j_(am.call(e)), i) : t;
      }, i.value = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : j_(+t), i) : r;
      }, i.order = function (t) {
        return arguments.length ? (e = null == t ? Zm : "function" == typeof t ? t : j_(am.call(t)), i) : e;
      }, i.offset = function (t) {
        return arguments.length ? (n = null == t ? $m : t, i) : n;
      }, i;
    }().keys(s)(a), function (t) {
      return t.key;
    });
    u.exit().attr("opacity", 0).remove(), u.enter().append("g").classed("bars", !0).attr("role", t.GROUP);
    var l = i.selectAll("g.bars").selectAll("path.bar").data(function (t) {
      return function (t) {
        return Object.keys(t).map(function (e) {
          "object" == typeof t[e] && (t[e].datasetLabel = t.key, t[e].label = t[e].data.label, t[e].value = t[e].data[t.key]);
        }), t;
      }(t);
    }, function (t) {
      return t.label;
    });
    l.exit().remove();
    var h = this.services.cartesianScales.getRangeScale();
    l.enter().append("path").merge(l).classed("bar", !0).transition(this.services.transitions.getTransition("bar-update-enter", e)).attr("fill", function (t) {
      return n.model.getFillScale()[t.datasetLabel](t.label);
    }).attr("height", function (t, e) {
      var i,
          o = t.datasetLabel,
          a = s.indexOf(o);
      return i = h.scaleType === f.LABELS ? Math.abs(h.scale.range()[0] - n.services.cartesianScales.getRangeValue(t.label, e)) : n.services.cartesianScales.getRangeValue(t[0]) - n.services.cartesianScales.getRangeValue(t[1]), a > 0 && i >= r.bars.dividerSize ? i - r.bars.dividerSize : i;
    }).attr("d", function (t, e) {
      var i = n.getBarWidth(),
          o = n.services.cartesianScales.getDomainValue(t, e) - i / 2,
          a = o + i,
          s = n.services.cartesianScales.getRangeValue(t[0], e),
          u = n.services.cartesianScales.getRangeValue(t[1], e);
      return Math.abs(u - s) > 0 && Math.abs(u - s) > r.bars.dividerSize && (n.services.cartesianScales.getOrientation() === c.VERTICAL ? u += 1 : u -= 1), Tl.generateSVGPathString({
        x0: o,
        x1: a,
        y0: s,
        y1: u
      }, n.services.cartesianScales.getOrientation());
    }).attr("opacity", 1).attr("role", t.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", function (t) {
      return t.value;
    }), this.addEventListeners();
  }, n.prototype.addEventListeners = function () {
    var t = this;
    this.parent.selectAll("path.bar").on("mouseover", function (e) {
      var n = wg(this);
      n.transition(t.services.transitions.getTransition("graph_element_mouseover_fill_update")).attr("fill", sh(n.attr("fill")).darker(.7).toString()), t.services.events.dispatchEvent(m.Bar.BAR_MOUSEOVER, {
        element: n,
        datum: e
      });
    }).on("mousemove", function (e) {
      var n = wg(this),
          r = wg(this).datum();
      n.classed("hovered", !0);
      var i = r.data,
          o = i.label;
      delete i.label;
      var a = Object.keys(i).map(function (t) {
        return {
          datasetLabel: t,
          value: i[t],
          label: o
        };
      });
      t.services.events.dispatchEvent(m.Bar.BAR_MOUSEMOVE, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("show-tooltip", {
        multidata: a,
        hoveredElement: n,
        type: p.DATAPOINT
      });
    }).on("click", function (e) {
      t.services.events.dispatchEvent(m.Bar.BAR_CLICK, {
        element: wg(this),
        datum: e
      });
    }).on("mouseout", function (e) {
      var n = wg(this);
      n.classed("hovered", !1), n.transition(t.services.transitions.getTransition("graph_element_mouseout_fill_update")).attr("fill", function (e) {
        return t.model.getFillScale()[e.datasetLabel](e.label);
      }), t.services.events.dispatchEvent(m.Bar.BAR_MOUSEOUT, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("hide-tooltip", {
        hoveredElement: n
      });
    });
  }, n.prototype.destroy = function () {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    var t = this.services.events;
    t.removeEventListener("legend-item-onhover", this.handleLegendOnHover), t.removeEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n;
}(lb),
    db = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.type = "line", t;
  }

  return a(n, e), n.prototype.init = function () {
    var t = this;
    this.services.events.addEventListener("legend-item-onhover", function (e) {
      var n = e.detail.hoveredElement;
      t.parent.selectAll("g.lines").transition(t.services.transitions.getTransition("legend-hover-line")).attr("opacity", function (t) {
        return t.label !== n.datum().key ? Xl.opacity.unselected : Xl.opacity.selected;
      });
    }), this.services.events.addEventListener("legend-item-onmouseout", function (e) {
      t.parent.selectAll("g.lines").transition(t.services.transitions.getTransition("legend-mouseout-line")).attr("opacity", Xl.opacity.selected);
    });
  }, n.prototype.render = function (e) {
    var n = this;
    void 0 === e && (e = !0);
    var r = this.getContainerSVG();

    this.lineGenerator = function () {
      var t = nm,
          e = rm,
          n = j_(!0),
          r = null,
          i = em,
          o = null;

      function a(a) {
        var s,
            u,
            c,
            l = a.length,
            f = !1;

        for (null == r && (o = i(c = R_())), s = 0; s <= l; ++s) {
          !(s < l && n(u = a[s], s, a)) === f && ((f = !f) ? o.lineStart() : o.lineEnd()), f && o.point(+t(u, s, a), +e(u, s, a));
        }

        if (c) return o = null, c + "" || null;
      }

      return a.x = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : j_(+e), a) : t;
      }, a.y = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : j_(+t), a) : e;
      }, a.defined = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : j_(!!t), a) : n;
      }, a.curve = function (t) {
        return arguments.length ? (i = t, null != r && (o = i(r)), a) : i;
      }, a.context = function (t) {
        return arguments.length ? (null == t ? r = o = null : o = i(r = t), a) : r;
      }, a;
    }().x(function (t, e) {
      return n.services.cartesianScales.getDomainValue(t, e);
    }).y(function (t, e) {
      return n.services.cartesianScales.getRangeValue(t, e);
    }).curve(this.services.curves.getD3Curve());

    var i = r.selectAll("g.lines").data(this.model.getDisplayData().datasets, function (t) {
      return t.label;
    });
    i.exit().attr("opacity", 0).remove();
    var o = i.enter().append("g").classed("lines", !0),
        a = this;
    o.append("path").attr("opacity", 0).merge(r.selectAll("g.lines path")).attr("stroke", function (t) {
      var e = wg(this.parentNode).datum();
      return a.model.getStrokeColor(e.label);
    }).datum(function (t) {
      var e = wg(this.parentNode).datum();
      return this._datasetLabel = e.label, e.data;
    }).attr("role", t.GRAPHICS_SYMBOL).attr("aria-roledescription", "line").attr("aria-label", function (t) {
      return t.map(function (t) {
        return t.value || t;
      }).join(",");
    }).transition(this.services.transitions.getTransition("line-update-enter", e)).attr("opacity", 1).attr("class", "line").attr("d", this.lineGenerator);
  }, n;
}(eb),
    vb = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.type = "scatter", t.handleLegendOnHover = function (e) {
      var n = e.detail.hoveredElement;
      t.parent.selectAll("circle.dot").transition(t.services.transitions.getTransition("legend-hover-scatter")).attr("opacity", function (t) {
        return t.datasetLabel !== n.datum().key ? .3 : 1;
      });
    }, t.handleLegendMouseOut = function (e) {
      t.parent.selectAll("circle.dot").transition(t.services.transitions.getTransition("legend-mouseout-scatter")).attr("opacity", 1);
    }, t;
  }

  return a(n, e), n.prototype.init = function () {
    var t = this.services.events;
    t.addEventListener("legend-item-onhover", this.handleLegendOnHover), t.addEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n.prototype.render = function (e) {
    var n = this,
        r = this.model.getOptions(),
        i = this.getContainerSVG().selectAll("g.dots").data(this.model.getDisplayData().datasets, function (t) {
      return t.label;
    });
    i.exit().attr("opacity", 0).remove();
    var o = i.enter().append("g").classed("dots", !0).attr("role", t.GROUP).merge(i).selectAll("circle.dot").data(function (t, e) {
      return n.addLabelsToDataPoints(t, e);
    }),
        a = o.enter().append("circle").attr("opacity", 0),
        s = r.points.filled;
    a.merge(o).raise().classed("dot", !0).classed("filled", s).classed("unfilled", !s).attr("cx", function (t, e) {
      return n.services.cartesianScales.getDomainValue(t, e);
    }).transition(this.services.transitions.getTransition("scatter-update-enter", e)).attr("cy", function (t, e) {
      return n.services.cartesianScales.getRangeValue(t, e);
    }).attr("r", r.points.radius).attr("fill", function (t) {
      if (s) return n.model.getFillScale()[t.datasetLabel](t.label);
    }).attr("fill-opacity", s ? .2 : 1).attr("stroke", function (t) {
      return n.model.getStrokeColor(t.datasetLabel, t.label, t.value);
    }).attr("opacity", 1).attr("role", t.GRAPHICS_SYMBOL).attr("aria-roledescription", "point").attr("aria-label", function (t) {
      return t.value;
    }), this.addEventListeners();
  }, n.prototype.addLabelsToDataPoints = function (t, e) {
    var n = this.model.getDisplayData().labels;
    return t.data.map(function (e, r) {
      return {
        date: e.date,
        label: n[r],
        datasetLabel: t.label,
        value: isNaN(e) ? e.value : e
      };
    });
  }, n.prototype.addEventListeners = function () {
    var t = this;
    this.parent.selectAll("circle").on("mouseover mousemove", function (e) {
      var n = wg(this);
      n.classed("hovered", !0), n.style("fill", function (e) {
        return t.model.getFillScale()[e.datasetLabel](e.label);
      });
      var r = "mouseover" === lg.type ? m.Scatter.SCATTER_MOUSEOVER : m.Scatter.SCATTER_MOUSEMOVE;
      t.services.events.dispatchEvent(r, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("show-tooltip", {
        hoveredElement: n,
        type: p.DATAPOINT
      });
    }).on("click", function (e) {
      t.services.events.dispatchEvent(m.Scatter.SCATTER_CLICK, {
        element: wg(this),
        datum: e
      });
    }).on("mouseout", function (e) {
      var n = wg(this);
      n.classed("hovered", !1), t.configs.filled || n.style("fill", null), t.services.events.dispatchEvent(m.Scatter.SCATTER_MOUSEOUT, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("hide-tooltip", {
        hoveredElement: n
      });
    });
  }, n.prototype.destroy = function () {
    this.parent.selectAll("circle").on("mousemove", null).on("mouseout", null);
    var t = this.services.events;
    t.removeEventListener("legend-item-onhover", this.handleLegendOnHover), t.removeEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n;
}(eb);

function gb(t, e) {
  var n = this,
      r = Rh(this._current, t);
  return function (t) {
    return n._current = r(t), e(n._current);
  };
}

var yb = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.type = "pie", t.handleLegendOnHover = function (e) {
      var n = e.detail.hoveredElement;
      t.parent.selectAll("path.slice").transition(t.services.transitions.getTransition("legend-hover-bar")).attr("opacity", function (t) {
        return t.data.label !== n.datum().key ? .3 : 1;
      });
    }, t.handleLegendMouseOut = function (e) {
      t.parent.selectAll("path.slice").transition(t.services.transitions.getTransition("legend-mouseout-bar")).attr("opacity", 1);
    }, t;
  }

  return a(n, e), n.prototype.init = function () {
    var t = this.services.events;
    t.addEventListener("legend-item-onhover", this.handleLegendOnHover), t.addEventListener("legend-item-onmouseout", this.handleLegendMouseOut);
  }, n.prototype.getDataList = function () {
    var t = this.model.getDisplayData();
    return t.datasets[0].data.map(function (e, n) {
      return {
        label: t.labels[n],
        value: e.value ? e.value : e
      };
    });
  }, n.prototype.getInnerRadius = function () {
    return this.model.getOptions().pie.innerRadius;
  }, n.prototype.render = function (e) {
    var n = this;
    void 0 === e && (e = !0);
    var r = this,
        i = this.getContainerSVG(),
        o = this.model.getOptions(),
        a = this.getDataList(),
        s = this.computeRadius();
    this.arc = Q_().innerRadius(this.getInnerRadius()).outerRadius(s), this.hoverArc = Q_().innerRadius(this.getInnerRadius()).outerRadius(s + o.pie.hoverArc.outerRadiusOffset);

    var u = function () {
      var t = om,
          e = im,
          n = null,
          r = j_(0),
          i = j_(U_),
          o = j_(0);

      function a(a) {
        var s,
            u,
            c,
            l,
            f,
            h = a.length,
            p = 0,
            d = new Array(h),
            v = new Array(h),
            g = +r.apply(this, arguments),
            y = Math.min(U_, Math.max(-U_, i.apply(this, arguments) - g)),
            _ = Math.min(Math.abs(y) / h, o.apply(this, arguments)),
            m = _ * (y < 0 ? -1 : 1);

        for (s = 0; s < h; ++s) {
          (f = v[d[s] = s] = +t(a[s], s, a)) > 0 && (p += f);
        }

        for (null != e ? d.sort(function (t, n) {
          return e(v[t], v[n]);
        }) : null != n && d.sort(function (t, e) {
          return n(a[t], a[e]);
        }), s = 0, c = p ? (y - h * m) / p : 0; s < h; ++s, g = l) {
          u = d[s], l = g + ((f = v[u]) > 0 ? f * c : 0) + m, v[u] = {
            data: a[u],
            index: s,
            value: f,
            startAngle: g,
            endAngle: l,
            padAngle: _
          };
        }

        return v;
      }

      return a.value = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : j_(+e), a) : t;
      }, a.sortValues = function (t) {
        return arguments.length ? (e = t, n = null, a) : e;
      }, a.sort = function (t) {
        return arguments.length ? (n = t, e = null, a) : n;
      }, a.startAngle = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : j_(+t), a) : r;
      }, a.endAngle = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : j_(+t), a) : i;
      }, a.padAngle = function (t) {
        return arguments.length ? (o = "function" == typeof t ? t : j_(+t), a) : o;
      }, a;
    }().value(function (t) {
      return t.value;
    }).sort(function (t, e) {
      return e.value - t.value;
    }).padAngle(o.pie.padAngle)(a).sort(function (t, e) {
      return t.index - e.index;
    }),
        c = Xg.appendOrSelect(i, "g.slices").attr("role", t.GROUP).selectAll("path.slice").data(u, function (t) {
      return t.data.label;
    });

    c.exit().attr("opacity", 0).remove(), c.enter().append("path").classed("slice", !0).attr("opacity", 0).merge(c).attr("fill", function (t) {
      return n.model.getFillScale()(t.data.label);
    }).attr("d", this.arc).transition(this.services.transitions.getTransition("pie-slice-enter-update", e)).attr("opacity", 1).attr("role", t.GRAPHICS_SYMBOL).attr("aria-roledescription", "slice").attr("aria-label", function (t) {
      return t.value + ", " + Tl.convertValueToPercentage(t.data.value, a) + "%";
    }).attrTween("d", function (t) {
      return gb.bind(this)(t, r.arc);
    });
    var l = Xg.appendOrSelect(i, "g.labels").attr("role", t.GROUP).selectAll("text.pie-label").data(u, function (t) {
      return t.data.label;
    });
    l.exit().attr("opacity", 0).remove();
    var f = l.enter().append("text").classed("pie-label", !0),
        h = [];
    f.merge(l).style("text-anchor", "middle").text(function (t) {
      return o.pie.labels.formatter ? o.pie.labels.formatter(t) : Tl.convertValueToPercentage(t.data.value, a) + "%";
    }).datum(function (t) {
      var e = this.getComputedTextLength();
      t.textOffsetX = e / 2, t.textOffsetY = parseFloat(getComputedStyle(this).fontSize) / 2;
      var n = s + 7,
          r = (t.endAngle - t.startAngle) / 2 + t.startAngle;
      return t.xPosition = (t.textOffsetX + n) * Math.sin(r), t.yPosition = (t.textOffsetY + n) * -Math.cos(r), t;
    }).attr("transform", function (t, e) {
      var n = a.length,
          r = (t.endAngle - t.startAngle) * (180 / Math.PI);

      if (e >= n - 2 && r < o.pie.callout.minSliceDegree) {
        var i = void 0,
            s = void 0;
        return t.index === n - 1 ? (i = t.xPosition + o.pie.callout.offsetX + o.pie.callout.textMargin + t.textOffsetX, s = t.yPosition - o.pie.callout.offsetY, t.direction = _.RIGHT, h.push(t)) : (i = t.xPosition - o.pie.callout.offsetX - t.textOffsetX - o.pie.callout.textMargin, s = t.yPosition - o.pie.callout.offsetY, t.direction = _.LEFT, h.push(t)), "translate(" + i + ", " + s + ")";
      }

      return "translate(" + t.xPosition + ", " + t.yPosition + ")";
    }), this.renderCallouts(h);
    var p = s + o.pie.xOffset,
        d = s + o.pie.yOffset;
    h.length > 0 && (d += o.pie.yOffsetCallout), i.attr("transform", "translate(" + p + ", " + d + ")"), this.addEventListeners();
  }, n.prototype.renderCallouts = function (e) {
    var n = Xg.appendOrSelect(this.getContainerSVG(), "g.callouts").attr("role", t.GROUP),
        r = this.model.getOptions(),
        i = n.selectAll("g.callout").data(e);
    i.exit().remove();
    var o = i.enter().append("g").classed("callout", !0).attr("role", t.GRAPHICS_SYMBOL + " " + t.GROUP).attr("aria-roledescription", "label callout");
    o.merge(i).datum(function (t) {
      var e = t.xPosition,
          n = t.yPosition;
      return t.direction === _.RIGHT ? (t.startPos = {
        x: e,
        y: n + t.textOffsetY
      }, t.endPos = {
        x: e + r.pie.callout.offsetX,
        y: n - r.pie.callout.offsetY + t.textOffsetY
      }, t.intersectPointX = t.endPos.x - r.pie.callout.horizontalLineLength) : (t.startPos = {
        x: e,
        y: n + t.textOffsetY
      }, t.endPos = {
        x: e - r.pie.callout.offsetX,
        y: n - r.pie.callout.offsetY + t.textOffsetY
      }, t.intersectPointX = t.endPos.x + r.pie.callout.horizontalLineLength), t;
    }), o.append("line").classed("vertical-line", !0).merge(n.selectAll("line.vertical-line")).datum(function (t) {
      return wg(this.parentNode).datum();
    }).style("stroke-width", "1px").attr("x1", function (t) {
      return t.startPos.x;
    }).attr("y1", function (t) {
      return t.startPos.y;
    }).attr("x2", function (t) {
      return t.intersectPointX;
    }).attr("y2", function (t) {
      return t.endPos.y;
    }), o.append("line").classed("horizontal-line", !0).merge(i.selectAll("line.horizontal-line")).datum(function (t) {
      return wg(this.parentNode).datum();
    }).style("stroke-width", "1px").attr("x1", function (t) {
      return t.intersectPointX;
    }).attr("y1", function (t) {
      return t.endPos.y;
    }).attr("x2", function (t) {
      return t.endPos.x;
    }).attr("y2", function (t) {
      return t.endPos.y;
    });
  }, n.prototype.addEventListeners = function () {
    var t = this;
    this.parent.selectAll("path.slice").on("mouseover", function (e) {
      t.services.events.dispatchEvent(m.Pie.SLICE_MOUSEOVER, {
        element: wg(this),
        datum: e
      });
    }).on("mousemove", function (e) {
      var n = wg(this);
      n.classed("hovered", !0).transition(t.services.transitions.getTransition("pie_slice_mouseover")).attr("d", t.hoverArc), t.services.events.dispatchEvent(m.Pie.SLICE_MOUSEMOVE, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("show-tooltip", {
        hoveredElement: n,
        type: p.DATAPOINT
      });
    }).on("click", function (e) {
      t.services.events.dispatchEvent(m.Pie.SLICE_CLICK, {
        element: wg(this),
        datum: e
      });
    }).on("mouseout", function (e) {
      var n = wg(this);
      n.classed("hovered", !1).transition(t.services.transitions.getTransition("pie_slice_mouseover")).attr("d", t.arc), t.services.events.dispatchEvent(m.Pie.SLICE_MOUSEOUT, {
        element: n,
        datum: e
      }), t.services.events.dispatchEvent("hide-tooltip", {
        hoveredElement: n
      });
    });
  }, n.prototype.computeRadius = function () {
    var t = this.model.getOptions(),
        e = Xg.getSVGElementSize(this.parent, {
      useAttrs: !0
    }),
        n = e.width,
        r = e.height;
    return Math.min(n, r) / 2 + t.pie.radiusOffset;
  }, n;
}(eb),
    _b = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.type = "donut", e;
  }

  return a(e, t), e.prototype.render = function (e) {
    void 0 === e && (e = !0), t.prototype.render.call(this, e);
    var n = this,
        r = Xg.appendOrSelect(this.getContainerSVG(), "g.center"),
        i = this.model.getOptions(),
        o = this.computeRadius();
    Xg.appendOrSelect(r, "text.donut-figure").attr("text-anchor", "middle").style("font-size", function () {
      return i.donut.center.numberFontSize(o);
    }).transition(this.services.transitions.getTransition("donut-figure-enter-update", e)).tween("text", function () {
      return n.centerNumberTween(wg(this));
    }), Xg.appendOrSelect(r, "text.donut-title").attr("text-anchor", "middle").style("font-size", function () {
      return i.donut.center.titleFontSize(o);
    }).attr("y", i.donut.center.titleYPosition(o)).text(Tl.getProperty(i, "donut", "center", "label"));
  }, e.prototype.getInnerRadius = function () {
    return .75 * this.computeRadius();
  }, e.prototype.centerNumberTween = function (t) {
    var e = this.model.getOptions(),
        n = Tl.getProperty(e, "donut", "center", "number");
    n || (n = this.getDataList().reduce(function (t, e) {
      return t + e.value;
    }, 0));
    var r = Mh(parseInt(t.text().replace(/[, ]+/g, ""), 10) || 0, n);
    return function (n) {
      var i = e.donut.center.numberFormatter;
      t.text(i(r(n)));
    };
  }, e;
}(yb),
    mb = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.type = "spacer", e;
  }

  return a(e, t), e.prototype.render = function () {
    this.getContainerSVG().append("rect").attr("x", 0).attr("y", 0).attr("width", this.configs.size || Kl["default"].size).attr("height", this.configs.size || Kl["default"].size).attr("opacity", 0);
  }, e;
}(eb);

function bb(t) {
  var e = 0,
      n = t.children,
      r = n && n.length;
  if (r) for (; --r >= 0;) {
    e += n[r].value;
  } else e = 1;
  t.value = e;
}

function xb(t, e) {
  var n,
      r,
      i,
      o,
      a,
      s = new Tb(t),
      u = +t.value && (s.value = t.value),
      c = [s];

  for (null == e && (e = wb); n = c.pop();) {
    if (u && (n.value = +n.data.value), (i = e(n.data)) && (a = i.length)) for (n.children = new Array(a), o = a - 1; o >= 0; --o) {
      c.push(r = n.children[o] = new Tb(i[o])), r.parent = n, r.depth = n.depth + 1;
    }
  }

  return s.eachBefore(Eb);
}

function wb(t) {
  return t.children;
}

function Ob(t) {
  t.data = t.data.data;
}

function Eb(t) {
  var e = 0;

  do {
    t.height = e;
  } while ((t = t.parent) && t.height < ++e);
}

function Tb(t) {
  this.data = t, this.depth = this.height = 0, this.parent = null;
}

function Sb(t) {
  if ("function" != typeof t) throw new Error();
  return t;
}

function Mb() {
  return 0;
}

function Ab(t) {
  return function () {
    return t;
  };
}

function kb(t) {
  t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
}

function Lb(t, e, n, r, i) {
  for (var o, a = t.children, s = -1, u = a.length, c = t.value && (r - e) / t.value; ++s < u;) {
    (o = a[s]).y0 = n, o.y1 = i, o.x0 = e, o.x1 = e += o.value * c;
  }
}

function Cb(t, e, n, r, i) {
  for (var o, a = t.children, s = -1, u = a.length, c = t.value && (i - n) / t.value; ++s < u;) {
    (o = a[s]).x0 = e, o.x1 = r, o.y0 = n, o.y1 = n += o.value * c;
  }
}

Tb.prototype = xb.prototype = {
  constructor: Tb,
  count: function count() {
    return this.eachAfter(bb);
  },
  each: function each(t) {
    var e,
        n,
        r,
        i,
        o = this,
        a = [o];

    do {
      for (e = a.reverse(), a = []; o = e.pop();) {
        if (t(o), n = o.children) for (r = 0, i = n.length; r < i; ++r) {
          a.push(n[r]);
        }
      }
    } while (a.length);

    return this;
  },
  eachAfter: function eachAfter(t) {
    for (var e, n, r, i = this, o = [i], a = []; i = o.pop();) {
      if (a.push(i), e = i.children) for (n = 0, r = e.length; n < r; ++n) {
        o.push(e[n]);
      }
    }

    for (; i = a.pop();) {
      t(i);
    }

    return this;
  },
  eachBefore: function eachBefore(t) {
    for (var e, n, r = this, i = [r]; r = i.pop();) {
      if (t(r), e = r.children) for (n = e.length - 1; n >= 0; --n) {
        i.push(e[n]);
      }
    }

    return this;
  },
  sum: function sum(t) {
    return this.eachAfter(function (e) {
      for (var n = +t(e.data) || 0, r = e.children, i = r && r.length; --i >= 0;) {
        n += r[i].value;
      }

      e.value = n;
    });
  },
  sort: function sort(t) {
    return this.eachBefore(function (e) {
      e.children && e.children.sort(t);
    });
  },
  path: function path(t) {
    for (var e = this, n = function (t, e) {
      if (t === e) return t;
      var n = t.ancestors(),
          r = e.ancestors(),
          i = null;
      t = n.pop(), e = r.pop();

      for (; t === e;) {
        i = t, t = n.pop(), e = r.pop();
      }

      return i;
    }(e, t), r = [e]; e !== n;) {
      e = e.parent, r.push(e);
    }

    for (var i = r.length; t !== n;) {
      r.splice(i, 0, t), t = t.parent;
    }

    return r;
  },
  ancestors: function ancestors() {
    for (var t = this, e = [t]; t = t.parent;) {
      e.push(t);
    }

    return e;
  },
  descendants: function descendants() {
    var t = [];
    return this.each(function (e) {
      t.push(e);
    }), t;
  },
  leaves: function leaves() {
    var t = [];
    return this.eachBefore(function (e) {
      e.children || t.push(e);
    }), t;
  },
  links: function links() {
    var t = this,
        e = [];
    return t.each(function (n) {
      n !== t && e.push({
        source: n.parent,
        target: n
      });
    }), e;
  },
  copy: function copy() {
    return xb(this).eachBefore(Ob);
  }
};

var Rb = function t(e) {
  function n(t, n, r, i, o) {
    !function (t, e, n, r, i, o) {
      for (var a, s, u, c, l, f, h, p, d, v, g, y = [], _ = e.children, m = 0, b = 0, x = _.length, w = e.value; m < x;) {
        u = i - n, c = o - r;

        do {
          l = _[b++].value;
        } while (!l && b < x);

        for (f = h = l, g = l * l * (v = Math.max(c / u, u / c) / (w * t)), d = Math.max(h / g, g / f); b < x; ++b) {
          if (l += s = _[b].value, s < f && (f = s), s > h && (h = s), g = l * l * v, (p = Math.max(h / g, g / f)) > d) {
            l -= s;
            break;
          }

          d = p;
        }

        y.push(a = {
          value: l,
          dice: u < c,
          children: _.slice(m, b)
        }), a.dice ? Lb(a, n, r, i, w ? r += c * l / w : o) : Cb(a, n, r, w ? n += u * l / w : i, o), w -= l, m = b;
      }
    }(e, t, n, r, i, o);
  }

  return n.ratio = function (e) {
    return t((e = +e) > 1 ? e : 1);
  }, n;
}((1 + Math.sqrt(5)) / 2);

function jb() {
  var t = Rb,
      e = !1,
      n = 1,
      r = 1,
      i = [0],
      o = Mb,
      a = Mb,
      s = Mb,
      u = Mb,
      c = Mb;

  function l(t) {
    return t.x0 = t.y0 = 0, t.x1 = n, t.y1 = r, t.eachBefore(f), i = [0], e && t.eachBefore(kb), t;
  }

  function f(e) {
    var n = i[e.depth],
        r = e.x0 + n,
        l = e.y0 + n,
        f = e.x1 - n,
        h = e.y1 - n;
    f < r && (r = f = (r + f) / 2), h < l && (l = h = (l + h) / 2), e.x0 = r, e.y0 = l, e.x1 = f, e.y1 = h, e.children && (n = i[e.depth + 1] = o(e) / 2, r += c(e) - n, l += a(e) - n, (f -= s(e) - n) < r && (r = f = (r + f) / 2), (h -= u(e) - n) < l && (l = h = (l + h) / 2), t(e, r, l, f, h));
  }

  return l.round = function (t) {
    return arguments.length ? (e = !!t, l) : e;
  }, l.size = function (t) {
    return arguments.length ? (n = +t[0], r = +t[1], l) : [n, r];
  }, l.tile = function (e) {
    return arguments.length ? (t = Sb(e), l) : t;
  }, l.padding = function (t) {
    return arguments.length ? l.paddingInner(t).paddingOuter(t) : l.paddingInner();
  }, l.paddingInner = function (t) {
    return arguments.length ? (o = "function" == typeof t ? t : Ab(+t), l) : o;
  }, l.paddingOuter = function (t) {
    return arguments.length ? l.paddingTop(t).paddingRight(t).paddingBottom(t).paddingLeft(t) : l.paddingTop();
  }, l.paddingTop = function (t) {
    return arguments.length ? (a = "function" == typeof t ? t : Ab(+t), l) : a;
  }, l.paddingRight = function (t) {
    return arguments.length ? (s = "function" == typeof t ? t : Ab(+t), l) : s;
  }, l.paddingBottom = function (t) {
    return arguments.length ? (u = "function" == typeof t ? t : Ab(+t), l) : u;
  }, l.paddingLeft = function (t) {
    return arguments.length ? (c = "function" == typeof t ? t : Ab(+t), l) : c;
  }, l;
}

var Pb = function (t) {
  function e(n, r, i, o) {
    var a = t.call(this, n, r, o) || this;
    return a.type = "layout", a.configs = o, a.children = i, a._instanceID = e.instanceID++, (a.configs.direction === g.ROW_REVERSE || a.configs.direction === g.COLUMN_REVERSE) && (a.children = a.children.reverse()), a.init(), a;
  }

  return a(e, t), e.prototype.init = function () {
    this.children.forEach(function (t) {
      t.components.forEach(function (t) {
        t.init();
      });
    });
  }, e.prototype.getPreferedAndFixedSizeSum = function () {
    var t = this.parent,
        e = 0;
    return t.selectAll("svg.layout-child-" + this._instanceID).filter(function (t) {
      var e = Tl.getProperty(t, "data", "growth", "x");
      return e === y.PREFERRED || e === y.FIXED;
    }).each(function (t) {
      e += t.data.size;
    }), e;
  }, e.prototype.getNumOfStretchChildren = function () {
    return this.parent.selectAll("svg.layout-child-" + this._instanceID).filter(function (t) {
      return Tl.getProperty(t, "data", "growth", "x") === y.STRETCH;
    }).size();
  }, e.prototype.render = function (t) {
    var e = this;
    void 0 === t && (t = !0);
    var n = this.parent,
        r = Xg.getSVGElementSize(n, {
      useAttrs: !0
    }),
        i = r.width,
        o = r.height,
        a = xb({
      children: this.children
    }).sum(function (t) {
      return t.size;
    }),
        s = this.configs.direction === g.ROW || this.configs.direction === g.ROW_REVERSE ? Lb : Cb;
    jb().tile(s).size([i, o])(a);
    var u = this.configs.direction === g.ROW || this.configs.direction === g.ROW_REVERSE,
        c = n.selectAll("svg.layout-child-" + this._instanceID).data(a.leaves(), function (t) {
      return t.data.id;
    });
    c.attr("width", function (t) {
      return t.x1 - t.x0;
    }).attr("height", function (t) {
      return t.y1 - t.y0;
    }), c.enter().append("svg").attr("class", function (t) {
      return "layout-child layout-child-" + e._instanceID + " " + t.data.id;
    }).attr("x", function (t) {
      return t.x0;
    }).attr("y", function (t) {
      return t.y0;
    }).merge(n.selectAll("svg.layout-child-" + this._instanceID)).each(function (e) {
      var n = this;
      e.data.components.forEach(function (r) {
        r.setParent(wg(n));
        var i = Tl.getProperty(e, "data", "growth", "x");
        i !== y.PREFERRED && i !== y.FIXED || r.render(t);
      });
    }), n.selectAll("svg.layout-child-" + this._instanceID).each(function (t) {
      var e = Tl.getProperty(t, "data", "growth", "x"),
          n = Xg.getSVGElementSize(wg(this), {
        useBBox: !0
      });

      if (e === y.PREFERRED) {
        var r = u ? n.width : n.height,
            a = u ? i : o;
        t.data.size = r / a * 100;
      }
    }), c.exit().remove(), this.children.filter(function (t) {
      return Tl.getProperty(t, "growth", "x") === y.STRETCH;
    }).forEach(function (t, n) {
      t.size = (100 - +e.getPreferedAndFixedSizeSum()) / +e.getNumOfStretchChildren();
    }), a = xb({
      children: this.children
    }).sum(function (t) {
      return t.size;
    }), jb().tile(s).size([i, o]).padding(0)(a), n.selectAll("svg.layout-child-" + this._instanceID).data(a.leaves(), function (t) {
      return t.data.id;
    }).attr("x", function (t) {
      return t.x0;
    }).attr("y", function (t) {
      return t.y0;
    }).attr("width", function (t) {
      return t.x1 - t.x0;
    }).attr("height", function (t) {
      return t.y1 - t.y0;
    }).each(function (e, n) {
      e.data.components.forEach(function (n) {
        Tl.getProperty(e, "data", "growth", "x") === y.STRETCH && n.render(t);
      });
    });
  }, e.prototype.setModel = function (e) {
    t.prototype.setModel.call(this, e), this.children.forEach(function (t) {
      t.components.forEach(function (t) {
        return t.setModel(e);
      });
    });
  }, e.prototype.setServices = function (e) {
    t.prototype.setServices.call(this, e), this.children.forEach(function (t) {
      t.components.forEach(function (t) {
        return t.setServices(e);
      });
    });
  }, e.prototype.destroy = function () {
    this.children.forEach(function (t) {
      t.components.forEach(function (t) {
        return t.destroy();
      });
    });
  }, e.instanceID = Math.floor(99999999999 * Math.random()), e;
}(eb),
    Db = Array.prototype.slice;

function Ib(t) {
  return t;
}

function Nb(t) {
  return "translate(" + (t + .5) + ",0)";
}

function Bb(t) {
  return "translate(0," + (t + .5) + ")";
}

function Fb(t) {
  return function (e) {
    return +t(e);
  };
}

function zb(t) {
  var e = Math.max(0, t.bandwidth() - 1) / 2;
  return t.round() && (e = Math.round(e)), function (n) {
    return +t(n) + e;
  };
}

function Vb() {
  return !this.__axis;
}

function Gb(t, e) {
  var n = [],
      r = null,
      i = null,
      o = 6,
      a = 6,
      s = 3,
      u = 1 === t || 4 === t ? -1 : 1,
      c = 4 === t || 2 === t ? "x" : "y",
      l = 1 === t || 3 === t ? Nb : Bb;

  function f(f) {
    var h = null == r ? e.ticks ? e.ticks.apply(e, n) : e.domain() : r,
        p = null == i ? e.tickFormat ? e.tickFormat.apply(e, n) : Ib : i,
        d = Math.max(o, 0) + s,
        v = e.range(),
        g = +v[0] + .5,
        y = +v[v.length - 1] + .5,
        _ = (e.bandwidth ? zb : Fb)(e.copy()),
        m = f.selection ? f.selection() : f,
        b = m.selectAll(".domain").data([null]),
        x = m.selectAll(".tick").data(h, e).order(),
        w = x.exit(),
        O = x.enter().append("g").attr("class", "tick"),
        E = x.select("line"),
        T = x.select("text");

    b = b.merge(b.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), x = x.merge(O), E = E.merge(O.append("line").attr("stroke", "currentColor").attr(c + "2", u * o)), T = T.merge(O.append("text").attr("fill", "currentColor").attr(c, u * d).attr("dy", 1 === t ? "0em" : 3 === t ? "0.71em" : "0.32em")), f !== m && (b = b.transition(f), x = x.transition(f), E = E.transition(f), T = T.transition(f), w = w.transition(f).attr("opacity", 1e-6).attr("transform", function (t) {
      return isFinite(t = _(t)) ? l(t) : this.getAttribute("transform");
    }), O.attr("opacity", 1e-6).attr("transform", function (t) {
      var e = this.parentNode.__axis;
      return l(e && isFinite(e = e(t)) ? e : _(t));
    })), w.remove(), b.attr("d", 4 === t || 2 == t ? a ? "M" + u * a + "," + g + "H0.5V" + y + "H" + u * a : "M0.5," + g + "V" + y : a ? "M" + g + "," + u * a + "V0.5H" + y + "V" + u * a : "M" + g + ",0.5H" + y), x.attr("opacity", 1).attr("transform", function (t) {
      return l(_(t));
    }), E.attr(c + "2", u * o), T.attr(c, u * d).text(p), m.filter(Vb).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", 2 === t ? "start" : 4 === t ? "end" : "middle"), m.each(function () {
      this.__axis = _;
    });
  }

  return f.scale = function (t) {
    return arguments.length ? (e = t, f) : e;
  }, f.ticks = function () {
    return n = Db.call(arguments), f;
  }, f.tickArguments = function (t) {
    return arguments.length ? (n = null == t ? [] : Db.call(t), f) : n.slice();
  }, f.tickValues = function (t) {
    return arguments.length ? (r = null == t ? null : Db.call(t), f) : r && r.slice();
  }, f.tickFormat = function (t) {
    return arguments.length ? (i = t, f) : i;
  }, f.tickSize = function (t) {
    return arguments.length ? (o = a = +t, f) : o;
  }, f.tickSizeInner = function (t) {
    return arguments.length ? (o = +t, f) : o;
  }, f.tickSizeOuter = function (t) {
    return arguments.length ? (a = +t, f) : a;
  }, f.tickPadding = function (t) {
    return arguments.length ? (s = +t, f) : s;
  }, f;
}

function Ub(t) {
  return Gb(1, t);
}

function Hb(t) {
  return Gb(2, t);
}

function Wb(t) {
  return Gb(3, t);
}

function qb(t) {
  return Gb(4, t);
}

var Yb = function (e) {
  function n(t, n, r) {
    var i = e.call(this, t, n, r) || this;
    return i.type = "axes", r && (i.configs = r), i.margins = i.configs.margins, i;
  }

  return a(n, e), n.prototype.render = function (e) {
    void 0 === e && (e = !0);
    var n,
        r,
        i = this.configs.position,
        o = this.model.getOptions(),
        a = Tl.getProperty(o, "axes", i),
        s = this.getContainerSVG(),
        c = Xg.getSVGElementSize(this.parent, {
      useAttrs: !0
    }),
        l = c.width,
        h = c.height;
    i === u.BOTTOM || i === u.TOP ? (n = this.configs.axes[u.LEFT] ? this.margins.left : 0, r = this.configs.axes[u.RIGHT] ? l - this.margins.right : l) : (n = h - this.margins.bottom, r = this.margins.top);
    var p,
        d = this.services.cartesianScales.getScaleByPosition(i);

    switch (this.scaleType === f.LABELS ? d.rangeRound([n, r]) : d.range([n, r]), i) {
      case u.LEFT:
        p = qb;
        break;

      case u.BOTTOM:
        p = Wb;
        break;

      case u.RIGHT:
        p = Hb;
        break;

      case u.TOP:
        p = Ub;
    }

    if (this.scaleType === f.TIME) {
      var v = Tl.getProperty(o, "locale", "time");
      v && sv(v);
    }

    var g = p(d).tickSizeOuter(0).tickFormat(Tl.getProperty(a, "ticks", "formatter"));

    if (d.ticks) {
      var y = Tl.getProperty(a, "ticks", "number") || Zl.ticks.number;

      if (g.ticks(y), this.scaleType === f.TIME) {
        var _ = d.ticks(y).concat(d.domain()).map(function (t) {
          return +t;
        }).sort();

        _ = Tl.removeArrayDuplicates(_), Tl.getProperty(o, "timeScale", "addSpaceOnEdges") && _.length > 2 && (_.splice(_.length - 1, 1), _.splice(0, 1)), g.tickValues(_);
      }
    }

    var m = Xg.appendOrSelect(s, "g.axis." + i),
        b = !m.select("g.ticks").empty(),
        x = Xg.appendOrSelect(m, "g.ticks");
    b || x.attr("role", t.GRAPHICS_OBJECT + " " + t.GROUP);
    var w = Xg.appendOrSelect(m, "g.ticks.invisible").style("opacity", "0").attr("aria-hidden", !0);

    switch (i) {
      case u.LEFT:
        x.attr("transform", "translate(" + this.margins.left + ", 0)");
        break;

      case u.BOTTOM:
        x.attr("transform", "translate(0, " + (h - this.margins.bottom) + ")");
        break;

      case u.RIGHT:
        x.attr("transform", "translate(" + (l - this.margins.right) + ", 0)");
        break;

      case u.TOP:
        x.attr("transform", "translate(0, " + this.margins.top + ")");
    }

    if (a.title) {
      var O = Xg.appendOrSelect(m, "text.axis-title").text(a.title);

      switch (i) {
        case u.LEFT:
          O.attr("transform", "rotate(-90)").attr("y", 0).attr("x", -d.range()[0] / 2).attr("dy", "1em").style("text-anchor", "middle");
          break;

        case u.BOTTOM:
          O.attr("transform", "translate(" + (this.margins.left / 2 + d.range()[1] / 2) + ", " + h + ")").style("text-anchor", "middle");
          break;

        case u.RIGHT:
          O.attr("transform", "rotate(90)").attr("y", -l).attr("x", d.range()[0] / 2).attr("dy", "1em").style("text-anchor", "middle");
          break;

        case u.TOP:
          var E = Xg.getSVGElementSize(O, {
            useBBox: !0
          }).height;
          O.attr("transform", "translate(" + (this.margins.left / 2 + d.range()[1] / 2) + ", " + E / 2 + ")").style("text-anchor", "middle");
      }
    }

    if (x = e && b ? x.transition(this.services.transitions.getTransition("axis-update")).call(g) : x.call(g), w.call(g), i === u.BOTTOM || i === u.TOP) {
      var T = !1;

      if (d.step) {
        T = w.selectAll("g.tick text").nodes().some(function (t) {
          return Xg.getSVGElementSize(t, {
            useBBox: !0
          }).width >= d.step();
        });
      } else {
        var S = Tl.getProperty(a, "ticks", "rotateIfSmallerThan") || Zl.ticks.rotateIfSmallerThan;
        T = l / d.ticks().length / 2 < S;
      }

      T ? m.selectAll("g.ticks g.tick text").attr("transform", "rotate(45)").style("text-anchor", i === u.TOP ? "end" : "start") : m.selectAll("g.ticks g.tick text").attr("transform", null).style("text-anchor", null);
    }
  }, n.prototype.getInvisibleAxisRef = function () {
    var t = this.configs.position;
    return this.getContainerSVG().select("g.axis." + t + " g.ticks.invisible");
  }, n.prototype.getTitleRef = function () {
    var t = this.configs.position;
    return this.getContainerSVG().select("g.axis." + t + " text.axis-title");
  }, n;
}(eb),
    Xb = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.type = "2D-axes", e.children = {}, e.margins = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, e;
  }

  return a(e, t), e.prototype.render = function (t) {
    var e = this;
    void 0 === t && (t = !1);
    var n = {},
        r = Object.keys(u),
        i = Tl.getProperty(this.model.getOptions(), "axes");
    i ? r.forEach(function (t) {
      var e = i[u[t]];
      e && (n[u[t]] = !0, !0 === e.primary || e.secondary);
    }) : (this.model.getOptions().axes = {
      left: {
        primary: !0
      },
      bottom: {
        secondary: !0,
        type: this.model.getDisplayData().labels ? f.LABELS : void 0
      }
    }, n[u.LEFT] = !0, n[u.BOTTOM] = !0), this.configs.axes = n, r.forEach(function (t) {
      var n = u[t];

      if (e.configs.axes[n] && !e.children[n]) {
        var r = new Yb(e.model, e.services, {
          position: n,
          axes: e.configs.axes,
          margins: e.margins
        });
        r.setModel(e.model), r.setServices(e.services), r.setParent(e.parent), e.children[n] = r;
      }
    }), Object.keys(this.children).forEach(function (n) {
      e.children[n].render(t);
    });
    var o = {};
    Object.keys(this.children).forEach(function (t) {
      var n,
          r = e.children[t],
          i = r.configs.position,
          a = r.getInvisibleAxisRef(),
          s = Xg.getSVGElementSize(a, {
        useBBox: !0
      }),
          c = s.width,
          l = s.height;

      switch (n = r.getTitleRef().empty() ? 0 : Xg.getSVGElementSize(r.getTitleRef(), {
        useBBox: !0
      }).height, i) {
        case u.TOP:
          o.top = l + n;
          break;

        case u.BOTTOM:
          o.bottom = l + n;
          break;

        case u.LEFT:
          o.left = c + n;
          break;

        case u.RIGHT:
          o.right = c + n;
      }
    }), Object.keys(o).some(function (t) {
      return e.margins[t] !== o[t];
    }) && (this.margins = Object.assign(this.margins, o), Object.keys(this.children).forEach(function (t) {
      e.children[t].margins = e.margins;
    }), this.render(!0));
  }, e;
}(eb),
    $b = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.type = "grid", e;
  }

  return a(e, t), e.prototype.render = function () {
    this.drawBackdrop(), Xg.appendOrSelect(this.backdrop, "g.x.grid"), Xg.appendOrSelect(this.backdrop, "g.y.grid"), this.drawXGrid(), this.drawYGrid(), Tl.getProperty(this.model.getOptions(), "tooltip", "gridline", "enabled") && this.addGridEventListeners();
  }, e.prototype.drawXGrid = function () {
    var t = this.parent,
        e = this.backdrop.attr("height"),
        n = Wb(this.services.cartesianScales.getMainXScale()).tickSizeInner(-e).tickSizeOuter(0),
        r = Tl.getProperty(this.model.getOptions(), "grid", "x", "numberOfTicks");
    n.ticks(r);
    var i = t.select(".x.grid").attr("transform", "translate(" + -this.backdrop.attr("x") + ", " + e + ")").call(n);
    this.cleanGrid(i);
  }, e.prototype.drawYGrid = function () {
    var t = this.parent,
        e = this.backdrop.attr("width"),
        n = qb(this.services.cartesianScales.getMainYScale()).tickSizeInner(-e).tickSizeOuter(0),
        r = Tl.getProperty(this.model.getOptions(), "grid", "y", "numberOfTicks");
    n.ticks(r);
    var i = t.select(".y.grid").attr("transform", "translate(0, " + -this.backdrop.attr("y") + ")").call(n);
    this.cleanGrid(i);
  }, e.prototype.getGridlineThreshold = function (t) {
    var e,
        n = this.parent,
        r = n.selectAll(".x.grid .tick").nodes().sort(function (t, e) {
      return Number(Tl.getTranslationValues(t).tx) - Number(Tl.getTranslationValues(e).tx);
    }),
        i = -1;
    r.forEach(function (e, n) {
      t[0] >= +Tl.getTranslationValues(e).tx && i++;
    }), e = i + 1 < r.length ? i + 1 : r.length;
    var o,
        a = r[i],
        s = r[e];
    if (a) {
      if (s) o = +Tl.getTranslationValues(s).tx - +Tl.getTranslationValues(a).tx;else {
        var u = n.select("rect.chart-grid-backdrop").node();
        o = Xg.getSVGElementSize(u).width - +Tl.getTranslationValues(a).tx;
      }
    } else o = +Tl.getTranslationValues(s).tx;
    return o * this.model.getOptions().tooltip.gridline.threshold;
  }, e.prototype.getActiveGridline = function (t) {
    var e = Tl.getProperty(this.model.getOptions, "tooltip", "gridline", "threshold") ? Tl.getProperty(this.model.getOptions, "tooltip", "gridline", "threshold") : this.getGridlineThreshold(t);
    return this.parent.selectAll(".x.grid .tick").filter(function () {
      var n = Tl.getTranslationValues(this),
          r = Number(n.tx) - e,
          i = Number(n.tx) + e;
      return r <= t[0] && t[0] <= i;
    });
  }, e.prototype.addGridEventListeners = function () {
    var t = this,
        e = this.parent;
    Xg.appendOrSelect(e, "rect.chart-grid-backdrop").on("mousemove mouseover", function () {
      var n = Eg(t.services.domUtils.getMainSVG()),
          r = wg(this);
      e.selectAll(".x.grid .tick").classed("active", !1);
      var i,
          o = t.getActiveGridline(n);
      o.empty() ? t.services.events.dispatchEvent("hide-tooltip", {}) : (o.classed("active", !0), o.each(function (e) {
        i = t.services.cartesianScales.getDataFromDomain(e);
      }), t.services.events.dispatchEvent("show-tooltip", {
        hoveredElement: r,
        multidata: i,
        type: p.GRIDLINE
      }));
    }).on("mouseout", function () {
      e.selectAll(".x.grid .tick").classed("active", !1), t.services.events.dispatchEvent("hide-tooltip", {});
    });
  }, e.prototype.drawBackdrop = function () {
    var t = this.parent,
        e = this.services.cartesianScales.getMainXScale(),
        n = this.services.cartesianScales.getMainYScale(),
        r = e.range(),
        i = r[0],
        o = r[1],
        a = n.range(),
        s = a[0],
        u = a[1];
    this.backdrop = Xg.appendOrSelect(t, "svg.chart-grid-backdrop");
    var c = Xg.appendOrSelect(this.backdrop, "rect.chart-grid-backdrop");
    this.backdrop.merge(c).attr("x", i).attr("y", u).attr("width", o - i).attr("height", s - u).lower(), c.attr("width", "100%").attr("height", "100%");
  }, e.prototype.cleanGrid = function (t) {
    var e = this.model.getOptions();
    t.selectAll("line").attr("stroke", e.grid.strokeColor), t.selectAll("text").remove(), t.select(".domain").remove();
  }, e;
}(eb),
    Zb = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.type = "zero-line", e;
  }

  return a(e, t), e.prototype.render = function (t) {
    var e = this.getContainerSVG(),
        n = this.services.cartesianScales.getDomainScale().range(),
        r = n[0],
        i = n[1],
        o = +this.services.cartesianScales.getRangeValue(0) + .5,
        a = Tl.flipSVGCoordinatesBasedOnOrientation({
      x0: r,
      x1: i,
      y0: o,
      y1: o
    }, this.services.cartesianScales.getOrientation());
    Xg.appendOrSelect(e, "line.domain").transition(this.services.transitions.getTransition("zero-line-update", t)).attr("y1", a.y0).attr("y2", a.y1).attr("x1", a.x0).attr("x2", a.x1);
  }, e;
}(eb),
    Kb = function () {
  function t(t, e) {
    this.services = {
      domUtils: Xg,
      events: $g,
      transitions: o_
    }, this.model = new fv(this.services);
  }

  return t.prototype.init = function (t, e) {
    var n = this;
    this.model.set({
      holder: t
    }, !0), Object.keys(this.services).forEach(function (t) {
      var e = n.services[t];
      n.services[t] = new e(n.model, n.services);
    }), this.services.events.addEventListener("model-update", function () {
      n.update(!0);
    }), this.model.setData(e.data), this.services.events.addEventListener("chart-resize", function () {
      n.update(!1);
    }), this.components = this.getComponents(), this.update();
  }, t.prototype.getComponents = function () {
    return console.error("getComponents() method is not implemented"), null;
  }, t.prototype.update = function (t) {
    var e = this;

    if (void 0 === t && (t = !0), this.components) {
      Object.keys(this.services).forEach(function (t) {
        e.services[t].update();
      }), this.components.forEach(function (e) {
        return e.render(t);
      });
      var n = this.services.transitions.getPendingTransitions(),
          r = Object.keys(n).map(function (t) {
        return n[t].end()["catch"](function (t) {
          return t;
        });
      });
      Promise.all(r).then(function () {
        return e.services.events.dispatchEvent("render-finished");
      });
    }
  }, t.prototype.destroy = function () {
    this.components.forEach(function (t) {
      return t.destroy();
    }), this.services.domUtils.getHolder().remove(), this.model.set({
      destroyed: !0
    }, !0);
  }, t.prototype.getChartComponents = function (t) {
    var e = {
      id: "title",
      components: [new rb(this.model, this.services)],
      growth: {
        x: y.PREFERRED,
        y: y.FIXED
      }
    },
        n = {
      id: "legend",
      components: [new nb(this.model, this.services)],
      growth: {
        x: y.PREFERRED,
        y: y.FIXED
      }
    },
        r = {
      id: "graph-frame",
      components: t,
      growth: {
        x: y.STRETCH,
        y: y.FIXED
      }
    },
        i = !1 !== this.model.getOptions().legend.enabled,
        o = g.COLUMN;

    if (i) {
      var a = Tl.getProperty(this.model.getOptions(), "legend", "position");
      "left" === a ? (o = g.ROW, this.model.getOptions().legend.orientation || (this.model.getOptions().legend.orientation = v.VERTICAL)) : "right" === a ? (o = g.ROW_REVERSE, this.model.getOptions().legend.orientation || (this.model.getOptions().legend.orientation = v.VERTICAL)) : "bottom" === a && (o = g.COLUMN_REVERSE);
    }

    var s = {
      id: "spacer",
      components: [new mb(this.model, this.services)],
      growth: {
        x: y.PREFERRED,
        y: y.FIXED
      }
    },
        u = {
      id: "full-frame",
      components: [new Pb(this.model, this.services, (i ? [n] : []).concat([s, r]), {
        direction: o
      })],
      growth: {
        x: y.STRETCH,
        y: y.FIXED
      }
    },
        c = [];

    if (this.model.getOptions().title) {
      c.push(e);
      var l = {
        id: "spacer",
        components: [new mb(this.model, this.services)],
        growth: {
          x: y.PREFERRED,
          y: y.FIXED
        }
      };
      c.push(l);
    }

    return c.push(u), [new Pb(this.model, this.services, c, {
      direction: g.COLUMN
    })];
  }, t;
}(),
    Jb = function (t) {
  function e(e, n) {
    var r = t.call(this, e, n) || this;
    return r.services = Object.assign(r.services, {
      cartesianScales: M_,
      curves: tb
    }), r;
  }

  return a(e, t), e.prototype.getAxisChartComponents = function (t) {
    var e = {
      id: "title",
      components: [new rb(this.model, this.services)],
      growth: {
        x: y.PREFERRED,
        y: y.FIXED
      }
    },
        n = {
      id: "legend",
      components: [new nb(this.model, this.services)],
      growth: {
        x: y.PREFERRED,
        y: y.FIXED
      }
    },
        r = {
      id: "graph-frame",
      components: t,
      growth: {
        x: y.STRETCH,
        y: y.FIXED
      }
    },
        i = !1 !== this.model.getOptions().legend.enabled,
        o = g.COLUMN;

    if (i) {
      var a = Tl.getProperty(this.model.getOptions(), "legend", "position");
      a === d.LEFT ? (o = g.ROW, this.model.getOptions().legend.orientation || (this.model.getOptions().legend.orientation = v.VERTICAL)) : a === d.RIGHT ? (o = g.ROW_REVERSE, this.model.getOptions().legend.orientation || (this.model.getOptions().legend.orientation = v.VERTICAL)) : a === d.BOTTOM && (o = g.COLUMN_REVERSE);
    }

    var s = {
      id: "spacer",
      components: [new mb(this.model, this.services)],
      growth: {
        x: y.PREFERRED,
        y: y.FIXED
      }
    },
        u = {
      id: "full-frame",
      components: [new Pb(this.model, this.services, (i ? [n] : []).concat([s, r]), {
        direction: o
      })],
      growth: {
        x: y.STRETCH,
        y: y.FIXED
      }
    },
        c = [];

    if (this.model.getOptions().title) {
      c.push(e);
      var l = {
        id: "spacer",
        components: [new mb(this.model, this.services)],
        growth: {
          x: y.PREFERRED,
          y: y.FIXED
        }
      };
      c.push(l);
    }

    return c.push(u), [new Pb(this.model, this.services, c, {
      direction: g.COLUMN
    })];
  }, e;
}(Kb),
    Qb = function (t) {
  function e(e) {
    return t.call(this, e) || this;
  }

  return a(e, t), e.prototype.generateDataLabels = function (t) {
    var e = {};
    return t.labels.forEach(function (t) {
      e[t] = Rl.items.status.ACTIVE;
    }), e;
  }, e.prototype.getDisplayData = function () {
    var t = Rl.items.status.ACTIVE,
        e = this.get("dataLabels");
    if (!this.get("data")) return null;
    var n = Tl.clone(this.get("data")),
        r = n.datasets[0];
    return r.data = r.data.filter(function (r, i) {
      var o = n.labels[i];
      return e[o] === t;
    }), n.labels = n.labels.filter(function (n) {
      return e[n] === t;
    }), n;
  }, e.prototype.setColorScale = function () {
    var t = this.getDisplayData().datasets[0];
    if (t.fillColors) this.colorScale = Uf().range(t.fillColors).domain(this.allDataLabels);else {
      var e = xf;
      this.colorScale = Uf().range(e).domain(this.allDataLabels);
    }
  }, e.prototype.getFillColor = function (t) {
    var e = this.getOptions();
    return e.getFillColor ? e.getFillColor(t) : this.getFillScale()(t);
  }, e.prototype.getStrokeColor = function (t) {
    var e = this.getOptions();
    return e.getStrokeColor ? e.getStrokeColor(t) : this.colorScale(t);
  }, e;
}(fv),
    tx = function (t) {
  function e(e, n) {
    var r = t.call(this, e, n) || this;
    return r.model = new Qb(r.services), r.model.setOptions(Tl.merge(Tl.clone(Yl.simpleBarChart), n.options)), r.init(e, n), r;
  }

  return a(e, t), e.prototype.getComponents = function () {
    var t = [new Xb(this.model, this.services), new $b(this.model, this.services), new fb(this.model, this.services), new Zb(this.model, this.services)],
        e = this.getAxisChartComponents(t);
    return e.push(new ub(this.model, this.services)), e;
  }, e;
}(Jb),
    ex = function (t) {
  function e(e, n) {
    var r = t.call(this, e, n) || this;
    return r.model.setOptions(Tl.merge(Tl.clone(Yl.groupedBarChart), n.options)), r.init(e, n), r;
  }

  return a(e, t), e.prototype.getComponents = function () {
    var t = [new Xb(this.model, this.services), new $b(this.model, this.services), new hb(this.model, this.services), new Zb(this.model, this.services)],
        e = this.getAxisChartComponents(t);
    return e.push(new ub(this.model, this.services)), e;
  }, e;
}(Jb),
    nx = function (t) {
  function e(e, n) {
    var r = t.call(this, e, n) || this;
    return r.model.setOptions(Tl.merge(Tl.clone(Yl.stackedBarChart), n.options)), r.init(e, n), r;
  }

  return a(e, t), e.prototype.getComponents = function () {
    var t = [new Xb(this.model, this.services), new $b(this.model, this.services), new pb(this.model, this.services)],
        e = this.getAxisChartComponents(t);
    return e.push(new ub(this.model, this.services)), e;
  }, e;
}(Jb),
    rx = function (t) {
  function e(e, n) {
    var r = t.call(this, e, n) || this;
    return r.model.setOptions(Tl.merge(Tl.clone(Yl.lineChart), n.options)), r.init(e, n), r;
  }

  return a(e, t), e.prototype.getComponents = function () {
    var t = [new Xb(this.model, this.services), new $b(this.model, this.services), new db(this.model, this.services), new vb(this.model, this.services)],
        e = this.getAxisChartComponents(t);
    return e.push(new cb(this.model, this.services)), e;
  }, e;
}(Jb),
    ix = function (t) {
  function e(e, n) {
    var r = t.call(this, e, n) || this;
    return r.model.setOptions(Tl.merge(Tl.clone(Yl.scatterChart), n.options)), r.init(e, n), r;
  }

  return a(e, t), e.prototype.getComponents = function () {
    var t = [new Xb(this.model, this.services), new $b(this.model, this.services), new vb(this.model, this.services)],
        e = this.getAxisChartComponents(t);
    return e.push(new cb(this.model, this.services)), e;
  }, e;
}(Jb),
    ox = function (t) {
  function e(e) {
    return t.call(this, e) || this;
  }

  return a(e, t), e.prototype.generateDataLabels = function (t) {
    var e = {};
    return t.labels.forEach(function (t) {
      e[t] = Rl.items.status.ACTIVE;
    }), e;
  }, e.prototype.getDisplayData = function () {
    var t = Rl.items.status.ACTIVE,
        e = this.get("dataLabels");
    if (!this.get("data")) return null;
    var n = Tl.clone(this.get("data")),
        r = n.datasets[0];
    return r.data = r.data.filter(function (r, i) {
      var o = n.labels[i];
      return e[o] === t;
    }), n.labels = n.labels.filter(function (n) {
      return e[n] === t;
    }), n;
  }, e.prototype.toggleDataLabel = function (t) {
    var e = Rl.items.status,
        n = e.ACTIVE,
        r = e.DISABLED,
        i = this.get("dataLabels"),
        o = Object.keys(i).some(function (t) {
      return i[t] === r;
    }),
        a = Object.keys(i).filter(function (t) {
      return i[t] === n;
    });
    o ? 1 === a.length && a[0] === t ? Object.keys(i).forEach(function (t) {
      i[t] = n;
    }) : i[t] = i[t] === r ? n : r : Object.keys(i).forEach(function (e) {
      i[e] = e === t ? n : r;
    }), this.set({
      dataLabels: i
    });
  }, e.prototype.setColorScale = function () {
    var t = this.getDisplayData().datasets[0];
    if (t.fillColors) this.colorScale = Uf().range(t.fillColors).domain(this.allDataLabels);else {
      var e = xf;
      this.colorScale = Uf().range(e).domain(this.allDataLabels);
    }
  }, e.prototype.getFillColor = function (t) {
    var e = this.getOptions();
    return e.getFillColor ? e.getFillColor(t) : this.getFillScale()(t);
  }, e.prototype.getStrokeColor = function (t) {
    var e = this.getOptions();
    return e.getStrokeColor ? e.getStrokeColor(t) : this.colorScale(t);
  }, e;
}(fv),
    ax = function (t) {
  function e(e, n, r) {
    void 0 === r && (r = !1);
    var i = t.call(this, e, n) || this;
    return i.model = new ox(i.services), r ? i : (i.model.setOptions(Tl.merge(Tl.clone(Yl.pieChart), n.options)), i.init(e, n), i);
  }

  return a(e, t), e.prototype.getComponents = function () {
    var t = [new yb(this.model, this.services)],
        e = this.getChartComponents(t);
    return e.push(new sb(this.model, this.services)), e;
  }, e;
}(Kb),
    sx = function (t) {
  function e(e, n) {
    var r = t.call(this, e, n, !0) || this;
    return r.model.setOptions(Tl.merge(Tl.clone(Yl.donutChart), n.options)), r.init(e, n), r;
  }

  return a(e, t), e.prototype.getComponents = function () {
    var t = [new _b(this.model, this.services)],
        e = this.getChartComponents(t);
    return e.push(new sb(this.model, this.services)), e;
  }, e;
}(ax),
    ux = xf;

export { sx as DonutChart, ex as GroupedBarChart, rx as LineChart, ax as PieChart, ix as ScatterChart, tx as SimpleBarChart, nx as StackedBarChart, wf as colorPalettes, Jl as configurations, ux as defaultColors, b as interfaces };